/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SAS Online Clinic Backend API
 * SASオンラインクリニックのバックエンドAPI仕様。分割YAML構成で管理し、RedoclyとSpectralで検証します。
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ClinicDepositAccount,
  ClinicDepositAccountCreateRequest,
  ClinicDepositAccountUpdateRequest,
  ClinicDetail,
  ClinicDetailCreateRequest,
  ClinicDetailUpdateRequest,
  ClinicForPatientDetail,
  ClinicListAssignedDoctors200,
  ClinicListClinics200,
  ClinicListClinicsParams,
  ClinicListDoctors200,
  ClinicListForPatients200,
  ClinicListForPatientsParams,
  ClinicProposal,
  ClinicProposalForPatient,
  ClinicProposalProposeRequest,
  ClinicProposalRequestCreate,
  CompanyDashboardGetCpapTreatmentSummaryDistributionParams,
  CompanyDashboardGetExamTreatmentStatusCountsParams,
  CompanyDashboardGetPsgStatusMonthlySnapshotsParams,
  CompanyDetail,
  CompanyDetailCreateRequest,
  CompanyDetailUpdateRequest,
  CompanyListCompanies200,
  CompanyListCompaniesParams,
  CpapPrescription,
  CpapPrescriptionConsentRequest,
  CpapPrescriptionCreateRequest,
  CpapPrescriptionListByPatientParams,
  CpapPrescriptionListResponse,
  CpapPrescriptionPatchRequest,
  CpapTreatmentSummary,
  CpapTreatmentSummaryDistribution,
  CpapTreatmentSummaryUpsertRequest,
  DemoSecureEcho201,
  DemoSecureEchoBody,
  DoctorSelf,
  EquipmentDetail,
  EquipmentDetailUpdateRequest,
  EquipmentListEquipment200,
  EquipmentListEquipmentParams,
  EquipmentShipment,
  EquipmentShipmentCreateRequest,
  ExamTreatmentStatusCounts,
  ExternalClinicListResponse,
  GetExternalClinicsParams,
  HealthNurseListHealthNurses200,
  IdentityUploadCategory,
  InPersonReservationCreateRequest,
  InvoiceCreateRequest,
  InvoiceCreateResponse,
  InvoiceListCandidates200,
  InvoiceListCandidatesParams,
  MediaCookieIssueRequest,
  MeetingJoinRequest,
  MeetingJoinResponse,
  NotificationCreateRequest,
  NotificationCreateResponse,
  NotificationListNotifications200,
  NotificationListNotificationsParams,
  OnlineConsultationReservationCreateRequest,
  OnlineConsultationReservationCreateResponse,
  OrganizationHierarchy,
  OrganizationHierarchyList,
  OrganizationListOrganizations200,
  OrganizationListOrganizationsParams,
  PatientCurrentClinicUpdateRequest,
  PatientDetail,
  PatientDiagnosis,
  PatientDiagnosisCreateRequest,
  PatientGetCheckupHistory200,
  PatientGetCpapTreatmentSummaryHistory200,
  PatientGetPsgStatusHistory200,
  PatientGetTreatmentVisitHistory200,
  PatientHealthNurseAssignments,
  PatientHealthNurseAssignmentsUpdateRequest,
  PatientIdentityUploadCompleteRequest,
  PatientIdentityUrls,
  PatientImportJob,
  PatientImportJobCreateRequest,
  PatientImportJobCreateResponse,
  PatientInvoice,
  PatientListDiagnoses200,
  PatientListDiagnosesParams,
  PatientListInvoices200,
  PatientListInvoicesParams,
  PatientListNotes200,
  PatientListNotesParams,
  PatientListPatients200,
  PatientListPatientsParams,
  PatientListQuestionnaires200,
  PatientListQuestionnairesParams,
  PatientListReferralRequests200,
  PatientLocalId,
  PatientLocalIdUpdateRequest,
  PatientNote,
  PatientNoteCreateRequest,
  PatientProfileUpdateRequest,
  PatientQuestionnaire,
  PatientQuestionnaireCreateRequest,
  PatientQuestionnaireCreateResponse,
  PatientStatusUpdateRequest,
  PatientTestReportDownloadResponse,
  PatientTestReportUploadRequest,
  PaymentCardRetryRequest,
  PaymentCardRetryResponse,
  PaymentCardUpsertRequest,
  PaymentCardUpsertResponse,
  PaymentChannelSwitchRequest,
  PaymentChannelSwitchResponse,
  PaymentCustomerEnsureResponse,
  PaymentHandleGmoCallbackParams,
  PaymentInvoiceCancelRequest,
  PaymentInvoiceCancelResponse,
  PaymentProfileChannelUpdateRequest,
  PaymentProfileChannelUpdateResponse,
  PaymentProfileStatusResponse,
  PaymentWebhookGmoRequest,
  ProblemResponse,
  ProblemResponseResponse,
  PsgStatusMonthlySnapshots,
  ReferralRequest,
  ReferralRequestCreateRequest,
  ReferralRequestUpdateRequest,
  Reservation,
  ReservationCreateRequest,
  ReservationGetLatestPendingDiagnosisByPatient200,
  ReservationListByPatient200,
  ReservationListByPatientParams,
  ReservationListReservations200,
  ReservationListReservationsParams,
  ReservationSlot,
  ReservationSlotBulkUpsert200,
  ReservationSlotBulkUpsertRequest,
  ReservationSlotCreateRequest,
  ReservationSlotList200,
  ReservationSlotListByPatient200,
  ReservationSlotListByPatientParams,
  ReservationSlotListParams,
  ReservationSlotUpdateRequest,
  SmsDeliveryReportRequest,
  SmsHandleCpaasDeliveryReport200,
  Task,
  TaskCreateRequest,
  TaskProgressListByUser200,
  TaskProgressListMe200,
  TaskUpdateRequest,
  TermsOfUseConsentStatus,
  UploadCompleteRequest,
  UploadCompleteResponse,
  UploadInitRequest,
  UploadInitResponse,
  UserProfile,
  UserProfileUpdateRequest
} from './sASOnlineClinicBackendAPI.schemas';

import { http } from '../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type patientGetDetailResponse200 = {
  data: PatientDetail
  status: 200
}

export type patientGetDetailResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientGetDetailResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientGetDetailResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientGetDetailResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientGetDetailResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientGetDetailResponseSuccess = (patientGetDetailResponse200) & {
  headers: Headers;
};
export type patientGetDetailResponseError = (patientGetDetailResponse401 | patientGetDetailResponse403 | patientGetDetailResponse404 | patientGetDetailResponse422 | patientGetDetailResponse500) & {
  headers: Headers;
};

export type patientGetDetailResponse = (patientGetDetailResponseSuccess | patientGetDetailResponseError)

export const getPatientGetDetailUrl = (patientId: string,) => {




  return `/patients/${patientId}/detail`
}

/**
 * 患者IDに対応する詳細情報を返します。
 *
 * 認証済みユーザーのロールがpatient-user（患者）の場合、指定したpatientIdに関わらず、自身の患者情報を返します。
 *
 * 認証済みユーザーのロールがpatient-admin（企業管理者）の場合、同じ組織に所属する患者情報のみ取得可能です。
 *
 * 認証済みユーザーのロールがclinic-doctor（医師）またはclinic-operator（医療事務）の場合、自身の医療機関に通院する患者情報のみ取得可能です。
 *
 * 認証済みユーザーのロールがops-admin（NTTBS管理者）またははops-operator（オペレーター）の場合、全ての患者情報を取得可能です。
 * @summary 患者の詳細情報を取得する
 */
export const patientGetDetail = async (patientId: string, options?: Parameters<typeof http>[1]): Promise<patientGetDetailResponse> => {

  return http<patientGetDetailResponse>(getPatientGetDetailUrl(patientId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPatientGetDetailQueryKey = (patientId: string,) => {
    return [
    `/patients/${patientId}/detail`
    ] as const;
    }


export const getPatientGetDetailQueryOptions = <TData = Awaited<ReturnType<typeof patientGetDetail>>, TError = ProblemResponseResponse>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientGetDetailQueryKey(patientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientGetDetail>>> = ({ signal }) => patientGetDetail(patientId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: patientId !== null && patientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientGetDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientGetDetailQueryResult = NonNullable<Awaited<ReturnType<typeof patientGetDetail>>>
export type PatientGetDetailQueryError = ProblemResponseResponse


export function usePatientGetDetail<TData = Awaited<ReturnType<typeof patientGetDetail>>, TError = ProblemResponseResponse>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetDetail>>,
          TError,
          Awaited<ReturnType<typeof patientGetDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetDetail<TData = Awaited<ReturnType<typeof patientGetDetail>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetDetail>>,
          TError,
          Awaited<ReturnType<typeof patientGetDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetDetail<TData = Awaited<ReturnType<typeof patientGetDetail>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者の詳細情報を取得する
 */

export function usePatientGetDetail<TData = Awaited<ReturnType<typeof patientGetDetail>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientGetDetailQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type patientUpdateProfileResponse200 = {
  data: PatientDetail
  status: 200
}

export type patientUpdateProfileResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type patientUpdateProfileResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientUpdateProfileResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientUpdateProfileResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientUpdateProfileResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientUpdateProfileResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientUpdateProfileResponseSuccess = (patientUpdateProfileResponse200) & {
  headers: Headers;
};
export type patientUpdateProfileResponseError = (patientUpdateProfileResponse400 | patientUpdateProfileResponse401 | patientUpdateProfileResponse403 | patientUpdateProfileResponse404 | patientUpdateProfileResponse422 | patientUpdateProfileResponse500) & {
  headers: Headers;
};

export type patientUpdateProfileResponse = (patientUpdateProfileResponseSuccess | patientUpdateProfileResponseError)

export const getPatientUpdateProfileUrl = (patientId: string,) => {




  return `/patients/${patientId}/detail`
}

/**
 * 患者の氏名/連絡先/住所/所属などのプロフィール情報を部分更新します（指定項目のみ更新）。
 *
 * 認証済みユーザーのロールがpatient-user（患者）の場合、指定したpatientIdに関わらず、自身の患者情報を更新します。
 *
 * 認証済みユーザーのロールがops-admin（NTTBS管理者）またははops-operator（オペレーター）の場合、全ての患者情報を更新可能です。
 *
 * 認証済みユーザーのロールがそれ以外の場合、更新は許可されません。
 * @summary 患者プロフィールを更新する
 */
export const patientUpdateProfile = async (patientId: string,
    patientProfileUpdateRequest: PatientProfileUpdateRequest, options?: Parameters<typeof http>[1]): Promise<patientUpdateProfileResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<patientUpdateProfileResponse>(getPatientUpdateProfileUrl(patientId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patientProfileUpdateRequest)
  }
);}





export const getPatientUpdateProfileMutationKey = () => ['patientUpdateProfile'] as const;

export const getPatientUpdateProfileMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientUpdateProfile>>, TError,PatientUpdateProfileMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof patientUpdateProfile>>, TError,PatientUpdateProfileMutationVariables, TContext> => {

const mutationKey = getPatientUpdateProfileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientUpdateProfile>>, PatientUpdateProfileMutationVariables> = (props) => {
          const {patientId,data} = props ?? {};

          return  patientUpdateProfile(patientId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientUpdateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof patientUpdateProfile>>>
    export type PatientUpdateProfileMutationBody = PatientProfileUpdateRequest
    export type PatientUpdateProfileMutationError = ProblemResponseResponse
    export type PatientUpdateProfileMutationVariables = {patientId: string;data: PatientProfileUpdateRequest}

    /**
 * @summary 患者プロフィールを更新する
 */
export const usePatientUpdateProfile = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientUpdateProfile>>, TError,PatientUpdateProfileMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientUpdateProfile>>,
        TError,
        PatientUpdateProfileMutationVariables,
        TContext
      > => {
      return useMutation(getPatientUpdateProfileMutationOptions(options), queryClient);
    }

export type patientGetHealthNurseAssignmentsResponse200 = {
  data: PatientHealthNurseAssignments
  status: 200
}

export type patientGetHealthNurseAssignmentsResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientGetHealthNurseAssignmentsResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientGetHealthNurseAssignmentsResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientGetHealthNurseAssignmentsResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientGetHealthNurseAssignmentsResponseSuccess = (patientGetHealthNurseAssignmentsResponse200) & {
  headers: Headers;
};
export type patientGetHealthNurseAssignmentsResponseError = (patientGetHealthNurseAssignmentsResponse401 | patientGetHealthNurseAssignmentsResponse403 | patientGetHealthNurseAssignmentsResponse404 | patientGetHealthNurseAssignmentsResponse500) & {
  headers: Headers;
};

export type patientGetHealthNurseAssignmentsResponse = (patientGetHealthNurseAssignmentsResponseSuccess | patientGetHealthNurseAssignmentsResponseError)

export const getPatientGetHealthNurseAssignmentsUrl = (patientId: string,) => {




  return `/patients/${patientId}/health-nurse-assignments`
}

/**
 * 患者IDに対応する従業員の担当保健師の割り付け状況（保健師1〜3の3スロット分）を返します。
 *
 * RBAC:
 * - 許可: patient-admin/health-nurse のみ（対象患者の所属組織が呼び出し元の readable_organization_ids に含まれる場合に限る）
 * @summary 従業員の担当保健師の割り付けを取得する
 */
export const patientGetHealthNurseAssignments = async (patientId: string, options?: Parameters<typeof http>[1]): Promise<patientGetHealthNurseAssignmentsResponse> => {

  return http<patientGetHealthNurseAssignmentsResponse>(getPatientGetHealthNurseAssignmentsUrl(patientId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPatientGetHealthNurseAssignmentsQueryKey = (patientId: string,) => {
    return [
    `/patients/${patientId}/health-nurse-assignments`
    ] as const;
    }


export const getPatientGetHealthNurseAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof patientGetHealthNurseAssignments>>, TError = ProblemResponseResponse>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetHealthNurseAssignments>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientGetHealthNurseAssignmentsQueryKey(patientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientGetHealthNurseAssignments>>> = ({ signal }) => patientGetHealthNurseAssignments(patientId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: patientId !== null && patientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientGetHealthNurseAssignments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientGetHealthNurseAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof patientGetHealthNurseAssignments>>>
export type PatientGetHealthNurseAssignmentsQueryError = ProblemResponseResponse


export function usePatientGetHealthNurseAssignments<TData = Awaited<ReturnType<typeof patientGetHealthNurseAssignments>>, TError = ProblemResponseResponse>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetHealthNurseAssignments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetHealthNurseAssignments>>,
          TError,
          Awaited<ReturnType<typeof patientGetHealthNurseAssignments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetHealthNurseAssignments<TData = Awaited<ReturnType<typeof patientGetHealthNurseAssignments>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetHealthNurseAssignments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetHealthNurseAssignments>>,
          TError,
          Awaited<ReturnType<typeof patientGetHealthNurseAssignments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetHealthNurseAssignments<TData = Awaited<ReturnType<typeof patientGetHealthNurseAssignments>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetHealthNurseAssignments>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 従業員の担当保健師の割り付けを取得する
 */

export function usePatientGetHealthNurseAssignments<TData = Awaited<ReturnType<typeof patientGetHealthNurseAssignments>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetHealthNurseAssignments>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientGetHealthNurseAssignmentsQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type patientUpdateHealthNurseAssignmentsResponse200 = {
  data: PatientHealthNurseAssignments
  status: 200
}

export type patientUpdateHealthNurseAssignmentsResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type patientUpdateHealthNurseAssignmentsResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientUpdateHealthNurseAssignmentsResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientUpdateHealthNurseAssignmentsResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientUpdateHealthNurseAssignmentsResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientUpdateHealthNurseAssignmentsResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientUpdateHealthNurseAssignmentsResponseSuccess = (patientUpdateHealthNurseAssignmentsResponse200) & {
  headers: Headers;
};
export type patientUpdateHealthNurseAssignmentsResponseError = (patientUpdateHealthNurseAssignmentsResponse400 | patientUpdateHealthNurseAssignmentsResponse401 | patientUpdateHealthNurseAssignmentsResponse403 | patientUpdateHealthNurseAssignmentsResponse404 | patientUpdateHealthNurseAssignmentsResponse422 | patientUpdateHealthNurseAssignmentsResponse500) & {
  headers: Headers;
};

export type patientUpdateHealthNurseAssignmentsResponse = (patientUpdateHealthNurseAssignmentsResponseSuccess | patientUpdateHealthNurseAssignmentsResponseError)

export const getPatientUpdateHealthNurseAssignmentsUrl = (patientId: string,) => {




  return `/patients/${patientId}/health-nurse-assignments`
}

/**
 * 患者IDに対応する従業員の担当保健師の割り付け（保健師1〜3の3スロット分）をまとめて一括更新します。
 * 各スロットの healthNurseUserId に null を指定するとそのスロットの割り付けを解除（未設定に）できます。
 *
 * RBAC:
 * - 許可: patient-admin/health-nurse のみ（対象患者の所属組織が呼び出し元の readable_organization_ids に含まれる場合に限る）
 * - 割り付ける healthNurseUserId は、呼び出し元から見える保健師候補（GET /api/health-nurses と同じ組織スコープ）に含まれている必要がある
 * @summary 従業員の担当保健師の割り付けを更新する
 */
export const patientUpdateHealthNurseAssignments = async (patientId: string,
    patientHealthNurseAssignmentsUpdateRequest: PatientHealthNurseAssignmentsUpdateRequest, options?: Parameters<typeof http>[1]): Promise<patientUpdateHealthNurseAssignmentsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<patientUpdateHealthNurseAssignmentsResponse>(getPatientUpdateHealthNurseAssignmentsUrl(patientId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patientHealthNurseAssignmentsUpdateRequest)
  }
);}





export const getPatientUpdateHealthNurseAssignmentsMutationKey = () => ['patientUpdateHealthNurseAssignments'] as const;

export const getPatientUpdateHealthNurseAssignmentsMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientUpdateHealthNurseAssignments>>, TError,PatientUpdateHealthNurseAssignmentsMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof patientUpdateHealthNurseAssignments>>, TError,PatientUpdateHealthNurseAssignmentsMutationVariables, TContext> => {

const mutationKey = getPatientUpdateHealthNurseAssignmentsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientUpdateHealthNurseAssignments>>, PatientUpdateHealthNurseAssignmentsMutationVariables> = (props) => {
          const {patientId,data} = props ?? {};

          return  patientUpdateHealthNurseAssignments(patientId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientUpdateHealthNurseAssignmentsMutationResult = NonNullable<Awaited<ReturnType<typeof patientUpdateHealthNurseAssignments>>>
    export type PatientUpdateHealthNurseAssignmentsMutationBody = PatientHealthNurseAssignmentsUpdateRequest
    export type PatientUpdateHealthNurseAssignmentsMutationError = ProblemResponseResponse
    export type PatientUpdateHealthNurseAssignmentsMutationVariables = {patientId: string;data: PatientHealthNurseAssignmentsUpdateRequest}

    /**
 * @summary 従業員の担当保健師の割り付けを更新する
 */
export const usePatientUpdateHealthNurseAssignments = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientUpdateHealthNurseAssignments>>, TError,PatientUpdateHealthNurseAssignmentsMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientUpdateHealthNurseAssignments>>,
        TError,
        PatientUpdateHealthNurseAssignmentsMutationVariables,
        TContext
      > => {
      return useMutation(getPatientUpdateHealthNurseAssignmentsMutationOptions(options), queryClient);
    }

export type notificationListNotificationsResponse200 = {
  data: NotificationListNotifications200
  status: 200
}

export type notificationListNotificationsResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type notificationListNotificationsResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type notificationListNotificationsResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type notificationListNotificationsResponseSuccess = (notificationListNotificationsResponse200) & {
  headers: Headers;
};
export type notificationListNotificationsResponseError = (notificationListNotificationsResponse401 | notificationListNotificationsResponse403 | notificationListNotificationsResponse500) & {
  headers: Headers;
};

export type notificationListNotificationsResponse = (notificationListNotificationsResponseSuccess | notificationListNotificationsResponseError)

export const getNotificationListNotificationsUrl = (params?: NotificationListNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/notifications?${stringifiedParams}` : `/notifications`
}

/**
 * 認証済みユーザーに対して発行された通知の最新一覧を返します。作成日時の降順で返し、既定では最新5件を返します。
 * @summary 通知一覧を取得する
 */
export const notificationListNotifications = async (params?: NotificationListNotificationsParams, options?: Parameters<typeof http>[1]): Promise<notificationListNotificationsResponse> => {

  return http<notificationListNotificationsResponse>(getNotificationListNotificationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getNotificationListNotificationsQueryKey = (params?: NotificationListNotificationsParams,) => {
    return [
    `/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getNotificationListNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof notificationListNotifications>>, TError = ProblemResponseResponse>(params?: NotificationListNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationListNotifications>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationListNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationListNotifications>>> = ({ signal }) => notificationListNotifications(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationListNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationListNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof notificationListNotifications>>>
export type NotificationListNotificationsQueryError = ProblemResponseResponse


export function useNotificationListNotifications<TData = Awaited<ReturnType<typeof notificationListNotifications>>, TError = ProblemResponseResponse>(
 params: undefined |  NotificationListNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationListNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationListNotifications>>,
          TError,
          Awaited<ReturnType<typeof notificationListNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationListNotifications<TData = Awaited<ReturnType<typeof notificationListNotifications>>, TError = ProblemResponseResponse>(
 params?: NotificationListNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationListNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationListNotifications>>,
          TError,
          Awaited<ReturnType<typeof notificationListNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationListNotifications<TData = Awaited<ReturnType<typeof notificationListNotifications>>, TError = ProblemResponseResponse>(
 params?: NotificationListNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationListNotifications>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 通知一覧を取得する
 */

export function useNotificationListNotifications<TData = Awaited<ReturnType<typeof notificationListNotifications>>, TError = ProblemResponseResponse>(
 params?: NotificationListNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationListNotifications>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationListNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type notificationCreateNotificationResponse201 = {
  data: NotificationCreateResponse
  status: 201
}

export type notificationCreateNotificationResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type notificationCreateNotificationResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type notificationCreateNotificationResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type notificationCreateNotificationResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type notificationCreateNotificationResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type notificationCreateNotificationResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type notificationCreateNotificationResponseSuccess = (notificationCreateNotificationResponse201) & {
  headers: Headers;
};
export type notificationCreateNotificationResponseError = (notificationCreateNotificationResponse400 | notificationCreateNotificationResponse401 | notificationCreateNotificationResponse403 | notificationCreateNotificationResponse409 | notificationCreateNotificationResponse422 | notificationCreateNotificationResponse500) & {
  headers: Headers;
};

export type notificationCreateNotificationResponse = (notificationCreateNotificationResponseSuccess | notificationCreateNotificationResponseError)

export const getNotificationCreateNotificationUrl = () => {




  return `/notifications`
}

/**
 * 通知と配信対象ユーザーを登録し、作成された通知情報を返します。
 * @summary 通知を登録する
 */
export const notificationCreateNotification = async (notificationCreateRequest: NotificationCreateRequest, options?: Parameters<typeof http>[1]): Promise<notificationCreateNotificationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<notificationCreateNotificationResponse>(getNotificationCreateNotificationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(notificationCreateRequest)
  }
);}





export const getNotificationCreateNotificationMutationKey = () => ['notificationCreateNotification'] as const;

export const getNotificationCreateNotificationMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationCreateNotification>>, TError,NotificationCreateNotificationMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationCreateNotification>>, TError,NotificationCreateNotificationMutationVariables, TContext> => {

const mutationKey = getNotificationCreateNotificationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationCreateNotification>>, NotificationCreateNotificationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  notificationCreateNotification(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotificationCreateNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof notificationCreateNotification>>>
    export type NotificationCreateNotificationMutationBody = NotificationCreateRequest
    export type NotificationCreateNotificationMutationError = ProblemResponseResponse
    export type NotificationCreateNotificationMutationVariables = {data: NotificationCreateRequest}

    /**
 * @summary 通知を登録する
 */
export const useNotificationCreateNotification = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationCreateNotification>>, TError,NotificationCreateNotificationMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationCreateNotification>>,
        TError,
        NotificationCreateNotificationMutationVariables,
        TContext
      > => {
      return useMutation(getNotificationCreateNotificationMutationOptions(options), queryClient);
    }

export type demoSecureEchoResponse201 = {
  data: DemoSecureEcho201
  status: 201
}

export type demoSecureEchoResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type demoSecureEchoResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type demoSecureEchoResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type demoSecureEchoResponseSuccess = (demoSecureEchoResponse201) & {
  headers: Headers;
};
export type demoSecureEchoResponseError = (demoSecureEchoResponse401 | demoSecureEchoResponse403 | demoSecureEchoResponse422) & {
  headers: Headers;
};

export type demoSecureEchoResponse = (demoSecureEchoResponseSuccess | demoSecureEchoResponseError)

export const getDemoSecureEchoUrl = () => {




  return `/demo/secure-echo`
}

/**
 * Cognitoで認証されたユーザーのみが呼び出せる保護付きPOST。入力の`message`をそのまま返し、作成IDと作成時刻を付与します。
 * @summary 認証済みでメッセージをエコーする
 */
export const demoSecureEcho = async (demoSecureEchoBody: DemoSecureEchoBody, options?: Parameters<typeof http>[1]): Promise<demoSecureEchoResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<demoSecureEchoResponse>(getDemoSecureEchoUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(demoSecureEchoBody)
  }
);}





export const getDemoSecureEchoMutationKey = () => ['demoSecureEcho'] as const;

export const getDemoSecureEchoMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof demoSecureEcho>>, TError,DemoSecureEchoMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof demoSecureEcho>>, TError,DemoSecureEchoMutationVariables, TContext> => {

const mutationKey = getDemoSecureEchoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof demoSecureEcho>>, DemoSecureEchoMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  demoSecureEcho(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DemoSecureEchoMutationResult = NonNullable<Awaited<ReturnType<typeof demoSecureEcho>>>
    export type DemoSecureEchoMutationBody = DemoSecureEchoBody
    export type DemoSecureEchoMutationError = ProblemResponseResponse
    export type DemoSecureEchoMutationVariables = {data: DemoSecureEchoBody}

    /**
 * @summary 認証済みでメッセージをエコーする
 */
export const useDemoSecureEcho = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof demoSecureEcho>>, TError,DemoSecureEchoMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof demoSecureEcho>>,
        TError,
        DemoSecureEchoMutationVariables,
        TContext
      > => {
      return useMutation(getDemoSecureEchoMutationOptions(options), queryClient);
    }

export type patientListPatientsResponse200 = {
  data: PatientListPatients200
  status: 200
}

export type patientListPatientsResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientListPatientsResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientListPatientsResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientListPatientsResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientListPatientsResponseSuccess = (patientListPatientsResponse200) & {
  headers: Headers;
};
export type patientListPatientsResponseError = (patientListPatientsResponse401 | patientListPatientsResponse403 | patientListPatientsResponse422 | patientListPatientsResponse500) & {
  headers: Headers;
};

export type patientListPatientsResponse = (patientListPatientsResponseSuccess | patientListPatientsResponseError)

export const getPatientListPatientsUrl = (params?: PatientListPatientsParams,) => {
  const normalizedParams = new URLSearchParams();
  const deepObjectEntries: string[] = [];

  Object.entries(params || {}).forEach(([key, value]) => {
    const deepObjectParameters = ["patientOrganization","clinicOrganization"];

    if (typeof value === 'object' && value !== null && !Array.isArray(value) && deepObjectParameters.includes(key)) {
      Object.entries(value).forEach(([subKey, subValue]) => {
        if (subValue !== undefined) {
          deepObjectEntries.push(encodeURIComponent(key) + '[' + encodeURIComponent(subKey) + ']=' + (subValue === null ? 'null' : encodeURIComponent(String(subValue))));
        }
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = [normalizedParams.toString(), deepObjectEntries.join('&')].filter(Boolean).join('&');

  return stringifiedParams.length > 0 ? `/patients?${stringifiedParams}` : `/patients`
}

/**
 * 認証済みユーザーの権限に応じた患者一覧を返します。clinic-doctor/clinic-operator のみアクセス可能で、所属組織にスコープされます（単一グループ前提）。
 * 認証済みユーザーの権限がオペレーターであれば、
 * - organizationをパラメーターで指定しない場合、すべての患者一覧を返します。
 * - organizationをパラメーターで指定した場合、指定された医療機関もしくは企業に所属する患者一覧を返します。
 *
 * 認証済みユーザーの権限が医療機関の場合、
 * - clinicOrganizationの有無に関わらず、自組織に通院する患者一覧を返します。
 * - patientOrganizationをパラメーターで指定した場合、自組織に通院する患者のうち、指定された企業に所属する患者一覧を返します。
 *
 * 認証済みユーザーの権限が企業（patient-admin）の場合、
 * - patientOrganizationの有無に関わらず、自組織に所属する患者一覧を返します。
 * - clinicOrganizationをパラメーターで指定した場合、自組織に所属する患者のうち、指定された医療機関に通院する患者一覧を返します。
 *
 * 例:
 * - オペレーター: 全患者一覧を取得
 *   ```bash
 *   curl -H "Authorization: Bearer <operator-token>" \
 *     "/api/patients?page=0&size=20&sort=createdAt,desc"
 *   ```
 * - オペレーター: 企業でフィルタ（name指定）
 *   ```bash
 *   curl -H "Authorization: Bearer <operator-token>" \
 *     "/api/patients?patientOrganization[name]=さすケア株式会社&page=0&size=20&sort=createdAt,desc"
 *   ```
 * - オペレーター: 医療機関でフィルタ（id指定）
 *   ```bash
 *   curl -H "Authorization: Bearer <operator-token>" \
 *     "/api/patients?clinicOrganization[id]=11111111-2222-3333-4444-555555555555&page=0&size=20&sort=createdAt,desc"
 *   ```
 * - 医療機関権限: 自組織通院の患者一覧
 *   ```bash
 *   curl -H "Authorization: Bearer <clinic-token>" \
 *     "/api/patients?page=0&size=20&sort=createdAt,desc"
 *   ```
 * - 医療機関権限: 指定企業に所属する通院患者のみ（id指定）
 *   ```bash
 *   curl -H "Authorization: Bearer <clinic-token>" \
 *     "/api/patients?patientOrganization[id]=9e4b2a2b-1234-5678-9abc-def012345678&page=0&size=20&sort=createdAt,desc"
 *   ```
 * - 企業権限: 自社所属の患者一覧
 *   ```bash
 *   curl -H "Authorization: Bearer <company-token>" \
 *     "/api/patients?page=0&size=20&sort=createdAt,desc"
 *   ```
 * - 企業権限: 指定医療機関に通院する自社患者のみ（name指定）
 *   ```bash
 *   curl -H "Authorization: Bearer <company-token>" \
 *     "/api/patients?clinicOrganization[name]=さすケアクリニック&page=0&size=20&sort=createdAt,desc"
 *   ```
 *
 * 制限事項:
 * - patient-user は本エンドポイントへアクセスできません（403）。本人の詳細は `/api/patients/{patientId}/detail` を利用してください。
 *
 * RBAC簡易注記:
 * - 許可: `ops-*`, `clinic-*`, `patient-admin`
 * - 禁止: `patient-user`
 *
 * オプションのフリー検索:
 * - nameKana: 患者名（ふりがな）の部分一致検索に使用します。
 * - phoneNumber: 電話番号の部分一致検索に使用します。
 * - patientLocalId: 患者識別番号（医療機関独自の番号）の部分一致検索に使用します。
 * - status: 患者ステータスで絞り込みに使用します。
 * - patientOrganization: 所属企業名の部分一致検索に使用します。
 * - employeeNumber: 従業員番号の部分一致検索に使用します（patient-admin向け一覧でのみ有効）。
 * - pulseResultGrade / pulsePerformedYear / psgResultFinding / cpapTreatmentStatus / currentMonthVisitStatus:
 *   検査結果・受診状況の絞り込みに使用します（patient-admin向け一覧でのみ有効）。
 * - healthNurseUserId: 指定した保健師が担当保健師1〜3のいずれかのスロットに割り付けられている従業員に絞り込みます（patient-admin向け一覧でのみ有効）。
 * - currentMonthAhiMin / currentMonthAhiMax / currentMonthUsageRateMin / currentMonthUsageRateMax /
 *   currentMonthAverageUsageTimeMin / currentMonthAverageUsageTimeMax / previousMonthAhiMin /
 *   previousMonthAhiMax / previousMonthUsageRateMin / previousMonthUsageRateMax /
 *   previousMonthAverageUsageTimeMin / previousMonthAverageUsageTimeMax:
 *   当月/前月のAHI・装着率・平均使用時間の範囲で絞り込みに使用します（patient-admin向け一覧でのみ有効）。
 *   該当する暦月の実績サマリーが無い従業員は、これらのいずれかを指定すると結果から除外されます。
 *
 * ソート仕様:
 * - 許可されるソート列は `createdAt|updatedAt|name|id` のみです。
 * - 方向は `asc|desc` を指定してください。
 * @summary 患者一覧を取得する
 */
export const patientListPatients = async (params?: PatientListPatientsParams, options?: Parameters<typeof http>[1]): Promise<patientListPatientsResponse> => {

  return http<patientListPatientsResponse>(getPatientListPatientsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPatientListPatientsQueryKey = (params?: PatientListPatientsParams,) => {
    return [
    `/patients`, ...(params ? [params] : [])
    ] as const;
    }


export const getPatientListPatientsQueryOptions = <TData = Awaited<ReturnType<typeof patientListPatients>>, TError = ProblemResponseResponse>(params?: PatientListPatientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListPatients>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientListPatientsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientListPatients>>> = ({ signal }) => patientListPatients(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientListPatients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientListPatientsQueryResult = NonNullable<Awaited<ReturnType<typeof patientListPatients>>>
export type PatientListPatientsQueryError = ProblemResponseResponse


export function usePatientListPatients<TData = Awaited<ReturnType<typeof patientListPatients>>, TError = ProblemResponseResponse>(
 params: undefined |  PatientListPatientsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListPatients>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientListPatients>>,
          TError,
          Awaited<ReturnType<typeof patientListPatients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientListPatients<TData = Awaited<ReturnType<typeof patientListPatients>>, TError = ProblemResponseResponse>(
 params?: PatientListPatientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListPatients>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientListPatients>>,
          TError,
          Awaited<ReturnType<typeof patientListPatients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientListPatients<TData = Awaited<ReturnType<typeof patientListPatients>>, TError = ProblemResponseResponse>(
 params?: PatientListPatientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListPatients>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者一覧を取得する
 */

export function usePatientListPatients<TData = Awaited<ReturnType<typeof patientListPatients>>, TError = ProblemResponseResponse>(
 params?: PatientListPatientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListPatients>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientListPatientsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type patientGetMyDetailResponse200 = {
  data: PatientDetail
  status: 200
}

export type patientGetMyDetailResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientGetMyDetailResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientGetMyDetailResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientGetMyDetailResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientGetMyDetailResponseSuccess = (patientGetMyDetailResponse200) & {
  headers: Headers;
};
export type patientGetMyDetailResponseError = (patientGetMyDetailResponse401 | patientGetMyDetailResponse403 | patientGetMyDetailResponse404 | patientGetMyDetailResponse500) & {
  headers: Headers;
};

export type patientGetMyDetailResponse = (patientGetMyDetailResponseSuccess | patientGetMyDetailResponseError)

export const getPatientGetMyDetailUrl = () => {




  return `/patients/me/detail`
}

/**
 * 認証済みユーザーに紐づく患者の基本情報（PatientDetail）を返します。patientIdは認証コンテキストから解決されます。
 * @summary 患者本人の基本情報を取得する
 */
export const patientGetMyDetail = async ( options?: Parameters<typeof http>[1]): Promise<patientGetMyDetailResponse> => {

  return http<patientGetMyDetailResponse>(getPatientGetMyDetailUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPatientGetMyDetailQueryKey = () => {
    return [
    `/patients/me/detail`
    ] as const;
    }


export const getPatientGetMyDetailQueryOptions = <TData = Awaited<ReturnType<typeof patientGetMyDetail>>, TError = ProblemResponseResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetMyDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientGetMyDetailQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientGetMyDetail>>> = ({ signal }) => patientGetMyDetail({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientGetMyDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientGetMyDetailQueryResult = NonNullable<Awaited<ReturnType<typeof patientGetMyDetail>>>
export type PatientGetMyDetailQueryError = ProblemResponseResponse


export function usePatientGetMyDetail<TData = Awaited<ReturnType<typeof patientGetMyDetail>>, TError = ProblemResponseResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetMyDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetMyDetail>>,
          TError,
          Awaited<ReturnType<typeof patientGetMyDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetMyDetail<TData = Awaited<ReturnType<typeof patientGetMyDetail>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetMyDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetMyDetail>>,
          TError,
          Awaited<ReturnType<typeof patientGetMyDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetMyDetail<TData = Awaited<ReturnType<typeof patientGetMyDetail>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetMyDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者本人の基本情報を取得する
 */

export function usePatientGetMyDetail<TData = Awaited<ReturnType<typeof patientGetMyDetail>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetMyDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientGetMyDetailQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type patientCreateReferralRequestResponse201 = {
  data: ReferralRequest
  status: 201
}

export type patientCreateReferralRequestResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type patientCreateReferralRequestResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientCreateReferralRequestResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientCreateReferralRequestResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientCreateReferralRequestResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type patientCreateReferralRequestResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientCreateReferralRequestResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientCreateReferralRequestResponseSuccess = (patientCreateReferralRequestResponse201) & {
  headers: Headers;
};
export type patientCreateReferralRequestResponseError = (patientCreateReferralRequestResponse400 | patientCreateReferralRequestResponse401 | patientCreateReferralRequestResponse403 | patientCreateReferralRequestResponse404 | patientCreateReferralRequestResponse409 | patientCreateReferralRequestResponse422 | patientCreateReferralRequestResponse500) & {
  headers: Headers;
};

export type patientCreateReferralRequestResponse = (patientCreateReferralRequestResponseSuccess | patientCreateReferralRequestResponseError)

export const getPatientCreateReferralRequestUrl = () => {




  return `/patients/me/referral-requests`
}

/**
 * 患者本人が選択した医療機関に対する紹介状依頼を作成します。
 * patientId は認証コンテキストから解決されます。
 * 請求主体となる「元クリニック」は、患者の current_clinic_organization_id をサーバ側で解決して保存します。
 * clinicId は「紹介先クリニック」を表します。
 * @summary 患者本人の紹介状依頼を作成する
 */
export const patientCreateReferralRequest = async (referralRequestCreateRequest: ReferralRequestCreateRequest, options?: Parameters<typeof http>[1]): Promise<patientCreateReferralRequestResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<patientCreateReferralRequestResponse>(getPatientCreateReferralRequestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(referralRequestCreateRequest)
  }
);}





export const getPatientCreateReferralRequestMutationKey = () => ['patientCreateReferralRequest'] as const;

export const getPatientCreateReferralRequestMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientCreateReferralRequest>>, TError,PatientCreateReferralRequestMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof patientCreateReferralRequest>>, TError,PatientCreateReferralRequestMutationVariables, TContext> => {

const mutationKey = getPatientCreateReferralRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientCreateReferralRequest>>, PatientCreateReferralRequestMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  patientCreateReferralRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientCreateReferralRequestMutationResult = NonNullable<Awaited<ReturnType<typeof patientCreateReferralRequest>>>
    export type PatientCreateReferralRequestMutationBody = ReferralRequestCreateRequest
    export type PatientCreateReferralRequestMutationError = ProblemResponseResponse
    export type PatientCreateReferralRequestMutationVariables = {data: ReferralRequestCreateRequest}

    /**
 * @summary 患者本人の紹介状依頼を作成する
 */
export const usePatientCreateReferralRequest = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientCreateReferralRequest>>, TError,PatientCreateReferralRequestMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientCreateReferralRequest>>,
        TError,
        PatientCreateReferralRequestMutationVariables,
        TContext
      > => {
      return useMutation(getPatientCreateReferralRequestMutationOptions(options), queryClient);
    }

export type patientListReferralRequestsResponse200 = {
  data: PatientListReferralRequests200
  status: 200
}

export type patientListReferralRequestsResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientListReferralRequestsResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientListReferralRequestsResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientListReferralRequestsResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientListReferralRequestsResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientListReferralRequestsResponseSuccess = (patientListReferralRequestsResponse200) & {
  headers: Headers;
};
export type patientListReferralRequestsResponseError = (patientListReferralRequestsResponse401 | patientListReferralRequestsResponse403 | patientListReferralRequestsResponse404 | patientListReferralRequestsResponse422 | patientListReferralRequestsResponse500) & {
  headers: Headers;
};

export type patientListReferralRequestsResponse = (patientListReferralRequestsResponseSuccess | patientListReferralRequestsResponseError)

export const getPatientListReferralRequestsUrl = (patientId: string,) => {




  return `/patients/${patientId}/referral-requests`
}

/**
 * 指定された患者（patientId）の紹介状依頼一覧を返します。
 * 患者詳細画面の紹介状発行状況表示に必要な項目（紹介先名、紹介状ステータス、依頼日時、発行日時）を返却します。
 * 請求済みを含む紹介状依頼を返却します。
 *
 * 可視性ルール:
 * - clinic-* は、自身の医療機関が紹介元（source_clinic_organization_id）である紹介状依頼のみ閲覧可能
 * - 紹介先（clinic_organization_id）のみ一致する紹介状依頼は閲覧不可
 * - ops-* / patient-admin は紹介状依頼を閲覧可能
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*\/patient-admin
 * - 許可: patient-user（本人のみ。本人判定はサービス層で強制）
 * @summary 患者の紹介状依頼一覧を取得する
 */
export const patientListReferralRequests = async (patientId: string, options?: Parameters<typeof http>[1]): Promise<patientListReferralRequestsResponse> => {

  return http<patientListReferralRequestsResponse>(getPatientListReferralRequestsUrl(patientId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPatientListReferralRequestsQueryKey = (patientId: string,) => {
    return [
    `/patients/${patientId}/referral-requests`
    ] as const;
    }


export const getPatientListReferralRequestsQueryOptions = <TData = Awaited<ReturnType<typeof patientListReferralRequests>>, TError = ProblemResponseResponse>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListReferralRequests>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientListReferralRequestsQueryKey(patientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientListReferralRequests>>> = ({ signal }) => patientListReferralRequests(patientId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: patientId !== null && patientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientListReferralRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientListReferralRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof patientListReferralRequests>>>
export type PatientListReferralRequestsQueryError = ProblemResponseResponse


export function usePatientListReferralRequests<TData = Awaited<ReturnType<typeof patientListReferralRequests>>, TError = ProblemResponseResponse>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListReferralRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientListReferralRequests>>,
          TError,
          Awaited<ReturnType<typeof patientListReferralRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientListReferralRequests<TData = Awaited<ReturnType<typeof patientListReferralRequests>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListReferralRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientListReferralRequests>>,
          TError,
          Awaited<ReturnType<typeof patientListReferralRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientListReferralRequests<TData = Awaited<ReturnType<typeof patientListReferralRequests>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListReferralRequests>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者の紹介状依頼一覧を取得する
 */

export function usePatientListReferralRequests<TData = Awaited<ReturnType<typeof patientListReferralRequests>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListReferralRequests>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientListReferralRequestsQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type patientUpdateReferralRequestResponse200 = {
  data: ReferralRequest
  status: 200
}

export type patientUpdateReferralRequestResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type patientUpdateReferralRequestResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientUpdateReferralRequestResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientUpdateReferralRequestResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientUpdateReferralRequestResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type patientUpdateReferralRequestResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientUpdateReferralRequestResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientUpdateReferralRequestResponseSuccess = (patientUpdateReferralRequestResponse200) & {
  headers: Headers;
};
export type patientUpdateReferralRequestResponseError = (patientUpdateReferralRequestResponse400 | patientUpdateReferralRequestResponse401 | patientUpdateReferralRequestResponse403 | patientUpdateReferralRequestResponse404 | patientUpdateReferralRequestResponse409 | patientUpdateReferralRequestResponse422 | patientUpdateReferralRequestResponse500) & {
  headers: Headers;
};

export type patientUpdateReferralRequestResponse = (patientUpdateReferralRequestResponseSuccess | patientUpdateReferralRequestResponseError)

export const getPatientUpdateReferralRequestUrl = (patientId: string,
    referralRequestId: string,) => {




  return `/patients/${patientId}/referral-requests/${referralRequestId}`
}

/**
 * 指定患者の紹介状依頼ステータスを更新します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*
 * @summary 患者の紹介状依頼ステータスを更新する
 */
export const patientUpdateReferralRequest = async (patientId: string,
    referralRequestId: string,
    referralRequestUpdateRequest: ReferralRequestUpdateRequest, options?: Parameters<typeof http>[1]): Promise<patientUpdateReferralRequestResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<patientUpdateReferralRequestResponse>(getPatientUpdateReferralRequestUrl(patientId,referralRequestId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(referralRequestUpdateRequest)
  }
);}





export const getPatientUpdateReferralRequestMutationKey = () => ['patientUpdateReferralRequest'] as const;

export const getPatientUpdateReferralRequestMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientUpdateReferralRequest>>, TError,PatientUpdateReferralRequestMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof patientUpdateReferralRequest>>, TError,PatientUpdateReferralRequestMutationVariables, TContext> => {

const mutationKey = getPatientUpdateReferralRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientUpdateReferralRequest>>, PatientUpdateReferralRequestMutationVariables> = (props) => {
          const {patientId,referralRequestId,data} = props ?? {};

          return  patientUpdateReferralRequest(patientId,referralRequestId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientUpdateReferralRequestMutationResult = NonNullable<Awaited<ReturnType<typeof patientUpdateReferralRequest>>>
    export type PatientUpdateReferralRequestMutationBody = ReferralRequestUpdateRequest
    export type PatientUpdateReferralRequestMutationError = ProblemResponseResponse
    export type PatientUpdateReferralRequestMutationVariables = {patientId: string;referralRequestId: string;data: ReferralRequestUpdateRequest}

    /**
 * @summary 患者の紹介状依頼ステータスを更新する
 */
export const usePatientUpdateReferralRequest = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientUpdateReferralRequest>>, TError,PatientUpdateReferralRequestMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientUpdateReferralRequest>>,
        TError,
        PatientUpdateReferralRequestMutationVariables,
        TContext
      > => {
      return useMutation(getPatientUpdateReferralRequestMutationOptions(options), queryClient);
    }

export type patientGetIdentityUrlsResponse200 = {
  data: PatientIdentityUrls
  status: 200
}

export type patientGetIdentityUrlsResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientGetIdentityUrlsResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientGetIdentityUrlsResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientGetIdentityUrlsResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientGetIdentityUrlsResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientGetIdentityUrlsResponseSuccess = (patientGetIdentityUrlsResponse200) & {
  headers: Headers;
};
export type patientGetIdentityUrlsResponseError = (patientGetIdentityUrlsResponse401 | patientGetIdentityUrlsResponse403 | patientGetIdentityUrlsResponse404 | patientGetIdentityUrlsResponse422 | patientGetIdentityUrlsResponse500) & {
  headers: Headers;
};

export type patientGetIdentityUrlsResponse = (patientGetIdentityUrlsResponseSuccess | patientGetIdentityUrlsResponseError)

export const getPatientGetIdentityUrlsUrl = (patientId: string,) => {




  return `/patients/${patientId}/identity-urls`
}

/**
 * 指定された患者（patientId）の保険証・身分証ダウンロード用の署名付きURLを返します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*\/patient-admin
 * - 許可: patient-user（本人のみ。本人判定はサービス層で強制）
 * @summary 患者の保険証/身分証の署名付きURLを取得する
 */
export const patientGetIdentityUrls = async (patientId: string, options?: Parameters<typeof http>[1]): Promise<patientGetIdentityUrlsResponse> => {

  return http<patientGetIdentityUrlsResponse>(getPatientGetIdentityUrlsUrl(patientId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPatientGetIdentityUrlsQueryKey = (patientId: string,) => {
    return [
    `/patients/${patientId}/identity-urls`
    ] as const;
    }


export const getPatientGetIdentityUrlsQueryOptions = <TData = Awaited<ReturnType<typeof patientGetIdentityUrls>>, TError = ProblemResponseResponse>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetIdentityUrls>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientGetIdentityUrlsQueryKey(patientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientGetIdentityUrls>>> = ({ signal }) => patientGetIdentityUrls(patientId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: patientId !== null && patientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientGetIdentityUrls>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientGetIdentityUrlsQueryResult = NonNullable<Awaited<ReturnType<typeof patientGetIdentityUrls>>>
export type PatientGetIdentityUrlsQueryError = ProblemResponseResponse


export function usePatientGetIdentityUrls<TData = Awaited<ReturnType<typeof patientGetIdentityUrls>>, TError = ProblemResponseResponse>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetIdentityUrls>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetIdentityUrls>>,
          TError,
          Awaited<ReturnType<typeof patientGetIdentityUrls>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetIdentityUrls<TData = Awaited<ReturnType<typeof patientGetIdentityUrls>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetIdentityUrls>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetIdentityUrls>>,
          TError,
          Awaited<ReturnType<typeof patientGetIdentityUrls>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetIdentityUrls<TData = Awaited<ReturnType<typeof patientGetIdentityUrls>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetIdentityUrls>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者の保険証/身分証の署名付きURLを取得する
 */

export function usePatientGetIdentityUrls<TData = Awaited<ReturnType<typeof patientGetIdentityUrls>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetIdentityUrls>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientGetIdentityUrlsQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type patientGetLocalIdResponse200 = {
  data: PatientLocalId
  status: 200
}

export type patientGetLocalIdResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientGetLocalIdResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientGetLocalIdResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientGetLocalIdResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientGetLocalIdResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientGetLocalIdResponseSuccess = (patientGetLocalIdResponse200) & {
  headers: Headers;
};
export type patientGetLocalIdResponseError = (patientGetLocalIdResponse401 | patientGetLocalIdResponse403 | patientGetLocalIdResponse404 | patientGetLocalIdResponse422 | patientGetLocalIdResponse500) & {
  headers: Headers;
};

export type patientGetLocalIdResponse = (patientGetLocalIdResponseSuccess | patientGetLocalIdResponseError)

export const getPatientGetLocalIdUrl = (patientId: string,) => {




  return `/patients/${patientId}/local-id`
}

/**
 * 患者IDに対応する患者の識別番号（医療機関独自の番号）を返します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*
 * @summary 患者の識別番号（医療機関独自の番号）を取得する
 */
export const patientGetLocalId = async (patientId: string, options?: Parameters<typeof http>[1]): Promise<patientGetLocalIdResponse> => {

  return http<patientGetLocalIdResponse>(getPatientGetLocalIdUrl(patientId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPatientGetLocalIdQueryKey = (patientId: string,) => {
    return [
    `/patients/${patientId}/local-id`
    ] as const;
    }


export const getPatientGetLocalIdQueryOptions = <TData = Awaited<ReturnType<typeof patientGetLocalId>>, TError = ProblemResponseResponse>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetLocalId>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientGetLocalIdQueryKey(patientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientGetLocalId>>> = ({ signal }) => patientGetLocalId(patientId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: patientId !== null && patientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientGetLocalId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientGetLocalIdQueryResult = NonNullable<Awaited<ReturnType<typeof patientGetLocalId>>>
export type PatientGetLocalIdQueryError = ProblemResponseResponse


export function usePatientGetLocalId<TData = Awaited<ReturnType<typeof patientGetLocalId>>, TError = ProblemResponseResponse>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetLocalId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetLocalId>>,
          TError,
          Awaited<ReturnType<typeof patientGetLocalId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetLocalId<TData = Awaited<ReturnType<typeof patientGetLocalId>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetLocalId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetLocalId>>,
          TError,
          Awaited<ReturnType<typeof patientGetLocalId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetLocalId<TData = Awaited<ReturnType<typeof patientGetLocalId>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetLocalId>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者の識別番号（医療機関独自の番号）を取得する
 */

export function usePatientGetLocalId<TData = Awaited<ReturnType<typeof patientGetLocalId>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetLocalId>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientGetLocalIdQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type patientUpdateLocalIdResponse200 = {
  data: PatientLocalId
  status: 200
}

export type patientUpdateLocalIdResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type patientUpdateLocalIdResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientUpdateLocalIdResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientUpdateLocalIdResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientUpdateLocalIdResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientUpdateLocalIdResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientUpdateLocalIdResponseSuccess = (patientUpdateLocalIdResponse200) & {
  headers: Headers;
};
export type patientUpdateLocalIdResponseError = (patientUpdateLocalIdResponse400 | patientUpdateLocalIdResponse401 | patientUpdateLocalIdResponse403 | patientUpdateLocalIdResponse404 | patientUpdateLocalIdResponse422 | patientUpdateLocalIdResponse500) & {
  headers: Headers;
};

export type patientUpdateLocalIdResponse = (patientUpdateLocalIdResponseSuccess | patientUpdateLocalIdResponseError)

export const getPatientUpdateLocalIdUrl = (patientId: string,) => {




  return `/patients/${patientId}/local-id`
}

/**
 * 患者IDに対応する患者の識別番号（医療機関独自の番号）を部分更新します（指定項目のみ更新）。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*
 * @summary 患者の識別番号（医療機関独自の番号）を更新する
 */
export const patientUpdateLocalId = async (patientId: string,
    patientLocalIdUpdateRequest: PatientLocalIdUpdateRequest, options?: Parameters<typeof http>[1]): Promise<patientUpdateLocalIdResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<patientUpdateLocalIdResponse>(getPatientUpdateLocalIdUrl(patientId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patientLocalIdUpdateRequest)
  }
);}





export const getPatientUpdateLocalIdMutationKey = () => ['patientUpdateLocalId'] as const;

export const getPatientUpdateLocalIdMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientUpdateLocalId>>, TError,PatientUpdateLocalIdMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof patientUpdateLocalId>>, TError,PatientUpdateLocalIdMutationVariables, TContext> => {

const mutationKey = getPatientUpdateLocalIdMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientUpdateLocalId>>, PatientUpdateLocalIdMutationVariables> = (props) => {
          const {patientId,data} = props ?? {};

          return  patientUpdateLocalId(patientId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientUpdateLocalIdMutationResult = NonNullable<Awaited<ReturnType<typeof patientUpdateLocalId>>>
    export type PatientUpdateLocalIdMutationBody = PatientLocalIdUpdateRequest
    export type PatientUpdateLocalIdMutationError = ProblemResponseResponse
    export type PatientUpdateLocalIdMutationVariables = {patientId: string;data: PatientLocalIdUpdateRequest}

    /**
 * @summary 患者の識別番号（医療機関独自の番号）を更新する
 */
export const usePatientUpdateLocalId = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientUpdateLocalId>>, TError,PatientUpdateLocalIdMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientUpdateLocalId>>,
        TError,
        PatientUpdateLocalIdMutationVariables,
        TContext
      > => {
      return useMutation(getPatientUpdateLocalIdMutationOptions(options), queryClient);
    }

export type patientListDiagnosesResponse200 = {
  data: PatientListDiagnoses200
  status: 200
}

export type patientListDiagnosesResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientListDiagnosesResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientListDiagnosesResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientListDiagnosesResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientListDiagnosesResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientListDiagnosesResponseSuccess = (patientListDiagnosesResponse200) & {
  headers: Headers;
};
export type patientListDiagnosesResponseError = (patientListDiagnosesResponse401 | patientListDiagnosesResponse403 | patientListDiagnosesResponse404 | patientListDiagnosesResponse422 | patientListDiagnosesResponse500) & {
  headers: Headers;
};

export type patientListDiagnosesResponse = (patientListDiagnosesResponseSuccess | patientListDiagnosesResponseError)

export const getPatientListDiagnosesUrl = (patientId: string,
    params?: PatientListDiagnosesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/patients/${patientId}/diagnoses?${stringifiedParams}` : `/patients/${patientId}/diagnoses`
}

/**
 * 指定された患者（patientId）の診断結果一覧を返します。
 *
 * 各行には consultationType（ONLINE / IN_PERSON）を含みます。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*\/patient-admin
 * - 許可: patient-user（本人のみ。本人判定はサービス層で強制）
 * @summary 患者の診断結果一覧を取得する
 */
export const patientListDiagnoses = async (patientId: string,
    params?: PatientListDiagnosesParams, options?: Parameters<typeof http>[1]): Promise<patientListDiagnosesResponse> => {

  return http<patientListDiagnosesResponse>(getPatientListDiagnosesUrl(patientId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPatientListDiagnosesQueryKey = (patientId: string,
    params?: PatientListDiagnosesParams,) => {
    return [
    `/patients/${patientId}/diagnoses`, ...(params ? [params] : [])
    ] as const;
    }


export const getPatientListDiagnosesQueryOptions = <TData = Awaited<ReturnType<typeof patientListDiagnoses>>, TError = ProblemResponseResponse>(patientId: string,
    params?: PatientListDiagnosesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListDiagnoses>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientListDiagnosesQueryKey(patientId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientListDiagnoses>>> = ({ signal }) => patientListDiagnoses(patientId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: patientId !== null && patientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientListDiagnoses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientListDiagnosesQueryResult = NonNullable<Awaited<ReturnType<typeof patientListDiagnoses>>>
export type PatientListDiagnosesQueryError = ProblemResponseResponse


export function usePatientListDiagnoses<TData = Awaited<ReturnType<typeof patientListDiagnoses>>, TError = ProblemResponseResponse>(
 patientId: string,
    params: undefined |  PatientListDiagnosesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListDiagnoses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientListDiagnoses>>,
          TError,
          Awaited<ReturnType<typeof patientListDiagnoses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientListDiagnoses<TData = Awaited<ReturnType<typeof patientListDiagnoses>>, TError = ProblemResponseResponse>(
 patientId: string,
    params?: PatientListDiagnosesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListDiagnoses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientListDiagnoses>>,
          TError,
          Awaited<ReturnType<typeof patientListDiagnoses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientListDiagnoses<TData = Awaited<ReturnType<typeof patientListDiagnoses>>, TError = ProblemResponseResponse>(
 patientId: string,
    params?: PatientListDiagnosesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListDiagnoses>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者の診断結果一覧を取得する
 */

export function usePatientListDiagnoses<TData = Awaited<ReturnType<typeof patientListDiagnoses>>, TError = ProblemResponseResponse>(
 patientId: string,
    params?: PatientListDiagnosesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListDiagnoses>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientListDiagnosesQueryOptions(patientId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type patientCreateDiagnosisResponse201 = {
  data: PatientDiagnosis
  status: 201
}

export type patientCreateDiagnosisResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type patientCreateDiagnosisResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientCreateDiagnosisResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientCreateDiagnosisResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientCreateDiagnosisResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type patientCreateDiagnosisResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientCreateDiagnosisResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientCreateDiagnosisResponseSuccess = (patientCreateDiagnosisResponse201) & {
  headers: Headers;
};
export type patientCreateDiagnosisResponseError = (patientCreateDiagnosisResponse400 | patientCreateDiagnosisResponse401 | patientCreateDiagnosisResponse403 | patientCreateDiagnosisResponse404 | patientCreateDiagnosisResponse409 | patientCreateDiagnosisResponse422 | patientCreateDiagnosisResponse500) & {
  headers: Headers;
};

export type patientCreateDiagnosisResponse = (patientCreateDiagnosisResponseSuccess | patientCreateDiagnosisResponseError)

export const getPatientCreateDiagnosisUrl = (patientId: string,) => {




  return `/patients/${patientId}/diagnoses`
}

/**
 * 指定された患者（patientId）に対して診断結果を登録します。
 * `reservationId` は当該患者に紐づく予約であることをサーバー側で検証します。
 * 診療種別はリクエストからは受け取らず、予約の種別を引き継ぎます。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*
 * @summary 患者の診断結果を登録する
 */
export const patientCreateDiagnosis = async (patientId: string,
    patientDiagnosisCreateRequest: PatientDiagnosisCreateRequest, options?: Parameters<typeof http>[1]): Promise<patientCreateDiagnosisResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<patientCreateDiagnosisResponse>(getPatientCreateDiagnosisUrl(patientId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patientDiagnosisCreateRequest)
  }
);}





export const getPatientCreateDiagnosisMutationKey = () => ['patientCreateDiagnosis'] as const;

export const getPatientCreateDiagnosisMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientCreateDiagnosis>>, TError,PatientCreateDiagnosisMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof patientCreateDiagnosis>>, TError,PatientCreateDiagnosisMutationVariables, TContext> => {

const mutationKey = getPatientCreateDiagnosisMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientCreateDiagnosis>>, PatientCreateDiagnosisMutationVariables> = (props) => {
          const {patientId,data} = props ?? {};

          return  patientCreateDiagnosis(patientId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientCreateDiagnosisMutationResult = NonNullable<Awaited<ReturnType<typeof patientCreateDiagnosis>>>
    export type PatientCreateDiagnosisMutationBody = PatientDiagnosisCreateRequest
    export type PatientCreateDiagnosisMutationError = ProblemResponseResponse
    export type PatientCreateDiagnosisMutationVariables = {patientId: string;data: PatientDiagnosisCreateRequest}

    /**
 * @summary 患者の診断結果を登録する
 */
export const usePatientCreateDiagnosis = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientCreateDiagnosis>>, TError,PatientCreateDiagnosisMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientCreateDiagnosis>>,
        TError,
        PatientCreateDiagnosisMutationVariables,
        TContext
      > => {
      return useMutation(getPatientCreateDiagnosisMutationOptions(options), queryClient);
    }

export type patientGetCheckupHistoryResponse200 = {
  data: PatientGetCheckupHistory200
  status: 200
}

export type patientGetCheckupHistoryResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientGetCheckupHistoryResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientGetCheckupHistoryResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientGetCheckupHistoryResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientGetCheckupHistoryResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientGetCheckupHistoryResponseSuccess = (patientGetCheckupHistoryResponse200) & {
  headers: Headers;
};
export type patientGetCheckupHistoryResponseError = (patientGetCheckupHistoryResponse401 | patientGetCheckupHistoryResponse403 | patientGetCheckupHistoryResponse404 | patientGetCheckupHistoryResponse422 | patientGetCheckupHistoryResponse500) & {
  headers: Headers;
};

export type patientGetCheckupHistoryResponse = (patientGetCheckupHistoryResponseSuccess | patientGetCheckupHistoryResponseError)

export const getPatientGetCheckupHistoryUrl = (patientId: string,) => {




  return `/patients/${patientId}/checkup-history`
}

/**
 * 指定された患者（patientId）のパルス検査履歴とPSG検査履歴をまとめて返します。
 * ページングは行わず、該当患者の全件を返します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*\/patient-admin
 * - 許可: patient-user（本人のみ。本人判定はサービス層で強制）
 * @summary 患者のパルス/PSG検査履歴を取得する
 */
export const patientGetCheckupHistory = async (patientId: string, options?: Parameters<typeof http>[1]): Promise<patientGetCheckupHistoryResponse> => {

  return http<patientGetCheckupHistoryResponse>(getPatientGetCheckupHistoryUrl(patientId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPatientGetCheckupHistoryQueryKey = (patientId: string,) => {
    return [
    `/patients/${patientId}/checkup-history`
    ] as const;
    }


export const getPatientGetCheckupHistoryQueryOptions = <TData = Awaited<ReturnType<typeof patientGetCheckupHistory>>, TError = ProblemResponseResponse>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetCheckupHistory>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientGetCheckupHistoryQueryKey(patientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientGetCheckupHistory>>> = ({ signal }) => patientGetCheckupHistory(patientId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: patientId !== null && patientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientGetCheckupHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientGetCheckupHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof patientGetCheckupHistory>>>
export type PatientGetCheckupHistoryQueryError = ProblemResponseResponse


export function usePatientGetCheckupHistory<TData = Awaited<ReturnType<typeof patientGetCheckupHistory>>, TError = ProblemResponseResponse>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetCheckupHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetCheckupHistory>>,
          TError,
          Awaited<ReturnType<typeof patientGetCheckupHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetCheckupHistory<TData = Awaited<ReturnType<typeof patientGetCheckupHistory>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetCheckupHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetCheckupHistory>>,
          TError,
          Awaited<ReturnType<typeof patientGetCheckupHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetCheckupHistory<TData = Awaited<ReturnType<typeof patientGetCheckupHistory>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetCheckupHistory>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者のパルス/PSG検査履歴を取得する
 */

export function usePatientGetCheckupHistory<TData = Awaited<ReturnType<typeof patientGetCheckupHistory>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetCheckupHistory>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientGetCheckupHistoryQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type patientGetTreatmentVisitHistoryResponse200 = {
  data: PatientGetTreatmentVisitHistory200
  status: 200
}

export type patientGetTreatmentVisitHistoryResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientGetTreatmentVisitHistoryResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientGetTreatmentVisitHistoryResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientGetTreatmentVisitHistoryResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientGetTreatmentVisitHistoryResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientGetTreatmentVisitHistoryResponseSuccess = (patientGetTreatmentVisitHistoryResponse200) & {
  headers: Headers;
};
export type patientGetTreatmentVisitHistoryResponseError = (patientGetTreatmentVisitHistoryResponse401 | patientGetTreatmentVisitHistoryResponse403 | patientGetTreatmentVisitHistoryResponse404 | patientGetTreatmentVisitHistoryResponse422 | patientGetTreatmentVisitHistoryResponse500) & {
  headers: Headers;
};

export type patientGetTreatmentVisitHistoryResponse = (patientGetTreatmentVisitHistoryResponseSuccess | patientGetTreatmentVisitHistoryResponseError)

export const getPatientGetTreatmentVisitHistoryUrl = (patientId: string,) => {




  return `/patients/${patientId}/treatment-visit-history`
}

/**
 * 指定された患者（patientId）の診療記録のうち、治療目的（billing_item_type = TREATMENT）の
 * ものだけをまとめて返します。初回スクリーニング/PSG検査に伴う診療記録は含みません。
 * ページングは行わず、該当患者の全件を返します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*\/patient-admin
 * - 許可: patient-user（本人のみ。本人判定はサービス層で強制）
 * @summary 患者の治療目的の受診履歴を取得する
 */
export const patientGetTreatmentVisitHistory = async (patientId: string, options?: Parameters<typeof http>[1]): Promise<patientGetTreatmentVisitHistoryResponse> => {

  return http<patientGetTreatmentVisitHistoryResponse>(getPatientGetTreatmentVisitHistoryUrl(patientId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPatientGetTreatmentVisitHistoryQueryKey = (patientId: string,) => {
    return [
    `/patients/${patientId}/treatment-visit-history`
    ] as const;
    }


export const getPatientGetTreatmentVisitHistoryQueryOptions = <TData = Awaited<ReturnType<typeof patientGetTreatmentVisitHistory>>, TError = ProblemResponseResponse>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetTreatmentVisitHistory>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientGetTreatmentVisitHistoryQueryKey(patientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientGetTreatmentVisitHistory>>> = ({ signal }) => patientGetTreatmentVisitHistory(patientId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: patientId !== null && patientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientGetTreatmentVisitHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientGetTreatmentVisitHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof patientGetTreatmentVisitHistory>>>
export type PatientGetTreatmentVisitHistoryQueryError = ProblemResponseResponse


export function usePatientGetTreatmentVisitHistory<TData = Awaited<ReturnType<typeof patientGetTreatmentVisitHistory>>, TError = ProblemResponseResponse>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetTreatmentVisitHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetTreatmentVisitHistory>>,
          TError,
          Awaited<ReturnType<typeof patientGetTreatmentVisitHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetTreatmentVisitHistory<TData = Awaited<ReturnType<typeof patientGetTreatmentVisitHistory>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetTreatmentVisitHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetTreatmentVisitHistory>>,
          TError,
          Awaited<ReturnType<typeof patientGetTreatmentVisitHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetTreatmentVisitHistory<TData = Awaited<ReturnType<typeof patientGetTreatmentVisitHistory>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetTreatmentVisitHistory>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者の治療目的の受診履歴を取得する
 */

export function usePatientGetTreatmentVisitHistory<TData = Awaited<ReturnType<typeof patientGetTreatmentVisitHistory>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetTreatmentVisitHistory>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientGetTreatmentVisitHistoryQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type patientGetPsgStatusHistoryResponse200 = {
  data: PatientGetPsgStatusHistory200
  status: 200
}

export type patientGetPsgStatusHistoryResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientGetPsgStatusHistoryResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientGetPsgStatusHistoryResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientGetPsgStatusHistoryResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientGetPsgStatusHistoryResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientGetPsgStatusHistoryResponseSuccess = (patientGetPsgStatusHistoryResponse200) & {
  headers: Headers;
};
export type patientGetPsgStatusHistoryResponseError = (patientGetPsgStatusHistoryResponse401 | patientGetPsgStatusHistoryResponse403 | patientGetPsgStatusHistoryResponse404 | patientGetPsgStatusHistoryResponse422 | patientGetPsgStatusHistoryResponse500) & {
  headers: Headers;
};

export type patientGetPsgStatusHistoryResponse = (patientGetPsgStatusHistoryResponseSuccess | patientGetPsgStatusHistoryResponseError)

export const getPatientGetPsgStatusHistoryUrl = (patientId: string,) => {




  return `/patients/${patientId}/psg-status-history`
}

/**
 * 指定された患者（patientId）のPSGステータス（statusPsg）の変更履歴を、変更日時の昇順で返します。
 * ページングは行わず、該当患者の全件を返します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*\/patient-admin
 * - 許可: patient-user（本人のみ。本人判定はサービス層で強制）
 * @summary 患者のPSGステータス変更履歴を取得する
 */
export const patientGetPsgStatusHistory = async (patientId: string, options?: Parameters<typeof http>[1]): Promise<patientGetPsgStatusHistoryResponse> => {

  return http<patientGetPsgStatusHistoryResponse>(getPatientGetPsgStatusHistoryUrl(patientId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPatientGetPsgStatusHistoryQueryKey = (patientId: string,) => {
    return [
    `/patients/${patientId}/psg-status-history`
    ] as const;
    }


export const getPatientGetPsgStatusHistoryQueryOptions = <TData = Awaited<ReturnType<typeof patientGetPsgStatusHistory>>, TError = ProblemResponseResponse>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetPsgStatusHistory>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientGetPsgStatusHistoryQueryKey(patientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientGetPsgStatusHistory>>> = ({ signal }) => patientGetPsgStatusHistory(patientId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: patientId !== null && patientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientGetPsgStatusHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientGetPsgStatusHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof patientGetPsgStatusHistory>>>
export type PatientGetPsgStatusHistoryQueryError = ProblemResponseResponse


export function usePatientGetPsgStatusHistory<TData = Awaited<ReturnType<typeof patientGetPsgStatusHistory>>, TError = ProblemResponseResponse>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetPsgStatusHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetPsgStatusHistory>>,
          TError,
          Awaited<ReturnType<typeof patientGetPsgStatusHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetPsgStatusHistory<TData = Awaited<ReturnType<typeof patientGetPsgStatusHistory>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetPsgStatusHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetPsgStatusHistory>>,
          TError,
          Awaited<ReturnType<typeof patientGetPsgStatusHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetPsgStatusHistory<TData = Awaited<ReturnType<typeof patientGetPsgStatusHistory>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetPsgStatusHistory>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者のPSGステータス変更履歴を取得する
 */

export function usePatientGetPsgStatusHistory<TData = Awaited<ReturnType<typeof patientGetPsgStatusHistory>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetPsgStatusHistory>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientGetPsgStatusHistoryQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type patientGetCpapTreatmentSummaryHistoryResponse200 = {
  data: PatientGetCpapTreatmentSummaryHistory200
  status: 200
}

export type patientGetCpapTreatmentSummaryHistoryResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientGetCpapTreatmentSummaryHistoryResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientGetCpapTreatmentSummaryHistoryResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientGetCpapTreatmentSummaryHistoryResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientGetCpapTreatmentSummaryHistoryResponseSuccess = (patientGetCpapTreatmentSummaryHistoryResponse200) & {
  headers: Headers;
};
export type patientGetCpapTreatmentSummaryHistoryResponseError = (patientGetCpapTreatmentSummaryHistoryResponse401 | patientGetCpapTreatmentSummaryHistoryResponse403 | patientGetCpapTreatmentSummaryHistoryResponse404 | patientGetCpapTreatmentSummaryHistoryResponse500) & {
  headers: Headers;
};

export type patientGetCpapTreatmentSummaryHistoryResponse = (patientGetCpapTreatmentSummaryHistoryResponseSuccess | patientGetCpapTreatmentSummaryHistoryResponseError)

export const getPatientGetCpapTreatmentSummaryHistoryUrl = (patientId: string,) => {




  return `/patients/${patientId}/cpap-treatment-summaries`
}

/**
 * 指定された患者（patientId）に対して手動登録済みのCPAP治療実績（平均AHI・装着率・
 * 平均使用時間の期間集計値）を、対象期間開始日（periodStart）の降順ですべて返します。
 * ページングは行いません。該当する実績が1件もない場合はitemsが空配列で返ります。
 *
 * RBAC:
 * - 許可: ops-*\/clinic-*\/patient-admin/health-nurse/patient-user
 * - clinic-* の場合、各実績が紐づく通院先クリニック（clinicOrganizationId、登録時点でのその患者の
 *   通院先。登録操作自体はops-admin/ops-operatorのみが行い、クリニックが自ら記録することはない）が
 *   閲覧クリニックと一致する実績のみに絞り込む
 * @summary 患者のCPAP治療実績（期間集計値）履歴を取得する
 */
export const patientGetCpapTreatmentSummaryHistory = async (patientId: string, options?: Parameters<typeof http>[1]): Promise<patientGetCpapTreatmentSummaryHistoryResponse> => {

  return http<patientGetCpapTreatmentSummaryHistoryResponse>(getPatientGetCpapTreatmentSummaryHistoryUrl(patientId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPatientGetCpapTreatmentSummaryHistoryQueryKey = (patientId: string,) => {
    return [
    `/patients/${patientId}/cpap-treatment-summaries`
    ] as const;
    }


export const getPatientGetCpapTreatmentSummaryHistoryQueryOptions = <TData = Awaited<ReturnType<typeof patientGetCpapTreatmentSummaryHistory>>, TError = ProblemResponseResponse>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetCpapTreatmentSummaryHistory>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientGetCpapTreatmentSummaryHistoryQueryKey(patientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientGetCpapTreatmentSummaryHistory>>> = ({ signal }) => patientGetCpapTreatmentSummaryHistory(patientId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: patientId !== null && patientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientGetCpapTreatmentSummaryHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientGetCpapTreatmentSummaryHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof patientGetCpapTreatmentSummaryHistory>>>
export type PatientGetCpapTreatmentSummaryHistoryQueryError = ProblemResponseResponse


export function usePatientGetCpapTreatmentSummaryHistory<TData = Awaited<ReturnType<typeof patientGetCpapTreatmentSummaryHistory>>, TError = ProblemResponseResponse>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetCpapTreatmentSummaryHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetCpapTreatmentSummaryHistory>>,
          TError,
          Awaited<ReturnType<typeof patientGetCpapTreatmentSummaryHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetCpapTreatmentSummaryHistory<TData = Awaited<ReturnType<typeof patientGetCpapTreatmentSummaryHistory>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetCpapTreatmentSummaryHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetCpapTreatmentSummaryHistory>>,
          TError,
          Awaited<ReturnType<typeof patientGetCpapTreatmentSummaryHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetCpapTreatmentSummaryHistory<TData = Awaited<ReturnType<typeof patientGetCpapTreatmentSummaryHistory>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetCpapTreatmentSummaryHistory>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者のCPAP治療実績（期間集計値）履歴を取得する
 */

export function usePatientGetCpapTreatmentSummaryHistory<TData = Awaited<ReturnType<typeof patientGetCpapTreatmentSummaryHistory>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetCpapTreatmentSummaryHistory>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientGetCpapTreatmentSummaryHistoryQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type patientListInvoicesResponse200 = {
  data: PatientListInvoices200
  status: 200
}

export type patientListInvoicesResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientListInvoicesResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientListInvoicesResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientListInvoicesResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientListInvoicesResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientListInvoicesResponseSuccess = (patientListInvoicesResponse200) & {
  headers: Headers;
};
export type patientListInvoicesResponseError = (patientListInvoicesResponse401 | patientListInvoicesResponse403 | patientListInvoicesResponse404 | patientListInvoicesResponse422 | patientListInvoicesResponse500) & {
  headers: Headers;
};

export type patientListInvoicesResponse = (patientListInvoicesResponseSuccess | patientListInvoicesResponseError)

export const getPatientListInvoicesUrl = (patientId: string,
    params?: PatientListInvoicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/invoices/by-patient/${patientId}?${stringifiedParams}` : `/invoices/by-patient/${patientId}`
}

/**
 * 指定された患者（patientId）の請求一覧を返します。
 * @summary 患者の請求一覧を取得する
 */
export const patientListInvoices = async (patientId: string,
    params?: PatientListInvoicesParams, options?: Parameters<typeof http>[1]): Promise<patientListInvoicesResponse> => {

  return http<patientListInvoicesResponse>(getPatientListInvoicesUrl(patientId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPatientListInvoicesQueryKey = (patientId: string,
    params?: PatientListInvoicesParams,) => {
    return [
    `/invoices/by-patient/${patientId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getPatientListInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof patientListInvoices>>, TError = ProblemResponseResponse>(patientId: string,
    params?: PatientListInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListInvoices>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientListInvoicesQueryKey(patientId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientListInvoices>>> = ({ signal }) => patientListInvoices(patientId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: patientId !== null && patientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientListInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientListInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof patientListInvoices>>>
export type PatientListInvoicesQueryError = ProblemResponseResponse


export function usePatientListInvoices<TData = Awaited<ReturnType<typeof patientListInvoices>>, TError = ProblemResponseResponse>(
 patientId: string,
    params: undefined |  PatientListInvoicesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListInvoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientListInvoices>>,
          TError,
          Awaited<ReturnType<typeof patientListInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientListInvoices<TData = Awaited<ReturnType<typeof patientListInvoices>>, TError = ProblemResponseResponse>(
 patientId: string,
    params?: PatientListInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListInvoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientListInvoices>>,
          TError,
          Awaited<ReturnType<typeof patientListInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientListInvoices<TData = Awaited<ReturnType<typeof patientListInvoices>>, TError = ProblemResponseResponse>(
 patientId: string,
    params?: PatientListInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListInvoices>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者の請求一覧を取得する
 */

export function usePatientListInvoices<TData = Awaited<ReturnType<typeof patientListInvoices>>, TError = ProblemResponseResponse>(
 patientId: string,
    params?: PatientListInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListInvoices>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientListInvoicesQueryOptions(patientId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type patientListQuestionnairesResponse200 = {
  data: PatientListQuestionnaires200
  status: 200
}

export type patientListQuestionnairesResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientListQuestionnairesResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientListQuestionnairesResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientListQuestionnairesResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientListQuestionnairesResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientListQuestionnairesResponseSuccess = (patientListQuestionnairesResponse200) & {
  headers: Headers;
};
export type patientListQuestionnairesResponseError = (patientListQuestionnairesResponse401 | patientListQuestionnairesResponse403 | patientListQuestionnairesResponse404 | patientListQuestionnairesResponse422 | patientListQuestionnairesResponse500) & {
  headers: Headers;
};

export type patientListQuestionnairesResponse = (patientListQuestionnairesResponseSuccess | patientListQuestionnairesResponseError)

export const getPatientListQuestionnairesUrl = (patientId: string,
    params?: PatientListQuestionnairesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/questionnaires/by-patient/${patientId}?${stringifiedParams}` : `/questionnaires/by-patient/${patientId}`
}

/**
 * 指定された患者（patientId）の問診票一覧を返します。
 * @summary 患者の問診票一覧を取得する
 */
export const patientListQuestionnaires = async (patientId: string,
    params?: PatientListQuestionnairesParams, options?: Parameters<typeof http>[1]): Promise<patientListQuestionnairesResponse> => {

  return http<patientListQuestionnairesResponse>(getPatientListQuestionnairesUrl(patientId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPatientListQuestionnairesQueryKey = (patientId: string,
    params?: PatientListQuestionnairesParams,) => {
    return [
    `/questionnaires/by-patient/${patientId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getPatientListQuestionnairesQueryOptions = <TData = Awaited<ReturnType<typeof patientListQuestionnaires>>, TError = ProblemResponseResponse>(patientId: string,
    params?: PatientListQuestionnairesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientListQuestionnairesQueryKey(patientId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientListQuestionnaires>>> = ({ signal }) => patientListQuestionnaires(patientId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: patientId !== null && patientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientListQuestionnaires>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientListQuestionnairesQueryResult = NonNullable<Awaited<ReturnType<typeof patientListQuestionnaires>>>
export type PatientListQuestionnairesQueryError = ProblemResponseResponse


export function usePatientListQuestionnaires<TData = Awaited<ReturnType<typeof patientListQuestionnaires>>, TError = ProblemResponseResponse>(
 patientId: string,
    params: undefined |  PatientListQuestionnairesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListQuestionnaires>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientListQuestionnaires>>,
          TError,
          Awaited<ReturnType<typeof patientListQuestionnaires>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientListQuestionnaires<TData = Awaited<ReturnType<typeof patientListQuestionnaires>>, TError = ProblemResponseResponse>(
 patientId: string,
    params?: PatientListQuestionnairesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListQuestionnaires>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientListQuestionnaires>>,
          TError,
          Awaited<ReturnType<typeof patientListQuestionnaires>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientListQuestionnaires<TData = Awaited<ReturnType<typeof patientListQuestionnaires>>, TError = ProblemResponseResponse>(
 patientId: string,
    params?: PatientListQuestionnairesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者の問診票一覧を取得する
 */

export function usePatientListQuestionnaires<TData = Awaited<ReturnType<typeof patientListQuestionnaires>>, TError = ProblemResponseResponse>(
 patientId: string,
    params?: PatientListQuestionnairesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientListQuestionnairesQueryOptions(patientId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type patientCreateQuestionnaireResponse201 = {
  data: PatientQuestionnaireCreateResponse
  status: 201
}

export type patientCreateQuestionnaireResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type patientCreateQuestionnaireResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientCreateQuestionnaireResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientCreateQuestionnaireResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type patientCreateQuestionnaireResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientCreateQuestionnaireResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientCreateQuestionnaireResponseSuccess = (patientCreateQuestionnaireResponse201) & {
  headers: Headers;
};
export type patientCreateQuestionnaireResponseError = (patientCreateQuestionnaireResponse400 | patientCreateQuestionnaireResponse401 | patientCreateQuestionnaireResponse403 | patientCreateQuestionnaireResponse409 | patientCreateQuestionnaireResponse422 | patientCreateQuestionnaireResponse500) & {
  headers: Headers;
};

export type patientCreateQuestionnaireResponse = (patientCreateQuestionnaireResponseSuccess | patientCreateQuestionnaireResponseError)

export const getPatientCreateQuestionnaireUrl = (patientId: string,) => {




  return `/questionnaires/by-patient/${patientId}`
}

/**
 * 指定された患者（patientId）の問診票を登録します。
 * @summary 患者の問診票を登録する
 */
export const patientCreateQuestionnaire = async (patientId: string,
    patientQuestionnaireCreateRequest: PatientQuestionnaireCreateRequest, options?: Parameters<typeof http>[1]): Promise<patientCreateQuestionnaireResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<patientCreateQuestionnaireResponse>(getPatientCreateQuestionnaireUrl(patientId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patientQuestionnaireCreateRequest)
  }
);}





export const getPatientCreateQuestionnaireMutationKey = () => ['patientCreateQuestionnaire'] as const;

export const getPatientCreateQuestionnaireMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientCreateQuestionnaire>>, TError,PatientCreateQuestionnaireMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof patientCreateQuestionnaire>>, TError,PatientCreateQuestionnaireMutationVariables, TContext> => {

const mutationKey = getPatientCreateQuestionnaireMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientCreateQuestionnaire>>, PatientCreateQuestionnaireMutationVariables> = (props) => {
          const {patientId,data} = props ?? {};

          return  patientCreateQuestionnaire(patientId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientCreateQuestionnaireMutationResult = NonNullable<Awaited<ReturnType<typeof patientCreateQuestionnaire>>>
    export type PatientCreateQuestionnaireMutationBody = PatientQuestionnaireCreateRequest
    export type PatientCreateQuestionnaireMutationError = ProblemResponseResponse
    export type PatientCreateQuestionnaireMutationVariables = {patientId: string;data: PatientQuestionnaireCreateRequest}

    /**
 * @summary 患者の問診票を登録する
 */
export const usePatientCreateQuestionnaire = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientCreateQuestionnaire>>, TError,PatientCreateQuestionnaireMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientCreateQuestionnaire>>,
        TError,
        PatientCreateQuestionnaireMutationVariables,
        TContext
      > => {
      return useMutation(getPatientCreateQuestionnaireMutationOptions(options), queryClient);
    }

export type reservationGetQuestionnaireResponse200 = {
  data: PatientQuestionnaire
  status: 200
}

export type reservationGetQuestionnaireResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type reservationGetQuestionnaireResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type reservationGetQuestionnaireResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type reservationGetQuestionnaireResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type reservationGetQuestionnaireResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type reservationGetQuestionnaireResponseSuccess = (reservationGetQuestionnaireResponse200) & {
  headers: Headers;
};
export type reservationGetQuestionnaireResponseError = (reservationGetQuestionnaireResponse401 | reservationGetQuestionnaireResponse403 | reservationGetQuestionnaireResponse404 | reservationGetQuestionnaireResponse422 | reservationGetQuestionnaireResponse500) & {
  headers: Headers;
};

export type reservationGetQuestionnaireResponse = (reservationGetQuestionnaireResponseSuccess | reservationGetQuestionnaireResponseError)

export const getReservationGetQuestionnaireUrl = (reservationId: string,) => {




  return `/questionnaires/by-reservation/${reservationId}`
}

/**
 * 指定された予約ID（reservationId）に紐づく問診票を返します。
 * @summary 予約IDに紐づく問診票を取得する
 */
export const reservationGetQuestionnaire = async (reservationId: string, options?: Parameters<typeof http>[1]): Promise<reservationGetQuestionnaireResponse> => {

  return http<reservationGetQuestionnaireResponse>(getReservationGetQuestionnaireUrl(reservationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReservationGetQuestionnaireQueryKey = (reservationId: string,) => {
    return [
    `/questionnaires/by-reservation/${reservationId}`
    ] as const;
    }


export const getReservationGetQuestionnaireQueryOptions = <TData = Awaited<ReturnType<typeof reservationGetQuestionnaire>>, TError = ProblemResponseResponse>(reservationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationGetQuestionnaire>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReservationGetQuestionnaireQueryKey(reservationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reservationGetQuestionnaire>>> = ({ signal }) => reservationGetQuestionnaire(reservationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: reservationId !== null && reservationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reservationGetQuestionnaire>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReservationGetQuestionnaireQueryResult = NonNullable<Awaited<ReturnType<typeof reservationGetQuestionnaire>>>
export type ReservationGetQuestionnaireQueryError = ProblemResponseResponse


export function useReservationGetQuestionnaire<TData = Awaited<ReturnType<typeof reservationGetQuestionnaire>>, TError = ProblemResponseResponse>(
 reservationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationGetQuestionnaire>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationGetQuestionnaire>>,
          TError,
          Awaited<ReturnType<typeof reservationGetQuestionnaire>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationGetQuestionnaire<TData = Awaited<ReturnType<typeof reservationGetQuestionnaire>>, TError = ProblemResponseResponse>(
 reservationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationGetQuestionnaire>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationGetQuestionnaire>>,
          TError,
          Awaited<ReturnType<typeof reservationGetQuestionnaire>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationGetQuestionnaire<TData = Awaited<ReturnType<typeof reservationGetQuestionnaire>>, TError = ProblemResponseResponse>(
 reservationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationGetQuestionnaire>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 予約IDに紐づく問診票を取得する
 */

export function useReservationGetQuestionnaire<TData = Awaited<ReturnType<typeof reservationGetQuestionnaire>>, TError = ProblemResponseResponse>(
 reservationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationGetQuestionnaire>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReservationGetQuestionnaireQueryOptions(reservationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type reservationGetLatestPendingDiagnosisByPatientResponse200 = {
  data: ReservationGetLatestPendingDiagnosisByPatient200
  status: 200
}

export type reservationGetLatestPendingDiagnosisByPatientResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type reservationGetLatestPendingDiagnosisByPatientResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type reservationGetLatestPendingDiagnosisByPatientResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type reservationGetLatestPendingDiagnosisByPatientResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type reservationGetLatestPendingDiagnosisByPatientResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type reservationGetLatestPendingDiagnosisByPatientResponseSuccess = (reservationGetLatestPendingDiagnosisByPatientResponse200) & {
  headers: Headers;
};
export type reservationGetLatestPendingDiagnosisByPatientResponseError = (reservationGetLatestPendingDiagnosisByPatientResponse401 | reservationGetLatestPendingDiagnosisByPatientResponse403 | reservationGetLatestPendingDiagnosisByPatientResponse404 | reservationGetLatestPendingDiagnosisByPatientResponse422 | reservationGetLatestPendingDiagnosisByPatientResponse500) & {
  headers: Headers;
};

export type reservationGetLatestPendingDiagnosisByPatientResponse = (reservationGetLatestPendingDiagnosisByPatientResponseSuccess | reservationGetLatestPendingDiagnosisByPatientResponseError)

export const getReservationGetLatestPendingDiagnosisByPatientUrl = (patientId: string,) => {




  return `/reservations/latest-pending-diagnosis/by-patient/${patientId}`
}

/**
 * 指定された患者IDに対して、診断結果が未登録の最新予約を検索します。結果は包装オブジェクトで返却し、`found`（boolean）と `reservation`（見つからない場合は null）を含みます。
 * @summary 特定患者の最新の未診断予約を取得する
 */
export const reservationGetLatestPendingDiagnosisByPatient = async (patientId: string, options?: Parameters<typeof http>[1]): Promise<reservationGetLatestPendingDiagnosisByPatientResponse> => {

  return http<reservationGetLatestPendingDiagnosisByPatientResponse>(getReservationGetLatestPendingDiagnosisByPatientUrl(patientId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReservationGetLatestPendingDiagnosisByPatientQueryKey = (patientId: string,) => {
    return [
    `/reservations/latest-pending-diagnosis/by-patient/${patientId}`
    ] as const;
    }


export const getReservationGetLatestPendingDiagnosisByPatientQueryOptions = <TData = Awaited<ReturnType<typeof reservationGetLatestPendingDiagnosisByPatient>>, TError = ProblemResponseResponse>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationGetLatestPendingDiagnosisByPatient>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReservationGetLatestPendingDiagnosisByPatientQueryKey(patientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reservationGetLatestPendingDiagnosisByPatient>>> = ({ signal }) => reservationGetLatestPendingDiagnosisByPatient(patientId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: patientId !== null && patientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reservationGetLatestPendingDiagnosisByPatient>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReservationGetLatestPendingDiagnosisByPatientQueryResult = NonNullable<Awaited<ReturnType<typeof reservationGetLatestPendingDiagnosisByPatient>>>
export type ReservationGetLatestPendingDiagnosisByPatientQueryError = ProblemResponseResponse


export function useReservationGetLatestPendingDiagnosisByPatient<TData = Awaited<ReturnType<typeof reservationGetLatestPendingDiagnosisByPatient>>, TError = ProblemResponseResponse>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationGetLatestPendingDiagnosisByPatient>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationGetLatestPendingDiagnosisByPatient>>,
          TError,
          Awaited<ReturnType<typeof reservationGetLatestPendingDiagnosisByPatient>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationGetLatestPendingDiagnosisByPatient<TData = Awaited<ReturnType<typeof reservationGetLatestPendingDiagnosisByPatient>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationGetLatestPendingDiagnosisByPatient>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationGetLatestPendingDiagnosisByPatient>>,
          TError,
          Awaited<ReturnType<typeof reservationGetLatestPendingDiagnosisByPatient>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationGetLatestPendingDiagnosisByPatient<TData = Awaited<ReturnType<typeof reservationGetLatestPendingDiagnosisByPatient>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationGetLatestPendingDiagnosisByPatient>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 特定患者の最新の未診断予約を取得する
 */

export function useReservationGetLatestPendingDiagnosisByPatient<TData = Awaited<ReturnType<typeof reservationGetLatestPendingDiagnosisByPatient>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationGetLatestPendingDiagnosisByPatient>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReservationGetLatestPendingDiagnosisByPatientQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type uploadsInitResponse201 = {
  data: UploadInitResponse
  status: 201
}

export type uploadsInitResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type uploadsInitResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type uploadsInitResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type uploadsInitResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type uploadsInitResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type uploadsInitResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type uploadsInitResponseSuccess = (uploadsInitResponse201) & {
  headers: Headers;
};
export type uploadsInitResponseError = (uploadsInitResponse400 | uploadsInitResponse401 | uploadsInitResponse403 | uploadsInitResponse409 | uploadsInitResponse422 | uploadsInitResponse500) & {
  headers: Headers;
};

export type uploadsInitResponse = (uploadsInitResponseSuccess | uploadsInitResponseError)

export const getUploadsInitUrl = () => {




  return `/uploads/init`
}

/**
 * ADRに基づき、Presigned POST（POST Policy）でサイズ・key prefix・Content-Typeを強制します。
 * 認可後にUUIDベースの推測困難なキーを割り当て、短期限の署名付きURLを返却します。
 *
 * RBAC簡易注記:
 * - 許可: `clinic-*`, `patient-admin`, `patient-user`（署名URL初期化の権限）
 * - 用途ごとの制限:
 *   - `insurance_card_pdf`, `id_document_pdf`: `patient-user` のみ（患者本人専用）
 *   - その他: `clinic-*`, `patient-admin`（組織単位）
 * @summary アップロードセッションを初期化し、署名付きURL（POST）を発行する
 */
export const uploadsInit = async (uploadInitRequest: UploadInitRequest, options?: Parameters<typeof http>[1]): Promise<uploadsInitResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<uploadsInitResponse>(getUploadsInitUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(uploadInitRequest)
  }
);}





export const getUploadsInitMutationKey = () => ['uploadsInit'] as const;

export const getUploadsInitMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadsInit>>, TError,UploadsInitMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadsInit>>, TError,UploadsInitMutationVariables, TContext> => {

const mutationKey = getUploadsInitMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadsInit>>, UploadsInitMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  uploadsInit(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadsInitMutationResult = NonNullable<Awaited<ReturnType<typeof uploadsInit>>>
    export type UploadsInitMutationBody = UploadInitRequest
    export type UploadsInitMutationError = ProblemResponseResponse
    export type UploadsInitMutationVariables = {data: UploadInitRequest}

    /**
 * @summary アップロードセッションを初期化し、署名付きURL（POST）を発行する
 */
export const useUploadsInit = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadsInit>>, TError,UploadsInitMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadsInit>>,
        TError,
        UploadsInitMutationVariables,
        TContext
      > => {
      return useMutation(getUploadsInitMutationOptions(options), queryClient);
    }

export type uploadsCompleteResponse200 = {
  data: UploadCompleteResponse
  status: 200
}

export type uploadsCompleteResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type uploadsCompleteResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type uploadsCompleteResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type uploadsCompleteResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type uploadsCompleteResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type uploadsCompleteResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type uploadsCompleteResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type uploadsCompleteResponseSuccess = (uploadsCompleteResponse200) & {
  headers: Headers;
};
export type uploadsCompleteResponseError = (uploadsCompleteResponse400 | uploadsCompleteResponse401 | uploadsCompleteResponse403 | uploadsCompleteResponse404 | uploadsCompleteResponse409 | uploadsCompleteResponse422 | uploadsCompleteResponse500) & {
  headers: Headers;
};

export type uploadsCompleteResponse = (uploadsCompleteResponseSuccess | uploadsCompleteResponseError)

export const getUploadsCompleteUrl = () => {




  return `/uploads/complete`
}

/**
 * HEAD Objectでサイズ/ETag/メタデータを検証し、要件を満たす場合にattachmentsへ確定します。
 *
 * RBAC簡易注記:
 * - 許可: `clinic-*`, `patient-admin`, `patient-user`
 * - アップロード元のセッションに応じた認可チェック:
 *   - 患者専用アップロード（`patients/*\/identity/*`）: `patient-user` 本人のみ
 *   - 組織アップロード: セッション作成時の組織IDと一致するスコープ
 * @summary アップロード完了を通知し、S3実体を検証して確定する
 */
export const uploadsComplete = async (uploadCompleteRequest: UploadCompleteRequest, options?: Parameters<typeof http>[1]): Promise<uploadsCompleteResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<uploadsCompleteResponse>(getUploadsCompleteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(uploadCompleteRequest)
  }
);}





export const getUploadsCompleteMutationKey = () => ['uploadsComplete'] as const;

export const getUploadsCompleteMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadsComplete>>, TError,UploadsCompleteMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadsComplete>>, TError,UploadsCompleteMutationVariables, TContext> => {

const mutationKey = getUploadsCompleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadsComplete>>, UploadsCompleteMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  uploadsComplete(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadsCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof uploadsComplete>>>
    export type UploadsCompleteMutationBody = UploadCompleteRequest
    export type UploadsCompleteMutationError = ProblemResponseResponse
    export type UploadsCompleteMutationVariables = {data: UploadCompleteRequest}

    /**
 * @summary アップロード完了を通知し、S3実体を検証して確定する
 */
export const useUploadsComplete = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadsComplete>>, TError,UploadsCompleteMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadsComplete>>,
        TError,
        UploadsCompleteMutationVariables,
        TContext
      > => {
      return useMutation(getUploadsCompleteMutationOptions(options), queryClient);
    }

export type mediaAccessIssueCookiesResponse204 = {
  data: void
  status: 204
}

export type mediaAccessIssueCookiesResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type mediaAccessIssueCookiesResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type mediaAccessIssueCookiesResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type mediaAccessIssueCookiesResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type mediaAccessIssueCookiesResponse429 = {
  data: ProblemResponseResponse
  status: 429
}

export type mediaAccessIssueCookiesResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type mediaAccessIssueCookiesResponseSuccess = (mediaAccessIssueCookiesResponse204) & {
  headers: Headers;
};
export type mediaAccessIssueCookiesResponseError = (mediaAccessIssueCookiesResponse400 | mediaAccessIssueCookiesResponse401 | mediaAccessIssueCookiesResponse403 | mediaAccessIssueCookiesResponse422 | mediaAccessIssueCookiesResponse429 | mediaAccessIssueCookiesResponse500) & {
  headers: Headers;
};

export type mediaAccessIssueCookiesResponse = (mediaAccessIssueCookiesResponseSuccess | mediaAccessIssueCookiesResponseError)

export const getMediaAccessIssueCookiesUrl = () => {




  return `/media-access/cookies`
}

/**
 * 認証済みユーザーに対して、指定された`resourcePath`向けのCloudFront Signed Cookieを発行します。
 *
 * 主要制約:
 * - Bearer認証必須
 * - `resourcePath` は `/patients/` または `/uploads/` で始まること
 * - `patient-user` の場合は `/patients/{patientId}/...`（本人）または、本人レコードに紐づく `/uploads/...` のみ許可
 * - ユーザー単位のレート制限（60/min）
 * @summary メディア閲覧用のCloudFront Signed Cookieを発行する
 */
export const mediaAccessIssueCookies = async (mediaCookieIssueRequest: MediaCookieIssueRequest, options?: Parameters<typeof http>[1]): Promise<mediaAccessIssueCookiesResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<mediaAccessIssueCookiesResponse>(getMediaAccessIssueCookiesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(mediaCookieIssueRequest)
  }
);}





export const getMediaAccessIssueCookiesMutationKey = () => ['mediaAccessIssueCookies'] as const;

export const getMediaAccessIssueCookiesMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mediaAccessIssueCookies>>, TError,MediaAccessIssueCookiesMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof mediaAccessIssueCookies>>, TError,MediaAccessIssueCookiesMutationVariables, TContext> => {

const mutationKey = getMediaAccessIssueCookiesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mediaAccessIssueCookies>>, MediaAccessIssueCookiesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  mediaAccessIssueCookies(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MediaAccessIssueCookiesMutationResult = NonNullable<Awaited<ReturnType<typeof mediaAccessIssueCookies>>>
    export type MediaAccessIssueCookiesMutationBody = MediaCookieIssueRequest
    export type MediaAccessIssueCookiesMutationError = ProblemResponseResponse
    export type MediaAccessIssueCookiesMutationVariables = {data: MediaCookieIssueRequest}

    /**
 * @summary メディア閲覧用のCloudFront Signed Cookieを発行する
 */
export const useMediaAccessIssueCookies = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mediaAccessIssueCookies>>, TError,MediaAccessIssueCookiesMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mediaAccessIssueCookies>>,
        TError,
        MediaAccessIssueCookiesMutationVariables,
        TContext
      > => {
      return useMutation(getMediaAccessIssueCookiesMutationOptions(options), queryClient);
    }

export type mediaAccessRevokeCookiesResponse204 = {
  data: void
  status: 204
}

export type mediaAccessRevokeCookiesResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type mediaAccessRevokeCookiesResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type mediaAccessRevokeCookiesResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type mediaAccessRevokeCookiesResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type mediaAccessRevokeCookiesResponseSuccess = (mediaAccessRevokeCookiesResponse204) & {
  headers: Headers;
};
export type mediaAccessRevokeCookiesResponseError = (mediaAccessRevokeCookiesResponse400 | mediaAccessRevokeCookiesResponse401 | mediaAccessRevokeCookiesResponse403 | mediaAccessRevokeCookiesResponse500) & {
  headers: Headers;
};

export type mediaAccessRevokeCookiesResponse = (mediaAccessRevokeCookiesResponseSuccess | mediaAccessRevokeCookiesResponseError)

export const getMediaAccessRevokeCookiesUrl = () => {




  return `/media-access/cookies`
}

/**
 * 認証済みユーザーに対して、CloudFront Signed Cookieの失効Cookieを返却します。
 *
 * 主要制約:
 * - Bearer認証必須
 * @summary メディア閲覧用のCloudFront Signed Cookieを失効する
 */
export const mediaAccessRevokeCookies = async ( options?: Parameters<typeof http>[1]): Promise<mediaAccessRevokeCookiesResponse> => {

  return http<mediaAccessRevokeCookiesResponse>(getMediaAccessRevokeCookiesUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getMediaAccessRevokeCookiesMutationKey = () => ['mediaAccessRevokeCookies'] as const;

export const getMediaAccessRevokeCookiesMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mediaAccessRevokeCookies>>, TError,void, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof mediaAccessRevokeCookies>>, TError,void, TContext> => {

const mutationKey = getMediaAccessRevokeCookiesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mediaAccessRevokeCookies>>, void> = () => {


          return  mediaAccessRevokeCookies(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MediaAccessRevokeCookiesMutationResult = NonNullable<Awaited<ReturnType<typeof mediaAccessRevokeCookies>>>

    export type MediaAccessRevokeCookiesMutationError = ProblemResponseResponse


    /**
 * @summary メディア閲覧用のCloudFront Signed Cookieを失効する
 */
export const useMediaAccessRevokeCookies = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mediaAccessRevokeCookies>>, TError,void, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mediaAccessRevokeCookies>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMediaAccessRevokeCookiesMutationOptions(options), queryClient);
    }

export type invoiceCreateInvoiceResponse201 = {
  data: InvoiceCreateResponse
  status: 201
}

export type invoiceCreateInvoiceResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type invoiceCreateInvoiceResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type invoiceCreateInvoiceResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type invoiceCreateInvoiceResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type invoiceCreateInvoiceResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type invoiceCreateInvoiceResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type invoiceCreateInvoiceResponseSuccess = (invoiceCreateInvoiceResponse201) & {
  headers: Headers;
};
export type invoiceCreateInvoiceResponseError = (invoiceCreateInvoiceResponse400 | invoiceCreateInvoiceResponse401 | invoiceCreateInvoiceResponse403 | invoiceCreateInvoiceResponse409 | invoiceCreateInvoiceResponse422 | invoiceCreateInvoiceResponse500) & {
  headers: Headers;
};

export type invoiceCreateInvoiceResponse = (invoiceCreateInvoiceResponseSuccess | invoiceCreateInvoiceResponseError)

export const getInvoiceCreateInvoiceUrl = () => {




  return `/invoices`
}

/**
 * 医療機関から特定の患者に対して請求を登録します。
 * @summary 請求を発行する
 */
export const invoiceCreateInvoice = async (invoiceCreateRequest: InvoiceCreateRequest, options?: Parameters<typeof http>[1]): Promise<invoiceCreateInvoiceResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<invoiceCreateInvoiceResponse>(getInvoiceCreateInvoiceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(invoiceCreateRequest)
  }
);}





export const getInvoiceCreateInvoiceMutationKey = () => ['invoiceCreateInvoice'] as const;

export const getInvoiceCreateInvoiceMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invoiceCreateInvoice>>, TError,InvoiceCreateInvoiceMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof invoiceCreateInvoice>>, TError,InvoiceCreateInvoiceMutationVariables, TContext> => {

const mutationKey = getInvoiceCreateInvoiceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof invoiceCreateInvoice>>, InvoiceCreateInvoiceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  invoiceCreateInvoice(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InvoiceCreateInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof invoiceCreateInvoice>>>
    export type InvoiceCreateInvoiceMutationBody = InvoiceCreateRequest
    export type InvoiceCreateInvoiceMutationError = ProblemResponseResponse
    export type InvoiceCreateInvoiceMutationVariables = {data: InvoiceCreateRequest}

    /**
 * @summary 請求を発行する
 */
export const useInvoiceCreateInvoice = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invoiceCreateInvoice>>, TError,InvoiceCreateInvoiceMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof invoiceCreateInvoice>>,
        TError,
        InvoiceCreateInvoiceMutationVariables,
        TContext
      > => {
      return useMutation(getInvoiceCreateInvoiceMutationOptions(options), queryClient);
    }

export type invoiceGetDetailResponse200 = {
  data: PatientInvoice
  status: 200
}

export type invoiceGetDetailResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type invoiceGetDetailResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type invoiceGetDetailResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type invoiceGetDetailResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type invoiceGetDetailResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type invoiceGetDetailResponseSuccess = (invoiceGetDetailResponse200) & {
  headers: Headers;
};
export type invoiceGetDetailResponseError = (invoiceGetDetailResponse401 | invoiceGetDetailResponse403 | invoiceGetDetailResponse404 | invoiceGetDetailResponse422 | invoiceGetDetailResponse500) & {
  headers: Headers;
};

export type invoiceGetDetailResponse = (invoiceGetDetailResponseSuccess | invoiceGetDetailResponseError)

export const getInvoiceGetDetailUrl = (invoiceId: string,) => {




  return `/invoices/${invoiceId}`
}

/**
 * 請求IDに対応する詳細情報を返します。
 * @summary 請求の詳細情報を取得する
 */
export const invoiceGetDetail = async (invoiceId: string, options?: Parameters<typeof http>[1]): Promise<invoiceGetDetailResponse> => {

  return http<invoiceGetDetailResponse>(getInvoiceGetDetailUrl(invoiceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getInvoiceGetDetailQueryKey = (invoiceId: string,) => {
    return [
    `/invoices/${invoiceId}`
    ] as const;
    }


export const getInvoiceGetDetailQueryOptions = <TData = Awaited<ReturnType<typeof invoiceGetDetail>>, TError = ProblemResponseResponse>(invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceGetDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvoiceGetDetailQueryKey(invoiceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof invoiceGetDetail>>> = ({ signal }) => invoiceGetDetail(invoiceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: invoiceId !== null && invoiceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof invoiceGetDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InvoiceGetDetailQueryResult = NonNullable<Awaited<ReturnType<typeof invoiceGetDetail>>>
export type InvoiceGetDetailQueryError = ProblemResponseResponse


export function useInvoiceGetDetail<TData = Awaited<ReturnType<typeof invoiceGetDetail>>, TError = ProblemResponseResponse>(
 invoiceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceGetDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof invoiceGetDetail>>,
          TError,
          Awaited<ReturnType<typeof invoiceGetDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvoiceGetDetail<TData = Awaited<ReturnType<typeof invoiceGetDetail>>, TError = ProblemResponseResponse>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceGetDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof invoiceGetDetail>>,
          TError,
          Awaited<ReturnType<typeof invoiceGetDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvoiceGetDetail<TData = Awaited<ReturnType<typeof invoiceGetDetail>>, TError = ProblemResponseResponse>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceGetDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 請求の詳細情報を取得する
 */

export function useInvoiceGetDetail<TData = Awaited<ReturnType<typeof invoiceGetDetail>>, TError = ProblemResponseResponse>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceGetDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInvoiceGetDetailQueryOptions(invoiceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type invoiceListCandidatesResponse200 = {
  data: InvoiceListCandidates200
  status: 200
}

export type invoiceListCandidatesResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type invoiceListCandidatesResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type invoiceListCandidatesResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type invoiceListCandidatesResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type invoiceListCandidatesResponseSuccess = (invoiceListCandidatesResponse200) & {
  headers: Headers;
};
export type invoiceListCandidatesResponseError = (invoiceListCandidatesResponse401 | invoiceListCandidatesResponse403 | invoiceListCandidatesResponse422 | invoiceListCandidatesResponse500) & {
  headers: Headers;
};

export type invoiceListCandidatesResponse = (invoiceListCandidatesResponseSuccess | invoiceListCandidatesResponseError)

export const getInvoiceListCandidatesUrl = (params?: InvoiceListCandidatesParams,) => {
  const normalizedParams = new URLSearchParams();
  const deepObjectEntries: string[] = [];

  Object.entries(params || {}).forEach(([key, value]) => {
    const deepObjectParameters = ["patientOrganization"];

    if (typeof value === 'object' && value !== null && !Array.isArray(value) && deepObjectParameters.includes(key)) {
      Object.entries(value).forEach(([subKey, subValue]) => {
        if (subValue !== undefined) {
          deepObjectEntries.push(encodeURIComponent(key) + '[' + encodeURIComponent(subKey) + ']=' + (subValue === null ? 'null' : encodeURIComponent(String(subValue))));
        }
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = [normalizedParams.toString(), deepObjectEntries.join('&')].filter(Boolean).join('&');

  return stringifiedParams.length > 0 ? `/invoices/candidates?${stringifiedParams}` : `/invoices/candidates`
}

/**
 * オンライン診療予約および紹介状依頼を基点に、請求発行に利用できる候補の一覧を返します。
 *
 * UI例（請求情報の一覧）に対応するため、以下のフィルタ/検索をサポートします:
 * - appointmentDateFrom/appointmentDateTo: 診療予約日時の範囲でフィルタします。
 * - nameKana: 患者名（ふりがな）の部分一致検索に使用します。
 * - companyName: 所属企業名の部分一致検索に使用します。
 * - phoneNumber: 電話番号の部分一致検索に使用します。
 * - patientLocalId: 患者識別番号（医療機関独自の番号）の部分一致検索に使用します。
 * - patientOrganization[id|name]: 所属企業フィルタに使用します（deepObject）。
 * - reservationStatus: 予約の状態でフィルタします（例: 診察実施済み、請求処理済み）。
 * - hasIdentityDocument: 本人確認書類の登録有無でフィルタします。
 * - invoiceStatus: 請求状況でフィルタします（NOT_BILLED/ISSUED/PAID/REISSUED/CANCELLED）。
 * @summary 請求候補の一覧を取得する
 */
export const invoiceListCandidates = async (params?: InvoiceListCandidatesParams, options?: Parameters<typeof http>[1]): Promise<invoiceListCandidatesResponse> => {

  return http<invoiceListCandidatesResponse>(getInvoiceListCandidatesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getInvoiceListCandidatesQueryKey = (params?: InvoiceListCandidatesParams,) => {
    return [
    `/invoices/candidates`, ...(params ? [params] : [])
    ] as const;
    }


export const getInvoiceListCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof invoiceListCandidates>>, TError = ProblemResponseResponse>(params?: InvoiceListCandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceListCandidates>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvoiceListCandidatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof invoiceListCandidates>>> = ({ signal }) => invoiceListCandidates(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof invoiceListCandidates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InvoiceListCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof invoiceListCandidates>>>
export type InvoiceListCandidatesQueryError = ProblemResponseResponse


export function useInvoiceListCandidates<TData = Awaited<ReturnType<typeof invoiceListCandidates>>, TError = ProblemResponseResponse>(
 params: undefined |  InvoiceListCandidatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceListCandidates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof invoiceListCandidates>>,
          TError,
          Awaited<ReturnType<typeof invoiceListCandidates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvoiceListCandidates<TData = Awaited<ReturnType<typeof invoiceListCandidates>>, TError = ProblemResponseResponse>(
 params?: InvoiceListCandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceListCandidates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof invoiceListCandidates>>,
          TError,
          Awaited<ReturnType<typeof invoiceListCandidates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvoiceListCandidates<TData = Awaited<ReturnType<typeof invoiceListCandidates>>, TError = ProblemResponseResponse>(
 params?: InvoiceListCandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceListCandidates>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 請求候補の一覧を取得する
 */

export function useInvoiceListCandidates<TData = Awaited<ReturnType<typeof invoiceListCandidates>>, TError = ProblemResponseResponse>(
 params?: InvoiceListCandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceListCandidates>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInvoiceListCandidatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type paymentGetProfileStatusResponse200 = {
  data: PaymentProfileStatusResponse
  status: 200
}

export type paymentGetProfileStatusResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type paymentGetProfileStatusResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type paymentGetProfileStatusResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type paymentGetProfileStatusResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type paymentGetProfileStatusResponseSuccess = (paymentGetProfileStatusResponse200) & {
  headers: Headers;
};
export type paymentGetProfileStatusResponseError = (paymentGetProfileStatusResponse401 | paymentGetProfileStatusResponse403 | paymentGetProfileStatusResponse409 | paymentGetProfileStatusResponse500) & {
  headers: Headers;
};

export type paymentGetProfileStatusResponse = (paymentGetProfileStatusResponseSuccess | paymentGetProfileStatusResponseError)

export const getPaymentGetProfileStatusUrl = () => {




  return `/payments/profile/status`
}

/**
 * 認証済み患者の支払いプロファイル状態を返します。
 * 予約導線の活性/非活性判定に利用します。
 * @summary 支払いプロファイル状態を取得する
 */
export const paymentGetProfileStatus = async ( options?: Parameters<typeof http>[1]): Promise<paymentGetProfileStatusResponse> => {

  return http<paymentGetProfileStatusResponse>(getPaymentGetProfileStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPaymentGetProfileStatusQueryKey = () => {
    return [
    `/payments/profile/status`
    ] as const;
    }


export const getPaymentGetProfileStatusQueryOptions = <TData = Awaited<ReturnType<typeof paymentGetProfileStatus>>, TError = ProblemResponseResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentGetProfileStatus>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPaymentGetProfileStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentGetProfileStatus>>> = ({ signal }) => paymentGetProfileStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof paymentGetProfileStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PaymentGetProfileStatusQueryResult = NonNullable<Awaited<ReturnType<typeof paymentGetProfileStatus>>>
export type PaymentGetProfileStatusQueryError = ProblemResponseResponse


export function usePaymentGetProfileStatus<TData = Awaited<ReturnType<typeof paymentGetProfileStatus>>, TError = ProblemResponseResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentGetProfileStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof paymentGetProfileStatus>>,
          TError,
          Awaited<ReturnType<typeof paymentGetProfileStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentGetProfileStatus<TData = Awaited<ReturnType<typeof paymentGetProfileStatus>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentGetProfileStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof paymentGetProfileStatus>>,
          TError,
          Awaited<ReturnType<typeof paymentGetProfileStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentGetProfileStatus<TData = Awaited<ReturnType<typeof paymentGetProfileStatus>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentGetProfileStatus>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 支払いプロファイル状態を取得する
 */

export function usePaymentGetProfileStatus<TData = Awaited<ReturnType<typeof paymentGetProfileStatus>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentGetProfileStatus>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPaymentGetProfileStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type paymentUpdateProfileChannelResponse200 = {
  data: PaymentProfileChannelUpdateResponse
  status: 200
}

export type paymentUpdateProfileChannelResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type paymentUpdateProfileChannelResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type paymentUpdateProfileChannelResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type paymentUpdateProfileChannelResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type paymentUpdateProfileChannelResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type paymentUpdateProfileChannelResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type paymentUpdateProfileChannelResponseSuccess = (paymentUpdateProfileChannelResponse200) & {
  headers: Headers;
};
export type paymentUpdateProfileChannelResponseError = (paymentUpdateProfileChannelResponse400 | paymentUpdateProfileChannelResponse401 | paymentUpdateProfileChannelResponse403 | paymentUpdateProfileChannelResponse409 | paymentUpdateProfileChannelResponse422 | paymentUpdateProfileChannelResponse500) & {
  headers: Headers;
};

export type paymentUpdateProfileChannelResponse = (paymentUpdateProfileChannelResponseSuccess | paymentUpdateProfileChannelResponseError)

export const getPaymentUpdateProfileChannelUrl = () => {




  return `/payments/profile/channel`
}

/**
 * 認証済み患者の既定支払いチャネルを更新します。
 * `409` は CARD選択時の前提未充足、または同時更新競合で返る場合があります。
 * @summary 既定支払いチャネルを更新する
 */
export const paymentUpdateProfileChannel = async (paymentProfileChannelUpdateRequest: PaymentProfileChannelUpdateRequest, options?: Parameters<typeof http>[1]): Promise<paymentUpdateProfileChannelResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<paymentUpdateProfileChannelResponse>(getPaymentUpdateProfileChannelUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(paymentProfileChannelUpdateRequest)
  }
);}





export const getPaymentUpdateProfileChannelMutationKey = () => ['paymentUpdateProfileChannel'] as const;

export const getPaymentUpdateProfileChannelMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentUpdateProfileChannel>>, TError,PaymentUpdateProfileChannelMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof paymentUpdateProfileChannel>>, TError,PaymentUpdateProfileChannelMutationVariables, TContext> => {

const mutationKey = getPaymentUpdateProfileChannelMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof paymentUpdateProfileChannel>>, PaymentUpdateProfileChannelMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  paymentUpdateProfileChannel(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PaymentUpdateProfileChannelMutationResult = NonNullable<Awaited<ReturnType<typeof paymentUpdateProfileChannel>>>
    export type PaymentUpdateProfileChannelMutationBody = PaymentProfileChannelUpdateRequest
    export type PaymentUpdateProfileChannelMutationError = ProblemResponseResponse
    export type PaymentUpdateProfileChannelMutationVariables = {data: PaymentProfileChannelUpdateRequest}

    /**
 * @summary 既定支払いチャネルを更新する
 */
export const usePaymentUpdateProfileChannel = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentUpdateProfileChannel>>, TError,PaymentUpdateProfileChannelMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof paymentUpdateProfileChannel>>,
        TError,
        PaymentUpdateProfileChannelMutationVariables,
        TContext
      > => {
      return useMutation(getPaymentUpdateProfileChannelMutationOptions(options), queryClient);
    }

export type paymentEnsureCustomerResponse200 = {
  data: PaymentCustomerEnsureResponse
  status: 200
}

export type paymentEnsureCustomerResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type paymentEnsureCustomerResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type paymentEnsureCustomerResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type paymentEnsureCustomerResponse502 = {
  data: ProblemResponseResponse
  status: 502
}

export type paymentEnsureCustomerResponse503 = {
  data: ProblemResponseResponse
  status: 503
}

export type paymentEnsureCustomerResponseSuccess = (paymentEnsureCustomerResponse200) & {
  headers: Headers;
};
export type paymentEnsureCustomerResponseError = (paymentEnsureCustomerResponse401 | paymentEnsureCustomerResponse403 | paymentEnsureCustomerResponse500 | paymentEnsureCustomerResponse502 | paymentEnsureCustomerResponse503) & {
  headers: Headers;
};

export type paymentEnsureCustomerResponse = (paymentEnsureCustomerResponseSuccess | paymentEnsureCustomerResponseError)

export const getPaymentEnsureCustomerUrl = () => {




  return `/payments/customers/ensure`
}

/**
 * 認証済み患者に紐づくGMO会員を照会し、未作成の場合は作成します。
 * @summary GMO会員を確立する
 */
export const paymentEnsureCustomer = async ( options?: Parameters<typeof http>[1]): Promise<paymentEnsureCustomerResponse> => {

  return http<paymentEnsureCustomerResponse>(getPaymentEnsureCustomerUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPaymentEnsureCustomerMutationKey = () => ['paymentEnsureCustomer'] as const;

export const getPaymentEnsureCustomerMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentEnsureCustomer>>, TError,void, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof paymentEnsureCustomer>>, TError,void, TContext> => {

const mutationKey = getPaymentEnsureCustomerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof paymentEnsureCustomer>>, void> = () => {


          return  paymentEnsureCustomer(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PaymentEnsureCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof paymentEnsureCustomer>>>

    export type PaymentEnsureCustomerMutationError = ProblemResponseResponse


    /**
 * @summary GMO会員を確立する
 */
export const usePaymentEnsureCustomer = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentEnsureCustomer>>, TError,void, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof paymentEnsureCustomer>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPaymentEnsureCustomerMutationOptions(options), queryClient);
    }

export type paymentUpsertCardResponse200 = {
  data: PaymentCardUpsertResponse
  status: 200
}

export type paymentUpsertCardResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type paymentUpsertCardResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type paymentUpsertCardResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type paymentUpsertCardResponse404 = {
  data: ProblemResponse
  status: 404
}

export type paymentUpsertCardResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type paymentUpsertCardResponse422 = {
  data: ProblemResponse
  status: 422
}

export type paymentUpsertCardResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type paymentUpsertCardResponse503 = {
  data: ProblemResponseResponse
  status: 503
}

export type paymentUpsertCardResponseSuccess = (paymentUpsertCardResponse200) & {
  headers: Headers;
};
export type paymentUpsertCardResponseError = (paymentUpsertCardResponse400 | paymentUpsertCardResponse401 | paymentUpsertCardResponse403 | paymentUpsertCardResponse404 | paymentUpsertCardResponse409 | paymentUpsertCardResponse422 | paymentUpsertCardResponse500 | paymentUpsertCardResponse503) & {
  headers: Headers;
};

export type paymentUpsertCardResponse = (paymentUpsertCardResponseSuccess | paymentUpsertCardResponseError)

export const getPaymentUpsertCardUrl = () => {




  return `/payments/cards`
}

/**
 * MpToken.jsで生成されたカードトークンを用いて、認証済み患者のカード情報を保存/更新します。
 * @summary カード情報を保存または更新する
 */
export const paymentUpsertCard = async (paymentCardUpsertRequest: PaymentCardUpsertRequest, options?: Parameters<typeof http>[1]): Promise<paymentUpsertCardResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<paymentUpsertCardResponse>(getPaymentUpsertCardUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(paymentCardUpsertRequest)
  }
);}





export const getPaymentUpsertCardMutationKey = () => ['paymentUpsertCard'] as const;

export const getPaymentUpsertCardMutationOptions = <TError = ProblemResponseResponse | ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentUpsertCard>>, TError,PaymentUpsertCardMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof paymentUpsertCard>>, TError,PaymentUpsertCardMutationVariables, TContext> => {

const mutationKey = getPaymentUpsertCardMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof paymentUpsertCard>>, PaymentUpsertCardMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  paymentUpsertCard(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PaymentUpsertCardMutationResult = NonNullable<Awaited<ReturnType<typeof paymentUpsertCard>>>
    export type PaymentUpsertCardMutationBody = PaymentCardUpsertRequest
    export type PaymentUpsertCardMutationError = ProblemResponseResponse | ProblemResponse
    export type PaymentUpsertCardMutationVariables = {data: PaymentCardUpsertRequest}

    /**
 * @summary カード情報を保存または更新する
 */
export const usePaymentUpsertCard = <TError = ProblemResponseResponse | ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentUpsertCard>>, TError,PaymentUpsertCardMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof paymentUpsertCard>>,
        TError,
        PaymentUpsertCardMutationVariables,
        TContext
      > => {
      return useMutation(getPaymentUpsertCardMutationOptions(options), queryClient);
    }

export type paymentRetryCardChargeResponse200 = {
  data: PaymentCardRetryResponse
  status: 200
}

export type paymentRetryCardChargeResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type paymentRetryCardChargeResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type paymentRetryCardChargeResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type paymentRetryCardChargeResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type paymentRetryCardChargeResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type paymentRetryCardChargeResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type paymentRetryCardChargeResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type paymentRetryCardChargeResponse502 = {
  data: ProblemResponseResponse
  status: 502
}

export type paymentRetryCardChargeResponse503 = {
  data: ProblemResponseResponse
  status: 503
}

export type paymentRetryCardChargeResponseSuccess = (paymentRetryCardChargeResponse200) & {
  headers: Headers;
};
export type paymentRetryCardChargeResponseError = (paymentRetryCardChargeResponse400 | paymentRetryCardChargeResponse401 | paymentRetryCardChargeResponse403 | paymentRetryCardChargeResponse404 | paymentRetryCardChargeResponse409 | paymentRetryCardChargeResponse422 | paymentRetryCardChargeResponse500 | paymentRetryCardChargeResponse502 | paymentRetryCardChargeResponse503) & {
  headers: Headers;
};

export type paymentRetryCardChargeResponse = (paymentRetryCardChargeResponseSuccess | paymentRetryCardChargeResponseError)

export const getPaymentRetryCardChargeUrl = () => {




  return `/payments/cards/retry`
}

/**
 * カードトークン更新と、指定請求に対する再課金起点を一体で実行します。
 * 同一請求に対する重複実行は冪等に扱い、重複起票を防止します。
 * @summary カード更新と再課金起点を実行する
 */
export const paymentRetryCardCharge = async (paymentCardRetryRequest: PaymentCardRetryRequest, options?: Parameters<typeof http>[1]): Promise<paymentRetryCardChargeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<paymentRetryCardChargeResponse>(getPaymentRetryCardChargeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(paymentCardRetryRequest)
  }
);}





export const getPaymentRetryCardChargeMutationKey = () => ['paymentRetryCardCharge'] as const;

export const getPaymentRetryCardChargeMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentRetryCardCharge>>, TError,PaymentRetryCardChargeMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof paymentRetryCardCharge>>, TError,PaymentRetryCardChargeMutationVariables, TContext> => {

const mutationKey = getPaymentRetryCardChargeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof paymentRetryCardCharge>>, PaymentRetryCardChargeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  paymentRetryCardCharge(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PaymentRetryCardChargeMutationResult = NonNullable<Awaited<ReturnType<typeof paymentRetryCardCharge>>>
    export type PaymentRetryCardChargeMutationBody = PaymentCardRetryRequest
    export type PaymentRetryCardChargeMutationError = ProblemResponseResponse
    export type PaymentRetryCardChargeMutationVariables = {data: PaymentCardRetryRequest}

    /**
 * @summary カード更新と再課金起点を実行する
 */
export const usePaymentRetryCardCharge = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentRetryCardCharge>>, TError,PaymentRetryCardChargeMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof paymentRetryCardCharge>>,
        TError,
        PaymentRetryCardChargeMutationVariables,
        TContext
      > => {
      return useMutation(getPaymentRetryCardChargeMutationOptions(options), queryClient);
    }

export type paymentSwitchChannelResponse200 = {
  data: PaymentChannelSwitchResponse
  status: 200
}

export type paymentSwitchChannelResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type paymentSwitchChannelResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type paymentSwitchChannelResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type paymentSwitchChannelResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type paymentSwitchChannelResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type paymentSwitchChannelResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type paymentSwitchChannelResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type paymentSwitchChannelResponse502 = {
  data: ProblemResponseResponse
  status: 502
}

export type paymentSwitchChannelResponse503 = {
  data: ProblemResponseResponse
  status: 503
}

export type paymentSwitchChannelResponseSuccess = (paymentSwitchChannelResponse200) & {
  headers: Headers;
};
export type paymentSwitchChannelResponseError = (paymentSwitchChannelResponse400 | paymentSwitchChannelResponse401 | paymentSwitchChannelResponse403 | paymentSwitchChannelResponse404 | paymentSwitchChannelResponse409 | paymentSwitchChannelResponse422 | paymentSwitchChannelResponse500 | paymentSwitchChannelResponse502 | paymentSwitchChannelResponse503) & {
  headers: Headers;
};

export type paymentSwitchChannelResponse = (paymentSwitchChannelResponseSuccess | paymentSwitchChannelResponseError)

export const getPaymentSwitchChannelUrl = () => {




  return `/payments/channels/switch`
}

/**
 * 請求単位で、カード/コンビニのチャネルを切り替えて新しい支払い試行を作成します。
 * @summary 同一請求内で支払いチャネルを切り替える
 */
export const paymentSwitchChannel = async (paymentChannelSwitchRequest: PaymentChannelSwitchRequest, options?: Parameters<typeof http>[1]): Promise<paymentSwitchChannelResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<paymentSwitchChannelResponse>(getPaymentSwitchChannelUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(paymentChannelSwitchRequest)
  }
);}





export const getPaymentSwitchChannelMutationKey = () => ['paymentSwitchChannel'] as const;

export const getPaymentSwitchChannelMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentSwitchChannel>>, TError,PaymentSwitchChannelMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof paymentSwitchChannel>>, TError,PaymentSwitchChannelMutationVariables, TContext> => {

const mutationKey = getPaymentSwitchChannelMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof paymentSwitchChannel>>, PaymentSwitchChannelMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  paymentSwitchChannel(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PaymentSwitchChannelMutationResult = NonNullable<Awaited<ReturnType<typeof paymentSwitchChannel>>>
    export type PaymentSwitchChannelMutationBody = PaymentChannelSwitchRequest
    export type PaymentSwitchChannelMutationError = ProblemResponseResponse
    export type PaymentSwitchChannelMutationVariables = {data: PaymentChannelSwitchRequest}

    /**
 * @summary 同一請求内で支払いチャネルを切り替える
 */
export const usePaymentSwitchChannel = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentSwitchChannel>>, TError,PaymentSwitchChannelMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof paymentSwitchChannel>>,
        TError,
        PaymentSwitchChannelMutationVariables,
        TContext
      > => {
      return useMutation(getPaymentSwitchChannelMutationOptions(options), queryClient);
    }

export type paymentHandleGmoWebhookResponse204 = {
  data: void
  status: 204
}

export type paymentHandleGmoWebhookResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type paymentHandleGmoWebhookResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type paymentHandleGmoWebhookResponseSuccess = (paymentHandleGmoWebhookResponse204) & {
  headers: Headers;
};
export type paymentHandleGmoWebhookResponseError = (paymentHandleGmoWebhookResponse401 | paymentHandleGmoWebhookResponse422) & {
  headers: Headers;
};

export type paymentHandleGmoWebhookResponse = (paymentHandleGmoWebhookResponseSuccess | paymentHandleGmoWebhookResponseError)

export const getPaymentHandleGmoWebhookUrl = () => {




  return `/payments/webhooks/gmo`
}

/**
 * GMOからの決済通知を受信して反映します。
 * 認証はBearerではなく、ペイロード内トークン検証で行います。
 * 正常処理時はレスポンスボディなしの2xxを返します。
 * 2xx以外を返した場合はGMO側で再送されます（最大5回、初期間隔60分）。
 * @summary GMO Webhookを受信する
 */
export const paymentHandleGmoWebhook = async (paymentWebhookGmoRequest: PaymentWebhookGmoRequest, options?: Parameters<typeof http>[1]): Promise<paymentHandleGmoWebhookResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<paymentHandleGmoWebhookResponse>(getPaymentHandleGmoWebhookUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(paymentWebhookGmoRequest)
  }
);}





export const getPaymentHandleGmoWebhookMutationKey = () => ['paymentHandleGmoWebhook'] as const;

export const getPaymentHandleGmoWebhookMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentHandleGmoWebhook>>, TError,PaymentHandleGmoWebhookMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof paymentHandleGmoWebhook>>, TError,PaymentHandleGmoWebhookMutationVariables, TContext> => {

const mutationKey = getPaymentHandleGmoWebhookMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof paymentHandleGmoWebhook>>, PaymentHandleGmoWebhookMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  paymentHandleGmoWebhook(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PaymentHandleGmoWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof paymentHandleGmoWebhook>>>
    export type PaymentHandleGmoWebhookMutationBody = PaymentWebhookGmoRequest
    export type PaymentHandleGmoWebhookMutationError = ProblemResponseResponse
    export type PaymentHandleGmoWebhookMutationVariables = {data: PaymentWebhookGmoRequest}

    /**
 * @summary GMO Webhookを受信する
 */
export const usePaymentHandleGmoWebhook = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentHandleGmoWebhook>>, TError,PaymentHandleGmoWebhookMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof paymentHandleGmoWebhook>>,
        TError,
        PaymentHandleGmoWebhookMutationVariables,
        TContext
      > => {
      return useMutation(getPaymentHandleGmoWebhookMutationOptions(options), queryClient);
    }

export type paymentHandleGmoCallbackResponse302 = {
  data: void
  status: 302
}

export type paymentHandleGmoCallbackResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

;
export type paymentHandleGmoCallbackResponseError = (paymentHandleGmoCallbackResponse302 | paymentHandleGmoCallbackResponse400) & {
  headers: Headers;
};

export type paymentHandleGmoCallbackResponse = (paymentHandleGmoCallbackResponseError)

export const getPaymentHandleGmoCallbackUrl = (params: PaymentHandleGmoCallbackParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/payments/callback/gmo?${stringifiedParams}` : `/payments/callback/gmo`
}

/**
 * GMO 3DS callbackのpayloadを検証し、結果画面へリダイレクトします。
 * 本エンドポイントは最終決済状態を確定しません。
 * payloadには `accessId` / `event` / `csrfToken` を含む想定です。
 * 同一payloadの重複到達は冪等に扱います。
 *
 * リダイレクト先URLに以下のクエリパラメータを付与します:
 * - `status`: `SUCCESS` | `pending` | `FAILED`
 * - `context`: `card`（カード登録3DSの場合のみ付与。省略時は再課金3DS）
 * @summary GMO 3DS callbackを受信して画面遷移する
 */
export const paymentHandleGmoCallback = async (params: PaymentHandleGmoCallbackParams, options?: Parameters<typeof http>[1]): Promise<paymentHandleGmoCallbackResponse> => {

  return http<paymentHandleGmoCallbackResponse>(getPaymentHandleGmoCallbackUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPaymentHandleGmoCallbackQueryKey = (params?: PaymentHandleGmoCallbackParams,) => {
    return [
    `/payments/callback/gmo`, ...(params ? [params] : [])
    ] as const;
    }


export const getPaymentHandleGmoCallbackQueryOptions = <TData = Awaited<ReturnType<typeof paymentHandleGmoCallback>>, TError = void | ProblemResponseResponse>(params: PaymentHandleGmoCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentHandleGmoCallback>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPaymentHandleGmoCallbackQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentHandleGmoCallback>>> = ({ signal }) => paymentHandleGmoCallback(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof paymentHandleGmoCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PaymentHandleGmoCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof paymentHandleGmoCallback>>>
export type PaymentHandleGmoCallbackQueryError = void | ProblemResponseResponse


export function usePaymentHandleGmoCallback<TData = Awaited<ReturnType<typeof paymentHandleGmoCallback>>, TError = void | ProblemResponseResponse>(
 params: PaymentHandleGmoCallbackParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentHandleGmoCallback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof paymentHandleGmoCallback>>,
          TError,
          Awaited<ReturnType<typeof paymentHandleGmoCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentHandleGmoCallback<TData = Awaited<ReturnType<typeof paymentHandleGmoCallback>>, TError = void | ProblemResponseResponse>(
 params: PaymentHandleGmoCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentHandleGmoCallback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof paymentHandleGmoCallback>>,
          TError,
          Awaited<ReturnType<typeof paymentHandleGmoCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentHandleGmoCallback<TData = Awaited<ReturnType<typeof paymentHandleGmoCallback>>, TError = void | ProblemResponseResponse>(
 params: PaymentHandleGmoCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentHandleGmoCallback>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary GMO 3DS callbackを受信して画面遷移する
 */

export function usePaymentHandleGmoCallback<TData = Awaited<ReturnType<typeof paymentHandleGmoCallback>>, TError = void | ProblemResponseResponse>(
 params: PaymentHandleGmoCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentHandleGmoCallback>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPaymentHandleGmoCallbackQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type paymentCancelInvoiceResponse200 = {
  data: PaymentInvoiceCancelResponse
  status: 200
}

export type paymentCancelInvoiceResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type paymentCancelInvoiceResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type paymentCancelInvoiceResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type paymentCancelInvoiceResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type paymentCancelInvoiceResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type paymentCancelInvoiceResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type paymentCancelInvoiceResponse502 = {
  data: ProblemResponseResponse
  status: 502
}

export type paymentCancelInvoiceResponse503 = {
  data: ProblemResponseResponse
  status: 503
}

export type paymentCancelInvoiceResponseSuccess = (paymentCancelInvoiceResponse200) & {
  headers: Headers;
};
export type paymentCancelInvoiceResponseError = (paymentCancelInvoiceResponse401 | paymentCancelInvoiceResponse403 | paymentCancelInvoiceResponse404 | paymentCancelInvoiceResponse409 | paymentCancelInvoiceResponse422 | paymentCancelInvoiceResponse500 | paymentCancelInvoiceResponse502 | paymentCancelInvoiceResponse503) & {
  headers: Headers;
};

export type paymentCancelInvoiceResponse = (paymentCancelInvoiceResponseSuccess | paymentCancelInvoiceResponseError)

export const getPaymentCancelInvoiceUrl = (invoiceId: string,) => {




  return `/payments/invoices/${invoiceId}/cancel`
}

/**
 * 請求をキャンセルし、必要に応じてGMO `/order/cancel` を実行します。
 * 企業請求はSAS内部状態のみ更新します。
 * @summary 請求をキャンセルする
 */
export const paymentCancelInvoice = async (invoiceId: string,
    paymentInvoiceCancelRequest: PaymentInvoiceCancelRequest, options?: Parameters<typeof http>[1]): Promise<paymentCancelInvoiceResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<paymentCancelInvoiceResponse>(getPaymentCancelInvoiceUrl(invoiceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(paymentInvoiceCancelRequest)
  }
);}





export const getPaymentCancelInvoiceMutationKey = () => ['paymentCancelInvoice'] as const;

export const getPaymentCancelInvoiceMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentCancelInvoice>>, TError,PaymentCancelInvoiceMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof paymentCancelInvoice>>, TError,PaymentCancelInvoiceMutationVariables, TContext> => {

const mutationKey = getPaymentCancelInvoiceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof paymentCancelInvoice>>, PaymentCancelInvoiceMutationVariables> = (props) => {
          const {invoiceId,data} = props ?? {};

          return  paymentCancelInvoice(invoiceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PaymentCancelInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof paymentCancelInvoice>>>
    export type PaymentCancelInvoiceMutationBody = PaymentInvoiceCancelRequest
    export type PaymentCancelInvoiceMutationError = ProblemResponseResponse
    export type PaymentCancelInvoiceMutationVariables = {invoiceId: string;data: PaymentInvoiceCancelRequest}

    /**
 * @summary 請求をキャンセルする
 */
export const usePaymentCancelInvoice = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentCancelInvoice>>, TError,PaymentCancelInvoiceMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof paymentCancelInvoice>>,
        TError,
        PaymentCancelInvoiceMutationVariables,
        TContext
      > => {
      return useMutation(getPaymentCancelInvoiceMutationOptions(options), queryClient);
    }

export type clinicListClinicsResponse200 = {
  data: ClinicListClinics200
  status: 200
}

export type clinicListClinicsResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type clinicListClinicsResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type clinicListClinicsResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type clinicListClinicsResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type clinicListClinicsResponseSuccess = (clinicListClinicsResponse200) & {
  headers: Headers;
};
export type clinicListClinicsResponseError = (clinicListClinicsResponse401 | clinicListClinicsResponse403 | clinicListClinicsResponse422 | clinicListClinicsResponse500) & {
  headers: Headers;
};

export type clinicListClinicsResponse = (clinicListClinicsResponseSuccess | clinicListClinicsResponseError)

export const getClinicListClinicsUrl = (params?: ClinicListClinicsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/clinics?${stringifiedParams}` : `/clinics`
}

/**
 * 認証済みユーザーの権限に応じた医療機関（クリニック）一覧を返します。
 * 認証済みユーザーがオペレーター権限を持つ場合、
 * - supportsCpapパラメーターを指定しないもしくはfalseの場合、すべての医療機関一覧を返します。
 * - supportsCpapパラメーターをtrueに指定した場合、CPAP治療を提供する医療機関一覧を返します。
 *
 * 認証済みユーザーが患者権限を持つ場合、
 * - supportsCpapパラメーターの指定有無に関わらず、CPAP治療を提供する医療機関一覧を返します。
 *
 * オプションのフリー検索:
 * - nameKana: 医療機関名（ふりがな）の部分一致検索に使用します。
 * - phoneNumber: 電話番号の部分一致検索に使用します。
 * - prefecture: 都道府県での絞り込みに使用します。
 * @summary 医療機関一覧を取得する
 */
export const clinicListClinics = async (params?: ClinicListClinicsParams, options?: Parameters<typeof http>[1]): Promise<clinicListClinicsResponse> => {

  return http<clinicListClinicsResponse>(getClinicListClinicsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getClinicListClinicsQueryKey = (params?: ClinicListClinicsParams,) => {
    return [
    `/clinics`, ...(params ? [params] : [])
    ] as const;
    }


export const getClinicListClinicsQueryOptions = <TData = Awaited<ReturnType<typeof clinicListClinics>>, TError = ProblemResponseResponse>(params?: ClinicListClinicsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicListClinics>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicListClinicsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicListClinics>>> = ({ signal }) => clinicListClinics(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicListClinics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClinicListClinicsQueryResult = NonNullable<Awaited<ReturnType<typeof clinicListClinics>>>
export type ClinicListClinicsQueryError = ProblemResponseResponse


export function useClinicListClinics<TData = Awaited<ReturnType<typeof clinicListClinics>>, TError = ProblemResponseResponse>(
 params: undefined |  ClinicListClinicsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicListClinics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicListClinics>>,
          TError,
          Awaited<ReturnType<typeof clinicListClinics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicListClinics<TData = Awaited<ReturnType<typeof clinicListClinics>>, TError = ProblemResponseResponse>(
 params?: ClinicListClinicsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicListClinics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicListClinics>>,
          TError,
          Awaited<ReturnType<typeof clinicListClinics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicListClinics<TData = Awaited<ReturnType<typeof clinicListClinics>>, TError = ProblemResponseResponse>(
 params?: ClinicListClinicsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicListClinics>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 医療機関一覧を取得する
 */

export function useClinicListClinics<TData = Awaited<ReturnType<typeof clinicListClinics>>, TError = ProblemResponseResponse>(
 params?: ClinicListClinicsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicListClinics>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClinicListClinicsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type clinicListForPatientsResponse200 = {
  data: ClinicListForPatients200
  status: 200
}

export type clinicListForPatientsResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type clinicListForPatientsResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type clinicListForPatientsResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type clinicListForPatientsResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type clinicListForPatientsResponseSuccess = (clinicListForPatientsResponse200) & {
  headers: Headers;
};
export type clinicListForPatientsResponseError = (clinicListForPatientsResponse401 | clinicListForPatientsResponse403 | clinicListForPatientsResponse422 | clinicListForPatientsResponse500) & {
  headers: Headers;
};

export type clinicListForPatientsResponse = (clinicListForPatientsResponseSuccess | clinicListForPatientsResponseError)

export const getClinicListForPatientsUrl = (params?: ClinicListForPatientsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/clinics/for-patients?${stringifiedParams}` : `/clinics/for-patients`
}

/**
 * 患者向けの医療機関一覧を返します。
 * このAPIは patient-user の利用を想定し、CPAP対応の医療機関のみを返します。
 *
 * オプション検索:
 * - prefecture: 都道府県での絞り込み
 * - supportsOnline: オンライン診療対応可での絞り込み
 * @summary 患者向け医療機関一覧を取得する
 */
export const clinicListForPatients = async (params?: ClinicListForPatientsParams, options?: Parameters<typeof http>[1]): Promise<clinicListForPatientsResponse> => {

  return http<clinicListForPatientsResponse>(getClinicListForPatientsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getClinicListForPatientsQueryKey = (params?: ClinicListForPatientsParams,) => {
    return [
    `/clinics/for-patients`, ...(params ? [params] : [])
    ] as const;
    }


export const getClinicListForPatientsQueryOptions = <TData = Awaited<ReturnType<typeof clinicListForPatients>>, TError = ProblemResponseResponse>(params?: ClinicListForPatientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicListForPatients>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicListForPatientsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicListForPatients>>> = ({ signal }) => clinicListForPatients(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicListForPatients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClinicListForPatientsQueryResult = NonNullable<Awaited<ReturnType<typeof clinicListForPatients>>>
export type ClinicListForPatientsQueryError = ProblemResponseResponse


export function useClinicListForPatients<TData = Awaited<ReturnType<typeof clinicListForPatients>>, TError = ProblemResponseResponse>(
 params: undefined |  ClinicListForPatientsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicListForPatients>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicListForPatients>>,
          TError,
          Awaited<ReturnType<typeof clinicListForPatients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicListForPatients<TData = Awaited<ReturnType<typeof clinicListForPatients>>, TError = ProblemResponseResponse>(
 params?: ClinicListForPatientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicListForPatients>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicListForPatients>>,
          TError,
          Awaited<ReturnType<typeof clinicListForPatients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicListForPatients<TData = Awaited<ReturnType<typeof clinicListForPatients>>, TError = ProblemResponseResponse>(
 params?: ClinicListForPatientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicListForPatients>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者向け医療機関一覧を取得する
 */

export function useClinicListForPatients<TData = Awaited<ReturnType<typeof clinicListForPatients>>, TError = ProblemResponseResponse>(
 params?: ClinicListForPatientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicListForPatients>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClinicListForPatientsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type clinicGetForPatientDetailResponse200 = {
  data: ClinicForPatientDetail
  status: 200
}

export type clinicGetForPatientDetailResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type clinicGetForPatientDetailResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type clinicGetForPatientDetailResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type clinicGetForPatientDetailResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type clinicGetForPatientDetailResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type clinicGetForPatientDetailResponseSuccess = (clinicGetForPatientDetailResponse200) & {
  headers: Headers;
};
export type clinicGetForPatientDetailResponseError = (clinicGetForPatientDetailResponse401 | clinicGetForPatientDetailResponse403 | clinicGetForPatientDetailResponse404 | clinicGetForPatientDetailResponse422 | clinicGetForPatientDetailResponse500) & {
  headers: Headers;
};

export type clinicGetForPatientDetailResponse = (clinicGetForPatientDetailResponseSuccess | clinicGetForPatientDetailResponseError)

export const getClinicGetForPatientDetailUrl = (clinicId: string,) => {




  return `/clinics/for-patients/${clinicId}`
}

/**
 * 患者向け医療機関一覧から選択した医療機関の詳細情報を返します。
 * @summary 患者向け医療機関詳細を取得する
 */
export const clinicGetForPatientDetail = async (clinicId: string, options?: Parameters<typeof http>[1]): Promise<clinicGetForPatientDetailResponse> => {

  return http<clinicGetForPatientDetailResponse>(getClinicGetForPatientDetailUrl(clinicId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getClinicGetForPatientDetailQueryKey = (clinicId: string,) => {
    return [
    `/clinics/for-patients/${clinicId}`
    ] as const;
    }


export const getClinicGetForPatientDetailQueryOptions = <TData = Awaited<ReturnType<typeof clinicGetForPatientDetail>>, TError = ProblemResponseResponse>(clinicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicGetForPatientDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicGetForPatientDetailQueryKey(clinicId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicGetForPatientDetail>>> = ({ signal }) => clinicGetForPatientDetail(clinicId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: clinicId !== null && clinicId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicGetForPatientDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClinicGetForPatientDetailQueryResult = NonNullable<Awaited<ReturnType<typeof clinicGetForPatientDetail>>>
export type ClinicGetForPatientDetailQueryError = ProblemResponseResponse


export function useClinicGetForPatientDetail<TData = Awaited<ReturnType<typeof clinicGetForPatientDetail>>, TError = ProblemResponseResponse>(
 clinicId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicGetForPatientDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicGetForPatientDetail>>,
          TError,
          Awaited<ReturnType<typeof clinicGetForPatientDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicGetForPatientDetail<TData = Awaited<ReturnType<typeof clinicGetForPatientDetail>>, TError = ProblemResponseResponse>(
 clinicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicGetForPatientDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicGetForPatientDetail>>,
          TError,
          Awaited<ReturnType<typeof clinicGetForPatientDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicGetForPatientDetail<TData = Awaited<ReturnType<typeof clinicGetForPatientDetail>>, TError = ProblemResponseResponse>(
 clinicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicGetForPatientDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者向け医療機関詳細を取得する
 */

export function useClinicGetForPatientDetail<TData = Awaited<ReturnType<typeof clinicGetForPatientDetail>>, TError = ProblemResponseResponse>(
 clinicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicGetForPatientDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClinicGetForPatientDetailQueryOptions(clinicId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type clinicGetDetailResponse200 = {
  data: ClinicDetail
  status: 200
}

export type clinicGetDetailResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type clinicGetDetailResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type clinicGetDetailResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type clinicGetDetailResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type clinicGetDetailResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type clinicGetDetailResponseSuccess = (clinicGetDetailResponse200) & {
  headers: Headers;
};
export type clinicGetDetailResponseError = (clinicGetDetailResponse401 | clinicGetDetailResponse403 | clinicGetDetailResponse404 | clinicGetDetailResponse422 | clinicGetDetailResponse500) & {
  headers: Headers;
};

export type clinicGetDetailResponse = (clinicGetDetailResponseSuccess | clinicGetDetailResponseError)

export const getClinicGetDetailUrl = (clinicId: string,) => {




  return `/clinics/${clinicId}/detail`
}

/**
 * クリニックIDに対応する詳細情報（基本情報）を返します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*
 * @summary クリニックの詳細情報を取得する
 */
export const clinicGetDetail = async (clinicId: string, options?: Parameters<typeof http>[1]): Promise<clinicGetDetailResponse> => {

  return http<clinicGetDetailResponse>(getClinicGetDetailUrl(clinicId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getClinicGetDetailQueryKey = (clinicId: string,) => {
    return [
    `/clinics/${clinicId}/detail`
    ] as const;
    }


export const getClinicGetDetailQueryOptions = <TData = Awaited<ReturnType<typeof clinicGetDetail>>, TError = ProblemResponseResponse>(clinicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicGetDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicGetDetailQueryKey(clinicId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicGetDetail>>> = ({ signal }) => clinicGetDetail(clinicId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: clinicId !== null && clinicId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicGetDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClinicGetDetailQueryResult = NonNullable<Awaited<ReturnType<typeof clinicGetDetail>>>
export type ClinicGetDetailQueryError = ProblemResponseResponse


export function useClinicGetDetail<TData = Awaited<ReturnType<typeof clinicGetDetail>>, TError = ProblemResponseResponse>(
 clinicId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicGetDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicGetDetail>>,
          TError,
          Awaited<ReturnType<typeof clinicGetDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicGetDetail<TData = Awaited<ReturnType<typeof clinicGetDetail>>, TError = ProblemResponseResponse>(
 clinicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicGetDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicGetDetail>>,
          TError,
          Awaited<ReturnType<typeof clinicGetDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicGetDetail<TData = Awaited<ReturnType<typeof clinicGetDetail>>, TError = ProblemResponseResponse>(
 clinicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicGetDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary クリニックの詳細情報を取得する
 */

export function useClinicGetDetail<TData = Awaited<ReturnType<typeof clinicGetDetail>>, TError = ProblemResponseResponse>(
 clinicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicGetDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClinicGetDetailQueryOptions(clinicId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type clinicCreateDetailResponse201 = {
  data: ClinicDetail
  status: 201
}

export type clinicCreateDetailResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type clinicCreateDetailResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type clinicCreateDetailResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type clinicCreateDetailResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type clinicCreateDetailResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type clinicCreateDetailResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type clinicCreateDetailResponseSuccess = (clinicCreateDetailResponse201) & {
  headers: Headers;
};
export type clinicCreateDetailResponseError = (clinicCreateDetailResponse400 | clinicCreateDetailResponse401 | clinicCreateDetailResponse403 | clinicCreateDetailResponse404 | clinicCreateDetailResponse422 | clinicCreateDetailResponse500) & {
  headers: Headers;
};

export type clinicCreateDetailResponse = (clinicCreateDetailResponseSuccess | clinicCreateDetailResponseError)

export const getClinicCreateDetailUrl = (clinicId: string,) => {




  return `/clinics/${clinicId}/detail`
}

/**
 * クリニックの基本情報を新規登録します（POST）。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*
 * @summary クリニックの基本情報を新規登録する
 */
export const clinicCreateDetail = async (clinicId: string,
    clinicDetailCreateRequest: ClinicDetailCreateRequest, options?: Parameters<typeof http>[1]): Promise<clinicCreateDetailResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<clinicCreateDetailResponse>(getClinicCreateDetailUrl(clinicId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(clinicDetailCreateRequest)
  }
);}





export const getClinicCreateDetailMutationKey = () => ['clinicCreateDetail'] as const;

export const getClinicCreateDetailMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicCreateDetail>>, TError,ClinicCreateDetailMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof clinicCreateDetail>>, TError,ClinicCreateDetailMutationVariables, TContext> => {

const mutationKey = getClinicCreateDetailMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicCreateDetail>>, ClinicCreateDetailMutationVariables> = (props) => {
          const {clinicId,data} = props ?? {};

          return  clinicCreateDetail(clinicId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClinicCreateDetailMutationResult = NonNullable<Awaited<ReturnType<typeof clinicCreateDetail>>>
    export type ClinicCreateDetailMutationBody = ClinicDetailCreateRequest
    export type ClinicCreateDetailMutationError = ProblemResponseResponse
    export type ClinicCreateDetailMutationVariables = {clinicId: string;data: ClinicDetailCreateRequest}

    /**
 * @summary クリニックの基本情報を新規登録する
 */
export const useClinicCreateDetail = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicCreateDetail>>, TError,ClinicCreateDetailMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clinicCreateDetail>>,
        TError,
        ClinicCreateDetailMutationVariables,
        TContext
      > => {
      return useMutation(getClinicCreateDetailMutationOptions(options), queryClient);
    }

export type clinicUpdateDetailResponse200 = {
  data: ClinicDetail
  status: 200
}

export type clinicUpdateDetailResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type clinicUpdateDetailResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type clinicUpdateDetailResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type clinicUpdateDetailResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type clinicUpdateDetailResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type clinicUpdateDetailResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type clinicUpdateDetailResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type clinicUpdateDetailResponseSuccess = (clinicUpdateDetailResponse200) & {
  headers: Headers;
};
export type clinicUpdateDetailResponseError = (clinicUpdateDetailResponse400 | clinicUpdateDetailResponse401 | clinicUpdateDetailResponse403 | clinicUpdateDetailResponse404 | clinicUpdateDetailResponse409 | clinicUpdateDetailResponse422 | clinicUpdateDetailResponse500) & {
  headers: Headers;
};

export type clinicUpdateDetailResponse = (clinicUpdateDetailResponseSuccess | clinicUpdateDetailResponseError)

export const getClinicUpdateDetailUrl = (clinicId: string,) => {




  return `/clinics/${clinicId}/detail`
}

/**
 * クリニックの基本情報を部分更新します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*
 * @summary クリニックの基本情報を更新する
 */
export const clinicUpdateDetail = async (clinicId: string,
    clinicDetailUpdateRequest: ClinicDetailUpdateRequest, options?: Parameters<typeof http>[1]): Promise<clinicUpdateDetailResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<clinicUpdateDetailResponse>(getClinicUpdateDetailUrl(clinicId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(clinicDetailUpdateRequest)
  }
);}





export const getClinicUpdateDetailMutationKey = () => ['clinicUpdateDetail'] as const;

export const getClinicUpdateDetailMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicUpdateDetail>>, TError,ClinicUpdateDetailMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof clinicUpdateDetail>>, TError,ClinicUpdateDetailMutationVariables, TContext> => {

const mutationKey = getClinicUpdateDetailMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicUpdateDetail>>, ClinicUpdateDetailMutationVariables> = (props) => {
          const {clinicId,data} = props ?? {};

          return  clinicUpdateDetail(clinicId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClinicUpdateDetailMutationResult = NonNullable<Awaited<ReturnType<typeof clinicUpdateDetail>>>
    export type ClinicUpdateDetailMutationBody = ClinicDetailUpdateRequest
    export type ClinicUpdateDetailMutationError = ProblemResponseResponse
    export type ClinicUpdateDetailMutationVariables = {clinicId: string;data: ClinicDetailUpdateRequest}

    /**
 * @summary クリニックの基本情報を更新する
 */
export const useClinicUpdateDetail = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicUpdateDetail>>, TError,ClinicUpdateDetailMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clinicUpdateDetail>>,
        TError,
        ClinicUpdateDetailMutationVariables,
        TContext
      > => {
      return useMutation(getClinicUpdateDetailMutationOptions(options), queryClient);
    }

export type clinicListDoctorsResponse200 = {
  data: ClinicListDoctors200
  status: 200
}

export type clinicListDoctorsResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type clinicListDoctorsResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type clinicListDoctorsResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type clinicListDoctorsResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type clinicListDoctorsResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type clinicListDoctorsResponseSuccess = (clinicListDoctorsResponse200) & {
  headers: Headers;
};
export type clinicListDoctorsResponseError = (clinicListDoctorsResponse401 | clinicListDoctorsResponse403 | clinicListDoctorsResponse404 | clinicListDoctorsResponse422 | clinicListDoctorsResponse500) & {
  headers: Headers;
};

export type clinicListDoctorsResponse = (clinicListDoctorsResponseSuccess | clinicListDoctorsResponseError)

export const getClinicListDoctorsUrl = (clinicId: string,) => {




  return `/clinics/${clinicId}/doctors`
}

/**
 * 指定クリニックに所属する担当医候補（doctorUserId / doctorName）を返します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*
 * @summary クリニック所属の担当医候補一覧を取得する
 */
export const clinicListDoctors = async (clinicId: string, options?: Parameters<typeof http>[1]): Promise<clinicListDoctorsResponse> => {

  return http<clinicListDoctorsResponse>(getClinicListDoctorsUrl(clinicId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getClinicListDoctorsQueryKey = (clinicId: string,) => {
    return [
    `/clinics/${clinicId}/doctors`
    ] as const;
    }


export const getClinicListDoctorsQueryOptions = <TData = Awaited<ReturnType<typeof clinicListDoctors>>, TError = ProblemResponseResponse>(clinicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicListDoctors>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicListDoctorsQueryKey(clinicId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicListDoctors>>> = ({ signal }) => clinicListDoctors(clinicId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: clinicId !== null && clinicId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicListDoctors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClinicListDoctorsQueryResult = NonNullable<Awaited<ReturnType<typeof clinicListDoctors>>>
export type ClinicListDoctorsQueryError = ProblemResponseResponse


export function useClinicListDoctors<TData = Awaited<ReturnType<typeof clinicListDoctors>>, TError = ProblemResponseResponse>(
 clinicId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicListDoctors>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicListDoctors>>,
          TError,
          Awaited<ReturnType<typeof clinicListDoctors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicListDoctors<TData = Awaited<ReturnType<typeof clinicListDoctors>>, TError = ProblemResponseResponse>(
 clinicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicListDoctors>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicListDoctors>>,
          TError,
          Awaited<ReturnType<typeof clinicListDoctors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicListDoctors<TData = Awaited<ReturnType<typeof clinicListDoctors>>, TError = ProblemResponseResponse>(
 clinicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicListDoctors>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary クリニック所属の担当医候補一覧を取得する
 */

export function useClinicListDoctors<TData = Awaited<ReturnType<typeof clinicListDoctors>>, TError = ProblemResponseResponse>(
 clinicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicListDoctors>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClinicListDoctorsQueryOptions(clinicId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type clinicListAssignedDoctorsResponse200 = {
  data: ClinicListAssignedDoctors200
  status: 200
}

export type clinicListAssignedDoctorsResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type clinicListAssignedDoctorsResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type clinicListAssignedDoctorsResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type clinicListAssignedDoctorsResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type clinicListAssignedDoctorsResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type clinicListAssignedDoctorsResponseSuccess = (clinicListAssignedDoctorsResponse200) & {
  headers: Headers;
};
export type clinicListAssignedDoctorsResponseError = (clinicListAssignedDoctorsResponse401 | clinicListAssignedDoctorsResponse403 | clinicListAssignedDoctorsResponse404 | clinicListAssignedDoctorsResponse422 | clinicListAssignedDoctorsResponse500) & {
  headers: Headers;
};

export type clinicListAssignedDoctorsResponse = (clinicListAssignedDoctorsResponseSuccess | clinicListAssignedDoctorsResponseError)

export const getClinicListAssignedDoctorsUrl = (clinicId: string,) => {




  return `/clinics/${clinicId}/assigned-doctors`
}

/**
 * 指定クリニックに担当医として登録済みの一覧（uniqueNumber / doctorName / doctorUserId）を返します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*\/patient-user（patient-userは通院先クリニックのみ）
 * @summary クリニックに登録済みの担当医一覧を取得する
 */
export const clinicListAssignedDoctors = async (clinicId: string, options?: Parameters<typeof http>[1]): Promise<clinicListAssignedDoctorsResponse> => {

  return http<clinicListAssignedDoctorsResponse>(getClinicListAssignedDoctorsUrl(clinicId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getClinicListAssignedDoctorsQueryKey = (clinicId: string,) => {
    return [
    `/clinics/${clinicId}/assigned-doctors`
    ] as const;
    }


export const getClinicListAssignedDoctorsQueryOptions = <TData = Awaited<ReturnType<typeof clinicListAssignedDoctors>>, TError = ProblemResponseResponse>(clinicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicListAssignedDoctors>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicListAssignedDoctorsQueryKey(clinicId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicListAssignedDoctors>>> = ({ signal }) => clinicListAssignedDoctors(clinicId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: clinicId !== null && clinicId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicListAssignedDoctors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClinicListAssignedDoctorsQueryResult = NonNullable<Awaited<ReturnType<typeof clinicListAssignedDoctors>>>
export type ClinicListAssignedDoctorsQueryError = ProblemResponseResponse


export function useClinicListAssignedDoctors<TData = Awaited<ReturnType<typeof clinicListAssignedDoctors>>, TError = ProblemResponseResponse>(
 clinicId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicListAssignedDoctors>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicListAssignedDoctors>>,
          TError,
          Awaited<ReturnType<typeof clinicListAssignedDoctors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicListAssignedDoctors<TData = Awaited<ReturnType<typeof clinicListAssignedDoctors>>, TError = ProblemResponseResponse>(
 clinicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicListAssignedDoctors>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicListAssignedDoctors>>,
          TError,
          Awaited<ReturnType<typeof clinicListAssignedDoctors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicListAssignedDoctors<TData = Awaited<ReturnType<typeof clinicListAssignedDoctors>>, TError = ProblemResponseResponse>(
 clinicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicListAssignedDoctors>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary クリニックに登録済みの担当医一覧を取得する
 */

export function useClinicListAssignedDoctors<TData = Awaited<ReturnType<typeof clinicListAssignedDoctors>>, TError = ProblemResponseResponse>(
 clinicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicListAssignedDoctors>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClinicListAssignedDoctorsQueryOptions(clinicId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type clinicGetDepositAccountResponse200 = {
  data: ClinicDepositAccount
  status: 200
}

export type clinicGetDepositAccountResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type clinicGetDepositAccountResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type clinicGetDepositAccountResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type clinicGetDepositAccountResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type clinicGetDepositAccountResponseSuccess = (clinicGetDepositAccountResponse200) & {
  headers: Headers;
};
export type clinicGetDepositAccountResponseError = (clinicGetDepositAccountResponse401 | clinicGetDepositAccountResponse403 | clinicGetDepositAccountResponse404 | clinicGetDepositAccountResponse500) & {
  headers: Headers;
};

export type clinicGetDepositAccountResponse = (clinicGetDepositAccountResponseSuccess | clinicGetDepositAccountResponseError)

export const getClinicGetDepositAccountUrl = (clinicId: string,) => {




  return `/clinics/${clinicId}/deposit-account`
}

/**
 * 指定されたクリニック（clinicId）の入金口座情報を返します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*
 * @summary 入金口座情報を取得する
 */
export const clinicGetDepositAccount = async (clinicId: string, options?: Parameters<typeof http>[1]): Promise<clinicGetDepositAccountResponse> => {

  return http<clinicGetDepositAccountResponse>(getClinicGetDepositAccountUrl(clinicId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getClinicGetDepositAccountQueryKey = (clinicId: string,) => {
    return [
    `/clinics/${clinicId}/deposit-account`
    ] as const;
    }


export const getClinicGetDepositAccountQueryOptions = <TData = Awaited<ReturnType<typeof clinicGetDepositAccount>>, TError = ProblemResponseResponse>(clinicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicGetDepositAccount>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicGetDepositAccountQueryKey(clinicId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicGetDepositAccount>>> = ({ signal }) => clinicGetDepositAccount(clinicId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: clinicId !== null && clinicId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicGetDepositAccount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClinicGetDepositAccountQueryResult = NonNullable<Awaited<ReturnType<typeof clinicGetDepositAccount>>>
export type ClinicGetDepositAccountQueryError = ProblemResponseResponse


export function useClinicGetDepositAccount<TData = Awaited<ReturnType<typeof clinicGetDepositAccount>>, TError = ProblemResponseResponse>(
 clinicId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicGetDepositAccount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicGetDepositAccount>>,
          TError,
          Awaited<ReturnType<typeof clinicGetDepositAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicGetDepositAccount<TData = Awaited<ReturnType<typeof clinicGetDepositAccount>>, TError = ProblemResponseResponse>(
 clinicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicGetDepositAccount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicGetDepositAccount>>,
          TError,
          Awaited<ReturnType<typeof clinicGetDepositAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicGetDepositAccount<TData = Awaited<ReturnType<typeof clinicGetDepositAccount>>, TError = ProblemResponseResponse>(
 clinicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicGetDepositAccount>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 入金口座情報を取得する
 */

export function useClinicGetDepositAccount<TData = Awaited<ReturnType<typeof clinicGetDepositAccount>>, TError = ProblemResponseResponse>(
 clinicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicGetDepositAccount>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClinicGetDepositAccountQueryOptions(clinicId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type clinicCreateDepositAccountResponse201 = {
  data: ClinicDepositAccount
  status: 201
}

export type clinicCreateDepositAccountResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type clinicCreateDepositAccountResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type clinicCreateDepositAccountResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type clinicCreateDepositAccountResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type clinicCreateDepositAccountResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type clinicCreateDepositAccountResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type clinicCreateDepositAccountResponseSuccess = (clinicCreateDepositAccountResponse201) & {
  headers: Headers;
};
export type clinicCreateDepositAccountResponseError = (clinicCreateDepositAccountResponse400 | clinicCreateDepositAccountResponse401 | clinicCreateDepositAccountResponse403 | clinicCreateDepositAccountResponse404 | clinicCreateDepositAccountResponse422 | clinicCreateDepositAccountResponse500) & {
  headers: Headers;
};

export type clinicCreateDepositAccountResponse = (clinicCreateDepositAccountResponseSuccess | clinicCreateDepositAccountResponseError)

export const getClinicCreateDepositAccountUrl = (clinicId: string,) => {




  return `/clinics/${clinicId}/deposit-account`
}

/**
 * 指定されたクリニック（clinicId）の入金口座情報を新規登録します（POST）。
 *
 * RBAC（Option A）:
 * - 許可: ops-*
 * @summary 入金口座情報を新規登録する
 */
export const clinicCreateDepositAccount = async (clinicId: string,
    clinicDepositAccountCreateRequest: ClinicDepositAccountCreateRequest, options?: Parameters<typeof http>[1]): Promise<clinicCreateDepositAccountResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<clinicCreateDepositAccountResponse>(getClinicCreateDepositAccountUrl(clinicId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(clinicDepositAccountCreateRequest)
  }
);}





export const getClinicCreateDepositAccountMutationKey = () => ['clinicCreateDepositAccount'] as const;

export const getClinicCreateDepositAccountMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicCreateDepositAccount>>, TError,ClinicCreateDepositAccountMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof clinicCreateDepositAccount>>, TError,ClinicCreateDepositAccountMutationVariables, TContext> => {

const mutationKey = getClinicCreateDepositAccountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicCreateDepositAccount>>, ClinicCreateDepositAccountMutationVariables> = (props) => {
          const {clinicId,data} = props ?? {};

          return  clinicCreateDepositAccount(clinicId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClinicCreateDepositAccountMutationResult = NonNullable<Awaited<ReturnType<typeof clinicCreateDepositAccount>>>
    export type ClinicCreateDepositAccountMutationBody = ClinicDepositAccountCreateRequest
    export type ClinicCreateDepositAccountMutationError = ProblemResponseResponse
    export type ClinicCreateDepositAccountMutationVariables = {clinicId: string;data: ClinicDepositAccountCreateRequest}

    /**
 * @summary 入金口座情報を新規登録する
 */
export const useClinicCreateDepositAccount = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicCreateDepositAccount>>, TError,ClinicCreateDepositAccountMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clinicCreateDepositAccount>>,
        TError,
        ClinicCreateDepositAccountMutationVariables,
        TContext
      > => {
      return useMutation(getClinicCreateDepositAccountMutationOptions(options), queryClient);
    }

export type clinicUpdateDepositAccountResponse200 = {
  data: ClinicDepositAccount
  status: 200
}

export type clinicUpdateDepositAccountResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type clinicUpdateDepositAccountResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type clinicUpdateDepositAccountResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type clinicUpdateDepositAccountResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type clinicUpdateDepositAccountResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type clinicUpdateDepositAccountResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type clinicUpdateDepositAccountResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type clinicUpdateDepositAccountResponseSuccess = (clinicUpdateDepositAccountResponse200) & {
  headers: Headers;
};
export type clinicUpdateDepositAccountResponseError = (clinicUpdateDepositAccountResponse400 | clinicUpdateDepositAccountResponse401 | clinicUpdateDepositAccountResponse403 | clinicUpdateDepositAccountResponse404 | clinicUpdateDepositAccountResponse409 | clinicUpdateDepositAccountResponse422 | clinicUpdateDepositAccountResponse500) & {
  headers: Headers;
};

export type clinicUpdateDepositAccountResponse = (clinicUpdateDepositAccountResponseSuccess | clinicUpdateDepositAccountResponseError)

export const getClinicUpdateDepositAccountUrl = (clinicId: string,) => {




  return `/clinics/${clinicId}/deposit-account`
}

/**
 * 指定されたクリニック（clinicId）の入金口座情報を更新します（PATCH）。
 *
 * RBAC（Option A）:
 * - 許可: ops-*
 * @summary 入金口座情報を更新する
 */
export const clinicUpdateDepositAccount = async (clinicId: string,
    clinicDepositAccountUpdateRequest: ClinicDepositAccountUpdateRequest, options?: Parameters<typeof http>[1]): Promise<clinicUpdateDepositAccountResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<clinicUpdateDepositAccountResponse>(getClinicUpdateDepositAccountUrl(clinicId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(clinicDepositAccountUpdateRequest)
  }
);}





export const getClinicUpdateDepositAccountMutationKey = () => ['clinicUpdateDepositAccount'] as const;

export const getClinicUpdateDepositAccountMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicUpdateDepositAccount>>, TError,ClinicUpdateDepositAccountMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof clinicUpdateDepositAccount>>, TError,ClinicUpdateDepositAccountMutationVariables, TContext> => {

const mutationKey = getClinicUpdateDepositAccountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicUpdateDepositAccount>>, ClinicUpdateDepositAccountMutationVariables> = (props) => {
          const {clinicId,data} = props ?? {};

          return  clinicUpdateDepositAccount(clinicId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClinicUpdateDepositAccountMutationResult = NonNullable<Awaited<ReturnType<typeof clinicUpdateDepositAccount>>>
    export type ClinicUpdateDepositAccountMutationBody = ClinicDepositAccountUpdateRequest
    export type ClinicUpdateDepositAccountMutationError = ProblemResponseResponse
    export type ClinicUpdateDepositAccountMutationVariables = {clinicId: string;data: ClinicDepositAccountUpdateRequest}

    /**
 * @summary 入金口座情報を更新する
 */
export const useClinicUpdateDepositAccount = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicUpdateDepositAccount>>, TError,ClinicUpdateDepositAccountMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clinicUpdateDepositAccount>>,
        TError,
        ClinicUpdateDepositAccountMutationVariables,
        TContext
      > => {
      return useMutation(getClinicUpdateDepositAccountMutationOptions(options), queryClient);
    }

export type clinicGetMyDetailResponse200 = {
  data: ClinicDetail
  status: 200
}

export type clinicGetMyDetailResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type clinicGetMyDetailResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type clinicGetMyDetailResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type clinicGetMyDetailResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type clinicGetMyDetailResponseSuccess = (clinicGetMyDetailResponse200) & {
  headers: Headers;
};
export type clinicGetMyDetailResponseError = (clinicGetMyDetailResponse401 | clinicGetMyDetailResponse403 | clinicGetMyDetailResponse404 | clinicGetMyDetailResponse500) & {
  headers: Headers;
};

export type clinicGetMyDetailResponse = (clinicGetMyDetailResponseSuccess | clinicGetMyDetailResponseError)

export const getClinicGetMyDetailUrl = () => {




  return `/clinics/me/detail`
}

/**
 * 認証済みユーザーの所属クリニックの基本情報（ClinicDetail）を返します。clinicIdは認証コンテキストから解決されます。
 * @summary 自院の基本情報を取得する
 */
export const clinicGetMyDetail = async ( options?: Parameters<typeof http>[1]): Promise<clinicGetMyDetailResponse> => {

  return http<clinicGetMyDetailResponse>(getClinicGetMyDetailUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getClinicGetMyDetailQueryKey = () => {
    return [
    `/clinics/me/detail`
    ] as const;
    }


export const getClinicGetMyDetailQueryOptions = <TData = Awaited<ReturnType<typeof clinicGetMyDetail>>, TError = ProblemResponseResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicGetMyDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicGetMyDetailQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicGetMyDetail>>> = ({ signal }) => clinicGetMyDetail({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicGetMyDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClinicGetMyDetailQueryResult = NonNullable<Awaited<ReturnType<typeof clinicGetMyDetail>>>
export type ClinicGetMyDetailQueryError = ProblemResponseResponse


export function useClinicGetMyDetail<TData = Awaited<ReturnType<typeof clinicGetMyDetail>>, TError = ProblemResponseResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicGetMyDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicGetMyDetail>>,
          TError,
          Awaited<ReturnType<typeof clinicGetMyDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicGetMyDetail<TData = Awaited<ReturnType<typeof clinicGetMyDetail>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicGetMyDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicGetMyDetail>>,
          TError,
          Awaited<ReturnType<typeof clinicGetMyDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicGetMyDetail<TData = Awaited<ReturnType<typeof clinicGetMyDetail>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicGetMyDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 自院の基本情報を取得する
 */

export function useClinicGetMyDetail<TData = Awaited<ReturnType<typeof clinicGetMyDetail>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicGetMyDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClinicGetMyDetailQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type companyListCompaniesResponse200 = {
  data: CompanyListCompanies200
  status: 200
}

export type companyListCompaniesResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type companyListCompaniesResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type companyListCompaniesResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type companyListCompaniesResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type companyListCompaniesResponseSuccess = (companyListCompaniesResponse200) & {
  headers: Headers;
};
export type companyListCompaniesResponseError = (companyListCompaniesResponse401 | companyListCompaniesResponse403 | companyListCompaniesResponse422 | companyListCompaniesResponse500) & {
  headers: Headers;
};

export type companyListCompaniesResponse = (companyListCompaniesResponseSuccess | companyListCompaniesResponseError)

export const getCompanyListCompaniesUrl = (params?: CompanyListCompaniesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/companies?${stringifiedParams}` : `/companies`
}

/**
 * 認証済みユーザーの権限に応じた企業（Company）一覧を返します。
 *
 * オプションのフリー検索:
 * - name: 企業名（漢字）の部分一致検索に使用します。
 * - nameKana: 企業名（ふりがな）の部分一致検索に使用します。
 * - phoneNumber: 電話番号の部分一致検索に使用します（担当者/請求送付先のいずれかに該当）。
 * @summary 企業一覧を取得する
 */
export const companyListCompanies = async (params?: CompanyListCompaniesParams, options?: Parameters<typeof http>[1]): Promise<companyListCompaniesResponse> => {

  return http<companyListCompaniesResponse>(getCompanyListCompaniesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCompanyListCompaniesQueryKey = (params?: CompanyListCompaniesParams,) => {
    return [
    `/companies`, ...(params ? [params] : [])
    ] as const;
    }


export const getCompanyListCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof companyListCompanies>>, TError = ProblemResponseResponse>(params?: CompanyListCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyListCompanies>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyListCompaniesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyListCompanies>>> = ({ signal }) => companyListCompanies(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyListCompanies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CompanyListCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof companyListCompanies>>>
export type CompanyListCompaniesQueryError = ProblemResponseResponse


export function useCompanyListCompanies<TData = Awaited<ReturnType<typeof companyListCompanies>>, TError = ProblemResponseResponse>(
 params: undefined |  CompanyListCompaniesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyListCompanies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof companyListCompanies>>,
          TError,
          Awaited<ReturnType<typeof companyListCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompanyListCompanies<TData = Awaited<ReturnType<typeof companyListCompanies>>, TError = ProblemResponseResponse>(
 params?: CompanyListCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyListCompanies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof companyListCompanies>>,
          TError,
          Awaited<ReturnType<typeof companyListCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompanyListCompanies<TData = Awaited<ReturnType<typeof companyListCompanies>>, TError = ProblemResponseResponse>(
 params?: CompanyListCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyListCompanies>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 企業一覧を取得する
 */

export function useCompanyListCompanies<TData = Awaited<ReturnType<typeof companyListCompanies>>, TError = ProblemResponseResponse>(
 params?: CompanyListCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyListCompanies>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompanyListCompaniesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type companyGetDetailResponse200 = {
  data: CompanyDetail
  status: 200
}

export type companyGetDetailResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type companyGetDetailResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type companyGetDetailResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type companyGetDetailResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type companyGetDetailResponseSuccess = (companyGetDetailResponse200) & {
  headers: Headers;
};
export type companyGetDetailResponseError = (companyGetDetailResponse401 | companyGetDetailResponse403 | companyGetDetailResponse404 | companyGetDetailResponse500) & {
  headers: Headers;
};

export type companyGetDetailResponse = (companyGetDetailResponseSuccess | companyGetDetailResponseError)

export const getCompanyGetDetailUrl = (companyId: string,) => {




  return `/companies/${companyId}/detail`
}

/**
 * 指定された企業（companyId）の詳細情報を返します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/patient-admin
 * @summary 企業の詳細情報を取得する
 */
export const companyGetDetail = async (companyId: string, options?: Parameters<typeof http>[1]): Promise<companyGetDetailResponse> => {

  return http<companyGetDetailResponse>(getCompanyGetDetailUrl(companyId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCompanyGetDetailQueryKey = (companyId: string,) => {
    return [
    `/companies/${companyId}/detail`
    ] as const;
    }


export const getCompanyGetDetailQueryOptions = <TData = Awaited<ReturnType<typeof companyGetDetail>>, TError = ProblemResponseResponse>(companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyGetDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyGetDetailQueryKey(companyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyGetDetail>>> = ({ signal }) => companyGetDetail(companyId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyGetDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CompanyGetDetailQueryResult = NonNullable<Awaited<ReturnType<typeof companyGetDetail>>>
export type CompanyGetDetailQueryError = ProblemResponseResponse


export function useCompanyGetDetail<TData = Awaited<ReturnType<typeof companyGetDetail>>, TError = ProblemResponseResponse>(
 companyId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyGetDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof companyGetDetail>>,
          TError,
          Awaited<ReturnType<typeof companyGetDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompanyGetDetail<TData = Awaited<ReturnType<typeof companyGetDetail>>, TError = ProblemResponseResponse>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyGetDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof companyGetDetail>>,
          TError,
          Awaited<ReturnType<typeof companyGetDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompanyGetDetail<TData = Awaited<ReturnType<typeof companyGetDetail>>, TError = ProblemResponseResponse>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyGetDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 企業の詳細情報を取得する
 */

export function useCompanyGetDetail<TData = Awaited<ReturnType<typeof companyGetDetail>>, TError = ProblemResponseResponse>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyGetDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompanyGetDetailQueryOptions(companyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type companyCreateDetailResponse201 = {
  data: CompanyDetail
  status: 201
}

export type companyCreateDetailResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type companyCreateDetailResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type companyCreateDetailResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type companyCreateDetailResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type companyCreateDetailResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type companyCreateDetailResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type companyCreateDetailResponseSuccess = (companyCreateDetailResponse201) & {
  headers: Headers;
};
export type companyCreateDetailResponseError = (companyCreateDetailResponse400 | companyCreateDetailResponse401 | companyCreateDetailResponse403 | companyCreateDetailResponse404 | companyCreateDetailResponse422 | companyCreateDetailResponse500) & {
  headers: Headers;
};

export type companyCreateDetailResponse = (companyCreateDetailResponseSuccess | companyCreateDetailResponseError)

export const getCompanyCreateDetailUrl = (companyId: string,) => {




  return `/companies/${companyId}/detail`
}

/**
 * 指定された企業（companyId）の詳細情報を新規登録します（POST）。
 *
 * RBAC（Option A）:
 * - 許可: ops-* のみ
 * - 拒否（403）: patient-admin / health-nurse（企業の情報の登録はオペレータのみが行う）
 * @summary 企業の詳細情報を新規登録する
 */
export const companyCreateDetail = async (companyId: string,
    companyDetailCreateRequest: CompanyDetailCreateRequest, options?: Parameters<typeof http>[1]): Promise<companyCreateDetailResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<companyCreateDetailResponse>(getCompanyCreateDetailUrl(companyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(companyDetailCreateRequest)
  }
);}





export const getCompanyCreateDetailMutationKey = () => ['companyCreateDetail'] as const;

export const getCompanyCreateDetailMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyCreateDetail>>, TError,CompanyCreateDetailMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof companyCreateDetail>>, TError,CompanyCreateDetailMutationVariables, TContext> => {

const mutationKey = getCompanyCreateDetailMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyCreateDetail>>, CompanyCreateDetailMutationVariables> = (props) => {
          const {companyId,data} = props ?? {};

          return  companyCreateDetail(companyId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompanyCreateDetailMutationResult = NonNullable<Awaited<ReturnType<typeof companyCreateDetail>>>
    export type CompanyCreateDetailMutationBody = CompanyDetailCreateRequest
    export type CompanyCreateDetailMutationError = ProblemResponseResponse
    export type CompanyCreateDetailMutationVariables = {companyId: string;data: CompanyDetailCreateRequest}

    /**
 * @summary 企業の詳細情報を新規登録する
 */
export const useCompanyCreateDetail = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyCreateDetail>>, TError,CompanyCreateDetailMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof companyCreateDetail>>,
        TError,
        CompanyCreateDetailMutationVariables,
        TContext
      > => {
      return useMutation(getCompanyCreateDetailMutationOptions(options), queryClient);
    }

export type companyUpdateDetailResponse200 = {
  data: CompanyDetail
  status: 200
}

export type companyUpdateDetailResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type companyUpdateDetailResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type companyUpdateDetailResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type companyUpdateDetailResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type companyUpdateDetailResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type companyUpdateDetailResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type companyUpdateDetailResponseSuccess = (companyUpdateDetailResponse200) & {
  headers: Headers;
};
export type companyUpdateDetailResponseError = (companyUpdateDetailResponse400 | companyUpdateDetailResponse401 | companyUpdateDetailResponse403 | companyUpdateDetailResponse404 | companyUpdateDetailResponse422 | companyUpdateDetailResponse500) & {
  headers: Headers;
};

export type companyUpdateDetailResponse = (companyUpdateDetailResponseSuccess | companyUpdateDetailResponseError)

export const getCompanyUpdateDetailUrl = (companyId: string,) => {




  return `/companies/${companyId}/detail`
}

/**
 * 指定された企業（companyId）の詳細情報を更新します（PATCH）。
 *
 * RBAC（Option A）:
 * - 許可: ops-* のみ
 * - 拒否（403）: patient-admin / health-nurse（企業の情報の変更はオペレータのみが行う）
 * @summary 企業の詳細情報を更新する
 */
export const companyUpdateDetail = async (companyId: string,
    companyDetailUpdateRequest: CompanyDetailUpdateRequest, options?: Parameters<typeof http>[1]): Promise<companyUpdateDetailResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<companyUpdateDetailResponse>(getCompanyUpdateDetailUrl(companyId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(companyDetailUpdateRequest)
  }
);}





export const getCompanyUpdateDetailMutationKey = () => ['companyUpdateDetail'] as const;

export const getCompanyUpdateDetailMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyUpdateDetail>>, TError,CompanyUpdateDetailMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof companyUpdateDetail>>, TError,CompanyUpdateDetailMutationVariables, TContext> => {

const mutationKey = getCompanyUpdateDetailMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyUpdateDetail>>, CompanyUpdateDetailMutationVariables> = (props) => {
          const {companyId,data} = props ?? {};

          return  companyUpdateDetail(companyId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompanyUpdateDetailMutationResult = NonNullable<Awaited<ReturnType<typeof companyUpdateDetail>>>
    export type CompanyUpdateDetailMutationBody = CompanyDetailUpdateRequest
    export type CompanyUpdateDetailMutationError = ProblemResponseResponse
    export type CompanyUpdateDetailMutationVariables = {companyId: string;data: CompanyDetailUpdateRequest}

    /**
 * @summary 企業の詳細情報を更新する
 */
export const useCompanyUpdateDetail = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyUpdateDetail>>, TError,CompanyUpdateDetailMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof companyUpdateDetail>>,
        TError,
        CompanyUpdateDetailMutationVariables,
        TContext
      > => {
      return useMutation(getCompanyUpdateDetailMutationOptions(options), queryClient);
    }

export type companyGetMyDetailResponse200 = {
  data: CompanyDetail
  status: 200
}

export type companyGetMyDetailResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type companyGetMyDetailResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type companyGetMyDetailResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type companyGetMyDetailResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type companyGetMyDetailResponseSuccess = (companyGetMyDetailResponse200) & {
  headers: Headers;
};
export type companyGetMyDetailResponseError = (companyGetMyDetailResponse401 | companyGetMyDetailResponse403 | companyGetMyDetailResponse404 | companyGetMyDetailResponse500) & {
  headers: Headers;
};

export type companyGetMyDetailResponse = (companyGetMyDetailResponseSuccess | companyGetMyDetailResponseError)

export const getCompanyGetMyDetailUrl = () => {




  return `/companies/me/detail`
}

/**
 * 認証済みユーザーの所属企業の基本情報（CompanyDetail）を返します。companyIdは認証コンテキストから解決されます。
 *
 * RBAC（Option A）:
 * - 許可: patient-admin
 * @summary 自社の基本情報を取得する
 */
export const companyGetMyDetail = async ( options?: Parameters<typeof http>[1]): Promise<companyGetMyDetailResponse> => {

  return http<companyGetMyDetailResponse>(getCompanyGetMyDetailUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCompanyGetMyDetailQueryKey = () => {
    return [
    `/companies/me/detail`
    ] as const;
    }


export const getCompanyGetMyDetailQueryOptions = <TData = Awaited<ReturnType<typeof companyGetMyDetail>>, TError = ProblemResponseResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyGetMyDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyGetMyDetailQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyGetMyDetail>>> = ({ signal }) => companyGetMyDetail({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyGetMyDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CompanyGetMyDetailQueryResult = NonNullable<Awaited<ReturnType<typeof companyGetMyDetail>>>
export type CompanyGetMyDetailQueryError = ProblemResponseResponse


export function useCompanyGetMyDetail<TData = Awaited<ReturnType<typeof companyGetMyDetail>>, TError = ProblemResponseResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyGetMyDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof companyGetMyDetail>>,
          TError,
          Awaited<ReturnType<typeof companyGetMyDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompanyGetMyDetail<TData = Awaited<ReturnType<typeof companyGetMyDetail>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyGetMyDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof companyGetMyDetail>>,
          TError,
          Awaited<ReturnType<typeof companyGetMyDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompanyGetMyDetail<TData = Awaited<ReturnType<typeof companyGetMyDetail>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyGetMyDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 自社の基本情報を取得する
 */

export function useCompanyGetMyDetail<TData = Awaited<ReturnType<typeof companyGetMyDetail>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyGetMyDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompanyGetMyDetailQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type organizationListOrganizationsResponse200 = {
  data: OrganizationListOrganizations200
  status: 200
}

export type organizationListOrganizationsResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type organizationListOrganizationsResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type organizationListOrganizationsResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type organizationListOrganizationsResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type organizationListOrganizationsResponseSuccess = (organizationListOrganizationsResponse200) & {
  headers: Headers;
};
export type organizationListOrganizationsResponseError = (organizationListOrganizationsResponse401 | organizationListOrganizationsResponse403 | organizationListOrganizationsResponse422 | organizationListOrganizationsResponse500) & {
  headers: Headers;
};

export type organizationListOrganizationsResponse = (organizationListOrganizationsResponseSuccess | organizationListOrganizationsResponseError)

export const getOrganizationListOrganizationsUrl = (params?: OrganizationListOrganizationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations?${stringifiedParams}` : `/organizations`
}

/**
 * 認証済みユーザーの権限に応じた組織（`app.organizations`）一覧を返します。組織は
 * 企業管理者の自組織自身や、部署・支店・末端の事業所を含みます。
 *
 * - patient-admin: 自組織＋配下の全組織（`org_closure` で解決）を1組織1行で返します。
 *   他企業の組織は含まれません。
 * - ops-admin / ops-operator: 企業を問わず全組織を1組織1行で返します。
 * - 上記以外のロール（clinic-doctor / clinic-operator / patient-user 等）は 403 です。
 *
 * 各行の `org1`/`org2`/`org3` は、その組織が属する企業ツリーのルートから見た
 * 祖先パスを深さ順（org1=ルート）に最大3階層まで表示します。加えて、その組織に
 * 直接所属する患者数の集計値（`totalEmployeeCount`/`finishedCount`/`psgCount`/
 * `cpapCount`）を含みます。配下組織の患者は合算しません。パルス人数に相当する
 * フィールドは含みません。
 *
 * `organizationId`/`organizationName`/`psgCountMin`/`psgCountMax`/`cpapCountMin`/
 * `cpapCountMax` で絞り込めます。いずれも任意で、複数指定した場合はAND条件に
 * なります。絞り込み後の件数に対してページングします。
 * @summary 組織一覧を取得する
 */
export const organizationListOrganizations = async (params?: OrganizationListOrganizationsParams, options?: Parameters<typeof http>[1]): Promise<organizationListOrganizationsResponse> => {

  return http<organizationListOrganizationsResponse>(getOrganizationListOrganizationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOrganizationListOrganizationsQueryKey = (params?: OrganizationListOrganizationsParams,) => {
    return [
    `/organizations`, ...(params ? [params] : [])
    ] as const;
    }


export const getOrganizationListOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof organizationListOrganizations>>, TError = ProblemResponseResponse>(params?: OrganizationListOrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationListOrganizations>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationListOrganizationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationListOrganizations>>> = ({ signal }) => organizationListOrganizations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationListOrganizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationListOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof organizationListOrganizations>>>
export type OrganizationListOrganizationsQueryError = ProblemResponseResponse


export function useOrganizationListOrganizations<TData = Awaited<ReturnType<typeof organizationListOrganizations>>, TError = ProblemResponseResponse>(
 params: undefined |  OrganizationListOrganizationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationListOrganizations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationListOrganizations>>,
          TError,
          Awaited<ReturnType<typeof organizationListOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationListOrganizations<TData = Awaited<ReturnType<typeof organizationListOrganizations>>, TError = ProblemResponseResponse>(
 params?: OrganizationListOrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationListOrganizations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationListOrganizations>>,
          TError,
          Awaited<ReturnType<typeof organizationListOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationListOrganizations<TData = Awaited<ReturnType<typeof organizationListOrganizations>>, TError = ProblemResponseResponse>(
 params?: OrganizationListOrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationListOrganizations>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 組織一覧を取得する
 */

export function useOrganizationListOrganizations<TData = Awaited<ReturnType<typeof organizationListOrganizations>>, TError = ProblemResponseResponse>(
 params?: OrganizationListOrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationListOrganizations>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationListOrganizationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type companyDashboardGetExamTreatmentStatusCountsResponse200 = {
  data: ExamTreatmentStatusCounts
  status: 200
}

export type companyDashboardGetExamTreatmentStatusCountsResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type companyDashboardGetExamTreatmentStatusCountsResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type companyDashboardGetExamTreatmentStatusCountsResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type companyDashboardGetExamTreatmentStatusCountsResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type companyDashboardGetExamTreatmentStatusCountsResponseSuccess = (companyDashboardGetExamTreatmentStatusCountsResponse200) & {
  headers: Headers;
};
export type companyDashboardGetExamTreatmentStatusCountsResponseError = (companyDashboardGetExamTreatmentStatusCountsResponse401 | companyDashboardGetExamTreatmentStatusCountsResponse403 | companyDashboardGetExamTreatmentStatusCountsResponse404 | companyDashboardGetExamTreatmentStatusCountsResponse500) & {
  headers: Headers;
};

export type companyDashboardGetExamTreatmentStatusCountsResponse = (companyDashboardGetExamTreatmentStatusCountsResponseSuccess | companyDashboardGetExamTreatmentStatusCountsResponseError)

export const getCompanyDashboardGetExamTreatmentStatusCountsUrl = (params?: CompanyDashboardGetExamTreatmentStatusCountsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/company-dashboard/exam-treatment-status-counts?${stringifiedParams}` : `/company-dashboard/exam-treatment-status-counts`
}

/**
 * 認証済みユーザーの企業スコープ（自組織＋配下組織）に属する患者を対象に、
 * パルス検査6区分（重症度グレードA〜E＋未完了）・PSG検査6区分（clinicalFindings所見区分＋未完了）・
 * 治療（CPAP）5区分の患者数集計を返します。
 *
 * - patient-admin: 自組織＋配下の全組織（`org_closure` で解決）に属する患者を対象にします。他企業の患者は含まれません。
 * - ops-admin / ops-operator: 企業を問わず全患者を対象にします。
 * - 上記以外のロール（clinic-doctor / clinic-operator / patient-user 等）は 403 です。
 *
 * `organizationId` を指定した場合は、その組織自身と配下組織に属する患者だけを対象にします。
 * patient-adminが指定できるのは、自組織自身または自組織の配下にある読取可能な組織だけです。
 * @summary 企業管理者ダッシュボードの「検査・治療状況」集計を取得する
 */
export const companyDashboardGetExamTreatmentStatusCounts = async (params?: CompanyDashboardGetExamTreatmentStatusCountsParams, options?: Parameters<typeof http>[1]): Promise<companyDashboardGetExamTreatmentStatusCountsResponse> => {

  return http<companyDashboardGetExamTreatmentStatusCountsResponse>(getCompanyDashboardGetExamTreatmentStatusCountsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCompanyDashboardGetExamTreatmentStatusCountsQueryKey = (params?: CompanyDashboardGetExamTreatmentStatusCountsParams,) => {
    return [
    `/company-dashboard/exam-treatment-status-counts`, ...(params ? [params] : [])
    ] as const;
    }


export const getCompanyDashboardGetExamTreatmentStatusCountsQueryOptions = <TData = Awaited<ReturnType<typeof companyDashboardGetExamTreatmentStatusCounts>>, TError = ProblemResponseResponse>(params?: CompanyDashboardGetExamTreatmentStatusCountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyDashboardGetExamTreatmentStatusCounts>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyDashboardGetExamTreatmentStatusCountsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyDashboardGetExamTreatmentStatusCounts>>> = ({ signal }) => companyDashboardGetExamTreatmentStatusCounts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyDashboardGetExamTreatmentStatusCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CompanyDashboardGetExamTreatmentStatusCountsQueryResult = NonNullable<Awaited<ReturnType<typeof companyDashboardGetExamTreatmentStatusCounts>>>
export type CompanyDashboardGetExamTreatmentStatusCountsQueryError = ProblemResponseResponse


export function useCompanyDashboardGetExamTreatmentStatusCounts<TData = Awaited<ReturnType<typeof companyDashboardGetExamTreatmentStatusCounts>>, TError = ProblemResponseResponse>(
 params: undefined |  CompanyDashboardGetExamTreatmentStatusCountsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyDashboardGetExamTreatmentStatusCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof companyDashboardGetExamTreatmentStatusCounts>>,
          TError,
          Awaited<ReturnType<typeof companyDashboardGetExamTreatmentStatusCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompanyDashboardGetExamTreatmentStatusCounts<TData = Awaited<ReturnType<typeof companyDashboardGetExamTreatmentStatusCounts>>, TError = ProblemResponseResponse>(
 params?: CompanyDashboardGetExamTreatmentStatusCountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyDashboardGetExamTreatmentStatusCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof companyDashboardGetExamTreatmentStatusCounts>>,
          TError,
          Awaited<ReturnType<typeof companyDashboardGetExamTreatmentStatusCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompanyDashboardGetExamTreatmentStatusCounts<TData = Awaited<ReturnType<typeof companyDashboardGetExamTreatmentStatusCounts>>, TError = ProblemResponseResponse>(
 params?: CompanyDashboardGetExamTreatmentStatusCountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyDashboardGetExamTreatmentStatusCounts>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 企業管理者ダッシュボードの「検査・治療状況」集計を取得する
 */

export function useCompanyDashboardGetExamTreatmentStatusCounts<TData = Awaited<ReturnType<typeof companyDashboardGetExamTreatmentStatusCounts>>, TError = ProblemResponseResponse>(
 params?: CompanyDashboardGetExamTreatmentStatusCountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyDashboardGetExamTreatmentStatusCounts>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompanyDashboardGetExamTreatmentStatusCountsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type companyDashboardGetPsgStatusMonthlySnapshotsResponse200 = {
  data: PsgStatusMonthlySnapshots
  status: 200
}

export type companyDashboardGetPsgStatusMonthlySnapshotsResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type companyDashboardGetPsgStatusMonthlySnapshotsResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type companyDashboardGetPsgStatusMonthlySnapshotsResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type companyDashboardGetPsgStatusMonthlySnapshotsResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type companyDashboardGetPsgStatusMonthlySnapshotsResponseSuccess = (companyDashboardGetPsgStatusMonthlySnapshotsResponse200) & {
  headers: Headers;
};
export type companyDashboardGetPsgStatusMonthlySnapshotsResponseError = (companyDashboardGetPsgStatusMonthlySnapshotsResponse401 | companyDashboardGetPsgStatusMonthlySnapshotsResponse403 | companyDashboardGetPsgStatusMonthlySnapshotsResponse404 | companyDashboardGetPsgStatusMonthlySnapshotsResponse500) & {
  headers: Headers;
};

export type companyDashboardGetPsgStatusMonthlySnapshotsResponse = (companyDashboardGetPsgStatusMonthlySnapshotsResponseSuccess | companyDashboardGetPsgStatusMonthlySnapshotsResponseError)

export const getCompanyDashboardGetPsgStatusMonthlySnapshotsUrl = (params?: CompanyDashboardGetPsgStatusMonthlySnapshotsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/company-dashboard/psg-status-monthly-snapshots?${stringifiedParams}` : `/company-dashboard/psg-status-monthly-snapshots`
}

/**
 * 認証済みユーザーの企業スコープ（自組織＋配下組織）に属する患者を対象に、
 * PSGステータス5段階（診療1回目/検査中/診療2回目/紹介状/完了）の月次時点スナップショットを、
 * 機能リリース月（2026-09）から当月まで昇順で返します。
 *
 * - patient-admin: 自組織＋配下の全組織（`org_closure` で解決）に属する患者を対象にします。他企業の患者は含まれません。
 * - ops-admin / ops-operator: 企業を問わず全患者を対象にします。
 * - 上記以外のロール（clinic-doctor / clinic-operator / patient-user 等）は 403 です。
 *
 * `organizationId` を指定した場合は、その組織自身と配下組織に属する患者だけを対象にします。
 * 過去月スナップショットも、患者の現在の所属組織で対象を判定します。
 * patient-adminが指定できるのは、自組織自身または自組織の配下にある読取可能な組織だけです。
 * @summary 企業管理者ダッシュボードの「検査ステータス」「ステータス別遷移」（PSG）月次スナップショットを取得する
 */
export const companyDashboardGetPsgStatusMonthlySnapshots = async (params?: CompanyDashboardGetPsgStatusMonthlySnapshotsParams, options?: Parameters<typeof http>[1]): Promise<companyDashboardGetPsgStatusMonthlySnapshotsResponse> => {

  return http<companyDashboardGetPsgStatusMonthlySnapshotsResponse>(getCompanyDashboardGetPsgStatusMonthlySnapshotsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCompanyDashboardGetPsgStatusMonthlySnapshotsQueryKey = (params?: CompanyDashboardGetPsgStatusMonthlySnapshotsParams,) => {
    return [
    `/company-dashboard/psg-status-monthly-snapshots`, ...(params ? [params] : [])
    ] as const;
    }


export const getCompanyDashboardGetPsgStatusMonthlySnapshotsQueryOptions = <TData = Awaited<ReturnType<typeof companyDashboardGetPsgStatusMonthlySnapshots>>, TError = ProblemResponseResponse>(params?: CompanyDashboardGetPsgStatusMonthlySnapshotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyDashboardGetPsgStatusMonthlySnapshots>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyDashboardGetPsgStatusMonthlySnapshotsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyDashboardGetPsgStatusMonthlySnapshots>>> = ({ signal }) => companyDashboardGetPsgStatusMonthlySnapshots(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyDashboardGetPsgStatusMonthlySnapshots>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CompanyDashboardGetPsgStatusMonthlySnapshotsQueryResult = NonNullable<Awaited<ReturnType<typeof companyDashboardGetPsgStatusMonthlySnapshots>>>
export type CompanyDashboardGetPsgStatusMonthlySnapshotsQueryError = ProblemResponseResponse


export function useCompanyDashboardGetPsgStatusMonthlySnapshots<TData = Awaited<ReturnType<typeof companyDashboardGetPsgStatusMonthlySnapshots>>, TError = ProblemResponseResponse>(
 params: undefined |  CompanyDashboardGetPsgStatusMonthlySnapshotsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyDashboardGetPsgStatusMonthlySnapshots>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof companyDashboardGetPsgStatusMonthlySnapshots>>,
          TError,
          Awaited<ReturnType<typeof companyDashboardGetPsgStatusMonthlySnapshots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompanyDashboardGetPsgStatusMonthlySnapshots<TData = Awaited<ReturnType<typeof companyDashboardGetPsgStatusMonthlySnapshots>>, TError = ProblemResponseResponse>(
 params?: CompanyDashboardGetPsgStatusMonthlySnapshotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyDashboardGetPsgStatusMonthlySnapshots>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof companyDashboardGetPsgStatusMonthlySnapshots>>,
          TError,
          Awaited<ReturnType<typeof companyDashboardGetPsgStatusMonthlySnapshots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompanyDashboardGetPsgStatusMonthlySnapshots<TData = Awaited<ReturnType<typeof companyDashboardGetPsgStatusMonthlySnapshots>>, TError = ProblemResponseResponse>(
 params?: CompanyDashboardGetPsgStatusMonthlySnapshotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyDashboardGetPsgStatusMonthlySnapshots>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 企業管理者ダッシュボードの「検査ステータス」「ステータス別遷移」（PSG）月次スナップショットを取得する
 */

export function useCompanyDashboardGetPsgStatusMonthlySnapshots<TData = Awaited<ReturnType<typeof companyDashboardGetPsgStatusMonthlySnapshots>>, TError = ProblemResponseResponse>(
 params?: CompanyDashboardGetPsgStatusMonthlySnapshotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyDashboardGetPsgStatusMonthlySnapshots>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompanyDashboardGetPsgStatusMonthlySnapshotsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type companyDashboardGetCpapTreatmentSummaryDistributionResponse200 = {
  data: CpapTreatmentSummaryDistribution
  status: 200
}

export type companyDashboardGetCpapTreatmentSummaryDistributionResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type companyDashboardGetCpapTreatmentSummaryDistributionResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type companyDashboardGetCpapTreatmentSummaryDistributionResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type companyDashboardGetCpapTreatmentSummaryDistributionResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type companyDashboardGetCpapTreatmentSummaryDistributionResponseSuccess = (companyDashboardGetCpapTreatmentSummaryDistributionResponse200) & {
  headers: Headers;
};
export type companyDashboardGetCpapTreatmentSummaryDistributionResponseError = (companyDashboardGetCpapTreatmentSummaryDistributionResponse401 | companyDashboardGetCpapTreatmentSummaryDistributionResponse403 | companyDashboardGetCpapTreatmentSummaryDistributionResponse404 | companyDashboardGetCpapTreatmentSummaryDistributionResponse500) & {
  headers: Headers;
};

export type companyDashboardGetCpapTreatmentSummaryDistributionResponse = (companyDashboardGetCpapTreatmentSummaryDistributionResponseSuccess | companyDashboardGetCpapTreatmentSummaryDistributionResponseError)

export const getCompanyDashboardGetCpapTreatmentSummaryDistributionUrl = (params?: CompanyDashboardGetCpapTreatmentSummaryDistributionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/company-dashboard/cpap-treatment-summary-distribution?${stringifiedParams}` : `/company-dashboard/cpap-treatment-summary-distribution`
}

/**
 * 認証済みユーザーの企業スコープ（自組織＋配下組織）に属する患者のうち、
 * API呼び出し時点の前月（Asia/Tokyo基準）分のCPAP治療実績（手動登録済みの
 * 平均AHI・装着率・平均使用時間の期間集計値）が登録済みの患者だけを対象に、
 * 低/中/高3区分の人数分布を返します。前月分のデータが登録されていない患者は
 * 集計対象に含まれません（0として扱いません）。
 *
 * - patient-admin / health-nurse: 自組織＋配下の全組織に属する患者を対象にします。
 * - ops-admin / ops-operator: 企業を問わず全患者を対象にします。
 * - 上記以外のロールは403です。
 *
 * `organizationId` を指定した場合の絞り込みは、既存の
 * `GET /company-dashboard/exam-treatment-status-counts` と同じ規則に従います。
 * @summary 企業管理者ダッシュボードの「CPAP使用状況」（先月分布）集計を取得する
 */
export const companyDashboardGetCpapTreatmentSummaryDistribution = async (params?: CompanyDashboardGetCpapTreatmentSummaryDistributionParams, options?: Parameters<typeof http>[1]): Promise<companyDashboardGetCpapTreatmentSummaryDistributionResponse> => {

  return http<companyDashboardGetCpapTreatmentSummaryDistributionResponse>(getCompanyDashboardGetCpapTreatmentSummaryDistributionUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCompanyDashboardGetCpapTreatmentSummaryDistributionQueryKey = (params?: CompanyDashboardGetCpapTreatmentSummaryDistributionParams,) => {
    return [
    `/company-dashboard/cpap-treatment-summary-distribution`, ...(params ? [params] : [])
    ] as const;
    }


export const getCompanyDashboardGetCpapTreatmentSummaryDistributionQueryOptions = <TData = Awaited<ReturnType<typeof companyDashboardGetCpapTreatmentSummaryDistribution>>, TError = ProblemResponseResponse>(params?: CompanyDashboardGetCpapTreatmentSummaryDistributionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyDashboardGetCpapTreatmentSummaryDistribution>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyDashboardGetCpapTreatmentSummaryDistributionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyDashboardGetCpapTreatmentSummaryDistribution>>> = ({ signal }) => companyDashboardGetCpapTreatmentSummaryDistribution(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyDashboardGetCpapTreatmentSummaryDistribution>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CompanyDashboardGetCpapTreatmentSummaryDistributionQueryResult = NonNullable<Awaited<ReturnType<typeof companyDashboardGetCpapTreatmentSummaryDistribution>>>
export type CompanyDashboardGetCpapTreatmentSummaryDistributionQueryError = ProblemResponseResponse


export function useCompanyDashboardGetCpapTreatmentSummaryDistribution<TData = Awaited<ReturnType<typeof companyDashboardGetCpapTreatmentSummaryDistribution>>, TError = ProblemResponseResponse>(
 params: undefined |  CompanyDashboardGetCpapTreatmentSummaryDistributionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyDashboardGetCpapTreatmentSummaryDistribution>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof companyDashboardGetCpapTreatmentSummaryDistribution>>,
          TError,
          Awaited<ReturnType<typeof companyDashboardGetCpapTreatmentSummaryDistribution>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompanyDashboardGetCpapTreatmentSummaryDistribution<TData = Awaited<ReturnType<typeof companyDashboardGetCpapTreatmentSummaryDistribution>>, TError = ProblemResponseResponse>(
 params?: CompanyDashboardGetCpapTreatmentSummaryDistributionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyDashboardGetCpapTreatmentSummaryDistribution>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof companyDashboardGetCpapTreatmentSummaryDistribution>>,
          TError,
          Awaited<ReturnType<typeof companyDashboardGetCpapTreatmentSummaryDistribution>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompanyDashboardGetCpapTreatmentSummaryDistribution<TData = Awaited<ReturnType<typeof companyDashboardGetCpapTreatmentSummaryDistribution>>, TError = ProblemResponseResponse>(
 params?: CompanyDashboardGetCpapTreatmentSummaryDistributionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyDashboardGetCpapTreatmentSummaryDistribution>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 企業管理者ダッシュボードの「CPAP使用状況」（先月分布）集計を取得する
 */

export function useCompanyDashboardGetCpapTreatmentSummaryDistribution<TData = Awaited<ReturnType<typeof companyDashboardGetCpapTreatmentSummaryDistribution>>, TError = ProblemResponseResponse>(
 params?: CompanyDashboardGetCpapTreatmentSummaryDistributionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyDashboardGetCpapTreatmentSummaryDistribution>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompanyDashboardGetCpapTreatmentSummaryDistributionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type organizationGetMyHierarchyResponse200 = {
  data: OrganizationHierarchy
  status: 200
}

export type organizationGetMyHierarchyResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type organizationGetMyHierarchyResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type organizationGetMyHierarchyResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type organizationGetMyHierarchyResponseSuccess = (organizationGetMyHierarchyResponse200) & {
  headers: Headers;
};
export type organizationGetMyHierarchyResponseError = (organizationGetMyHierarchyResponse401 | organizationGetMyHierarchyResponse403 | organizationGetMyHierarchyResponse500) & {
  headers: Headers;
};

export type organizationGetMyHierarchyResponse = (organizationGetMyHierarchyResponseSuccess | organizationGetMyHierarchyResponseError)

export const getOrganizationGetMyHierarchyUrl = () => {




  return `/organizations/me/hierarchy`
}

/**
 * ログインユーザーの直接所属組織が属する企業ルートから直接所属組織までの親子経路と、
 * 直接所属組織の配下組織を返します。
 *
 * PATIENT_ADMINだけが利用できます。
 * @summary ログインユーザーの所属組織階層を取得する
 */
export const organizationGetMyHierarchy = async ( options?: Parameters<typeof http>[1]): Promise<organizationGetMyHierarchyResponse> => {

  return http<organizationGetMyHierarchyResponse>(getOrganizationGetMyHierarchyUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOrganizationGetMyHierarchyQueryKey = () => {
    return [
    `/organizations/me/hierarchy`
    ] as const;
    }


export const getOrganizationGetMyHierarchyQueryOptions = <TData = Awaited<ReturnType<typeof organizationGetMyHierarchy>>, TError = ProblemResponseResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetMyHierarchy>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationGetMyHierarchyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationGetMyHierarchy>>> = ({ signal }) => organizationGetMyHierarchy({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationGetMyHierarchy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationGetMyHierarchyQueryResult = NonNullable<Awaited<ReturnType<typeof organizationGetMyHierarchy>>>
export type OrganizationGetMyHierarchyQueryError = ProblemResponseResponse


export function useOrganizationGetMyHierarchy<TData = Awaited<ReturnType<typeof organizationGetMyHierarchy>>, TError = ProblemResponseResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetMyHierarchy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationGetMyHierarchy>>,
          TError,
          Awaited<ReturnType<typeof organizationGetMyHierarchy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationGetMyHierarchy<TData = Awaited<ReturnType<typeof organizationGetMyHierarchy>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetMyHierarchy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationGetMyHierarchy>>,
          TError,
          Awaited<ReturnType<typeof organizationGetMyHierarchy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationGetMyHierarchy<TData = Awaited<ReturnType<typeof organizationGetMyHierarchy>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetMyHierarchy>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ログインユーザーの所属組織階層を取得する
 */

export function useOrganizationGetMyHierarchy<TData = Awaited<ReturnType<typeof organizationGetMyHierarchy>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetMyHierarchy>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationGetMyHierarchyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type organizationListHierarchyResponse200 = {
  data: OrganizationHierarchyList
  status: 200
}

export type organizationListHierarchyResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type organizationListHierarchyResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type organizationListHierarchyResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type organizationListHierarchyResponseSuccess = (organizationListHierarchyResponse200) & {
  headers: Headers;
};
export type organizationListHierarchyResponseError = (organizationListHierarchyResponse401 | organizationListHierarchyResponse403 | organizationListHierarchyResponse500) & {
  headers: Headers;
};

export type organizationListHierarchyResponse = (organizationListHierarchyResponseSuccess | organizationListHierarchyResponseError)

export const getOrganizationListHierarchyUrl = () => {




  return `/organizations/hierarchy`
}

/**
 * 企業を問わず、全ての組織（`app.organizations`のうち`organization_type='COMPANY'`である行、
 * つまり階層のどの深さであれ会社側の組織）を、企業ルートを基準とした階層情報
 * （`level`・`parentId`）付きで1回のレスポンスで返します。ページングは行いません。
 *
 * ops-admin / ops-operator だけが利用できます。
 * @summary 全社・全階層の組織階層を取得する（OPS向け）
 */
export const organizationListHierarchy = async ( options?: Parameters<typeof http>[1]): Promise<organizationListHierarchyResponse> => {

  return http<organizationListHierarchyResponse>(getOrganizationListHierarchyUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOrganizationListHierarchyQueryKey = () => {
    return [
    `/organizations/hierarchy`
    ] as const;
    }


export const getOrganizationListHierarchyQueryOptions = <TData = Awaited<ReturnType<typeof organizationListHierarchy>>, TError = ProblemResponseResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationListHierarchy>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationListHierarchyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationListHierarchy>>> = ({ signal }) => organizationListHierarchy({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationListHierarchy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationListHierarchyQueryResult = NonNullable<Awaited<ReturnType<typeof organizationListHierarchy>>>
export type OrganizationListHierarchyQueryError = ProblemResponseResponse


export function useOrganizationListHierarchy<TData = Awaited<ReturnType<typeof organizationListHierarchy>>, TError = ProblemResponseResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationListHierarchy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationListHierarchy>>,
          TError,
          Awaited<ReturnType<typeof organizationListHierarchy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationListHierarchy<TData = Awaited<ReturnType<typeof organizationListHierarchy>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationListHierarchy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationListHierarchy>>,
          TError,
          Awaited<ReturnType<typeof organizationListHierarchy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationListHierarchy<TData = Awaited<ReturnType<typeof organizationListHierarchy>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationListHierarchy>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 全社・全階層の組織階層を取得する（OPS向け）
 */

export function useOrganizationListHierarchy<TData = Awaited<ReturnType<typeof organizationListHierarchy>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationListHierarchy>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationListHierarchyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type healthNurseListHealthNursesResponse200 = {
  data: HealthNurseListHealthNurses200
  status: 200
}

export type healthNurseListHealthNursesResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type healthNurseListHealthNursesResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type healthNurseListHealthNursesResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type healthNurseListHealthNursesResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type healthNurseListHealthNursesResponseSuccess = (healthNurseListHealthNursesResponse200) & {
  headers: Headers;
};
export type healthNurseListHealthNursesResponseError = (healthNurseListHealthNursesResponse401 | healthNurseListHealthNursesResponse403 | healthNurseListHealthNursesResponse422 | healthNurseListHealthNursesResponse500) & {
  headers: Headers;
};

export type healthNurseListHealthNursesResponse = (healthNurseListHealthNursesResponseSuccess | healthNurseListHealthNursesResponseError)

export const getHealthNurseListHealthNursesUrl = () => {




  return `/health-nurses`
}

/**
 * 認証済みユーザーの権限に応じた保健師（`app.health_nurse_memberships`で組織に
 * 所属登録されている`health-nurse`ユーザー）の全件を返します。
 *
 * - patient-admin / health-nurse: 自組織＋配下の全組織（`org_closure`で解決）に
 *   所属登録されている保健師を、組織ごとに1行で返します。他企業の保健師は
 *   含まれません。
 * - 上記以外のロール（ops-admin / ops-operator / clinic-doctor / clinic-operator /
 *   patient-user 等）は403です。
 *
 * 同一ユーザーが複数組織に所属登録されている場合、組織ごとに1行返ります
 * （ユーザー単位ではまとめません）。
 *
 * 従業員への担当保健師割り付け（今後実装予定）のプルダウン候補として使うことを
 * 想定しており、`GET /api/clinics/{clinicId}/doctors`（担当医候補一覧）と同じ理由で
 * ページングは付けていません。全件を返します。
 * @summary 保健師一覧を取得する
 */
export const healthNurseListHealthNurses = async ( options?: Parameters<typeof http>[1]): Promise<healthNurseListHealthNursesResponse> => {

  return http<healthNurseListHealthNursesResponse>(getHealthNurseListHealthNursesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthNurseListHealthNursesQueryKey = () => {
    return [
    `/health-nurses`
    ] as const;
    }


export const getHealthNurseListHealthNursesQueryOptions = <TData = Awaited<ReturnType<typeof healthNurseListHealthNurses>>, TError = ProblemResponseResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthNurseListHealthNurses>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthNurseListHealthNursesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthNurseListHealthNurses>>> = ({ signal }) => healthNurseListHealthNurses({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthNurseListHealthNurses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthNurseListHealthNursesQueryResult = NonNullable<Awaited<ReturnType<typeof healthNurseListHealthNurses>>>
export type HealthNurseListHealthNursesQueryError = ProblemResponseResponse


export function useHealthNurseListHealthNurses<TData = Awaited<ReturnType<typeof healthNurseListHealthNurses>>, TError = ProblemResponseResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthNurseListHealthNurses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthNurseListHealthNurses>>,
          TError,
          Awaited<ReturnType<typeof healthNurseListHealthNurses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthNurseListHealthNurses<TData = Awaited<ReturnType<typeof healthNurseListHealthNurses>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthNurseListHealthNurses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthNurseListHealthNurses>>,
          TError,
          Awaited<ReturnType<typeof healthNurseListHealthNurses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthNurseListHealthNurses<TData = Awaited<ReturnType<typeof healthNurseListHealthNurses>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthNurseListHealthNurses>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 保健師一覧を取得する
 */

export function useHealthNurseListHealthNurses<TData = Awaited<ReturnType<typeof healthNurseListHealthNurses>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthNurseListHealthNurses>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthNurseListHealthNursesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type patientImportJobsCreateResponse201 = {
  data: PatientImportJobCreateResponse
  status: 201
}

export type patientImportJobsCreateResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientImportJobsCreateResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientImportJobsCreateResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientImportJobsCreateResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientImportJobsCreateResponseSuccess = (patientImportJobsCreateResponse201) & {
  headers: Headers;
};
export type patientImportJobsCreateResponseError = (patientImportJobsCreateResponse401 | patientImportJobsCreateResponse403 | patientImportJobsCreateResponse422 | patientImportJobsCreateResponse500) & {
  headers: Headers;
};

export type patientImportJobsCreateResponse = (patientImportJobsCreateResponseSuccess | patientImportJobsCreateResponseError)

export const getPatientImportJobsCreateUrl = () => {




  return `/imports/patient-jobs`
}

/**
 * `uploads/init` と `uploads/complete` でアップロード済みのCSVファイルを取り込み対象として、患者名簿の登録ジョブを開始します。
 * ジョブIDが払い出され、進行状況はジョブ詳細取得APIで確認できます。
 * @summary 患者CSV取り込みジョブを開始する
 */
export const patientImportJobsCreate = async (patientImportJobCreateRequest: PatientImportJobCreateRequest, options?: Parameters<typeof http>[1]): Promise<patientImportJobsCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<patientImportJobsCreateResponse>(getPatientImportJobsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patientImportJobCreateRequest)
  }
);}





export const getPatientImportJobsCreateMutationKey = () => ['patientImportJobsCreate'] as const;

export const getPatientImportJobsCreateMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientImportJobsCreate>>, TError,PatientImportJobsCreateMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof patientImportJobsCreate>>, TError,PatientImportJobsCreateMutationVariables, TContext> => {

const mutationKey = getPatientImportJobsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientImportJobsCreate>>, PatientImportJobsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  patientImportJobsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientImportJobsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof patientImportJobsCreate>>>
    export type PatientImportJobsCreateMutationBody = PatientImportJobCreateRequest
    export type PatientImportJobsCreateMutationError = ProblemResponseResponse
    export type PatientImportJobsCreateMutationVariables = {data: PatientImportJobCreateRequest}

    /**
 * @summary 患者CSV取り込みジョブを開始する
 */
export const usePatientImportJobsCreate = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientImportJobsCreate>>, TError,PatientImportJobsCreateMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientImportJobsCreate>>,
        TError,
        PatientImportJobsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getPatientImportJobsCreateMutationOptions(options), queryClient);
    }

export type patientImportJobsGetResponse200 = {
  data: PatientImportJob
  status: 200
}

export type patientImportJobsGetResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientImportJobsGetResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientImportJobsGetResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientImportJobsGetResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientImportJobsGetResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientImportJobsGetResponseSuccess = (patientImportJobsGetResponse200) & {
  headers: Headers;
};
export type patientImportJobsGetResponseError = (patientImportJobsGetResponse401 | patientImportJobsGetResponse403 | patientImportJobsGetResponse404 | patientImportJobsGetResponse422 | patientImportJobsGetResponse500) & {
  headers: Headers;
};

export type patientImportJobsGetResponse = (patientImportJobsGetResponseSuccess | patientImportJobsGetResponseError)

export const getPatientImportJobsGetUrl = (jobId: string,) => {




  return `/imports/patient-jobs/${jobId}`
}

/**
 * 指定された取り込みジョブ（jobId）の進行状況と結果を返します。
 * @summary 患者CSV取り込みジョブの状態を取得する
 */
export const patientImportJobsGet = async (jobId: string, options?: Parameters<typeof http>[1]): Promise<patientImportJobsGetResponse> => {

  return http<patientImportJobsGetResponse>(getPatientImportJobsGetUrl(jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPatientImportJobsGetQueryKey = (jobId: string,) => {
    return [
    `/imports/patient-jobs/${jobId}`
    ] as const;
    }


export const getPatientImportJobsGetQueryOptions = <TData = Awaited<ReturnType<typeof patientImportJobsGet>>, TError = ProblemResponseResponse>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientImportJobsGet>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientImportJobsGetQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientImportJobsGet>>> = ({ signal }) => patientImportJobsGet(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientImportJobsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientImportJobsGetQueryResult = NonNullable<Awaited<ReturnType<typeof patientImportJobsGet>>>
export type PatientImportJobsGetQueryError = ProblemResponseResponse


export function usePatientImportJobsGet<TData = Awaited<ReturnType<typeof patientImportJobsGet>>, TError = ProblemResponseResponse>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientImportJobsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientImportJobsGet>>,
          TError,
          Awaited<ReturnType<typeof patientImportJobsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientImportJobsGet<TData = Awaited<ReturnType<typeof patientImportJobsGet>>, TError = ProblemResponseResponse>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientImportJobsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientImportJobsGet>>,
          TError,
          Awaited<ReturnType<typeof patientImportJobsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientImportJobsGet<TData = Awaited<ReturnType<typeof patientImportJobsGet>>, TError = ProblemResponseResponse>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientImportJobsGet>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者CSV取り込みジョブの状態を取得する
 */

export function usePatientImportJobsGet<TData = Awaited<ReturnType<typeof patientImportJobsGet>>, TError = ProblemResponseResponse>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientImportJobsGet>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientImportJobsGetQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type equipmentListEquipmentResponse200 = {
  data: EquipmentListEquipment200
  status: 200
}

export type equipmentListEquipmentResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type equipmentListEquipmentResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type equipmentListEquipmentResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type equipmentListEquipmentResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type equipmentListEquipmentResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type equipmentListEquipmentResponseSuccess = (equipmentListEquipmentResponse200) & {
  headers: Headers;
};
export type equipmentListEquipmentResponseError = (equipmentListEquipmentResponse400 | equipmentListEquipmentResponse401 | equipmentListEquipmentResponse403 | equipmentListEquipmentResponse422 | equipmentListEquipmentResponse500) & {
  headers: Headers;
};

export type equipmentListEquipmentResponse = (equipmentListEquipmentResponseSuccess | equipmentListEquipmentResponseError)

export const getEquipmentListEquipmentUrl = (params?: EquipmentListEquipmentParams,) => {
  const normalizedParams = new URLSearchParams();
  const deepObjectEntries: string[] = [];

  Object.entries(params || {}).forEach(([key, value]) => {
    const deepObjectParameters = ["patientOrganization"];

    if (typeof value === 'object' && value !== null && !Array.isArray(value) && deepObjectParameters.includes(key)) {
      Object.entries(value).forEach(([subKey, subValue]) => {
        if (subValue !== undefined) {
          deepObjectEntries.push(encodeURIComponent(key) + '[' + encodeURIComponent(subKey) + ']=' + (subValue === null ? 'null' : encodeURIComponent(String(subValue))));
        }
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = [normalizedParams.toString(), deepObjectEntries.join('&')].filter(Boolean).join('&');

  return stringifiedParams.length > 0 ? `/equipment?${stringifiedParams}` : `/equipment`
}

/**
 * 検査機器（検査カテゴリ: 未分類/パルス/PG/PSG）の一覧を返します。
 *
 * オプションのフィルタ/検索:
 * - category: 検査カテゴリでフィルタします（UNCLASSIFIED, PULSE, PG, PSG）。
 * - patientNameKana: 患者名（ふりがな）の部分一致検索に使用します。
 * - clinicNameKana: 医療機関名（ふりがな）の部分一致検索に使用します。
 * - PatientOrganizatione: 所属企業名の検索に使用します。
 * - status: 検査機器の状態でフィルタします（PENDING_SHIPMENT|SHIPPED|RETURNED）。
 * - hasResultArrived: 検査レポート到着有無でフィルタします。
 * @summary 検査機器一覧を取得する
 */
export const equipmentListEquipment = async (params?: EquipmentListEquipmentParams, options?: Parameters<typeof http>[1]): Promise<equipmentListEquipmentResponse> => {

  return http<equipmentListEquipmentResponse>(getEquipmentListEquipmentUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getEquipmentListEquipmentQueryKey = (params?: EquipmentListEquipmentParams,) => {
    return [
    `/equipment`, ...(params ? [params] : [])
    ] as const;
    }


export const getEquipmentListEquipmentQueryOptions = <TData = Awaited<ReturnType<typeof equipmentListEquipment>>, TError = ProblemResponseResponse>(params?: EquipmentListEquipmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentListEquipment>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEquipmentListEquipmentQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipmentListEquipment>>> = ({ signal }) => equipmentListEquipment(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipmentListEquipment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EquipmentListEquipmentQueryResult = NonNullable<Awaited<ReturnType<typeof equipmentListEquipment>>>
export type EquipmentListEquipmentQueryError = ProblemResponseResponse


export function useEquipmentListEquipment<TData = Awaited<ReturnType<typeof equipmentListEquipment>>, TError = ProblemResponseResponse>(
 params: undefined |  EquipmentListEquipmentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentListEquipment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof equipmentListEquipment>>,
          TError,
          Awaited<ReturnType<typeof equipmentListEquipment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEquipmentListEquipment<TData = Awaited<ReturnType<typeof equipmentListEquipment>>, TError = ProblemResponseResponse>(
 params?: EquipmentListEquipmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentListEquipment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof equipmentListEquipment>>,
          TError,
          Awaited<ReturnType<typeof equipmentListEquipment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEquipmentListEquipment<TData = Awaited<ReturnType<typeof equipmentListEquipment>>, TError = ProblemResponseResponse>(
 params?: EquipmentListEquipmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentListEquipment>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 検査機器一覧を取得する
 */

export function useEquipmentListEquipment<TData = Awaited<ReturnType<typeof equipmentListEquipment>>, TError = ProblemResponseResponse>(
 params?: EquipmentListEquipmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentListEquipment>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentListEquipmentQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type equipmentGetDetailResponse200 = {
  data: EquipmentDetail
  status: 200
}

export type equipmentGetDetailResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type equipmentGetDetailResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type equipmentGetDetailResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type equipmentGetDetailResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type equipmentGetDetailResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type equipmentGetDetailResponseSuccess = (equipmentGetDetailResponse200) & {
  headers: Headers;
};
export type equipmentGetDetailResponseError = (equipmentGetDetailResponse401 | equipmentGetDetailResponse403 | equipmentGetDetailResponse404 | equipmentGetDetailResponse422 | equipmentGetDetailResponse500) & {
  headers: Headers;
};

export type equipmentGetDetailResponse = (equipmentGetDetailResponseSuccess | equipmentGetDetailResponseError)

export const getEquipmentGetDetailUrl = (equipmentId: string,) => {




  return `/equipment/${equipmentId}`
}

/**
 * 指定された機器（equipmentId）の詳細情報を返します。
 * 発送先住所には、デフォルトでは患者の住所が設定されます。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*
 * @summary 検査機器の詳細情報を取得する
 */
export const equipmentGetDetail = async (equipmentId: string, options?: Parameters<typeof http>[1]): Promise<equipmentGetDetailResponse> => {

  return http<equipmentGetDetailResponse>(getEquipmentGetDetailUrl(equipmentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getEquipmentGetDetailQueryKey = (equipmentId: string,) => {
    return [
    `/equipment/${equipmentId}`
    ] as const;
    }


export const getEquipmentGetDetailQueryOptions = <TData = Awaited<ReturnType<typeof equipmentGetDetail>>, TError = ProblemResponseResponse>(equipmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentGetDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEquipmentGetDetailQueryKey(equipmentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipmentGetDetail>>> = ({ signal }) => equipmentGetDetail(equipmentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: equipmentId !== null && equipmentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipmentGetDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EquipmentGetDetailQueryResult = NonNullable<Awaited<ReturnType<typeof equipmentGetDetail>>>
export type EquipmentGetDetailQueryError = ProblemResponseResponse


export function useEquipmentGetDetail<TData = Awaited<ReturnType<typeof equipmentGetDetail>>, TError = ProblemResponseResponse>(
 equipmentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentGetDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof equipmentGetDetail>>,
          TError,
          Awaited<ReturnType<typeof equipmentGetDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEquipmentGetDetail<TData = Awaited<ReturnType<typeof equipmentGetDetail>>, TError = ProblemResponseResponse>(
 equipmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentGetDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof equipmentGetDetail>>,
          TError,
          Awaited<ReturnType<typeof equipmentGetDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEquipmentGetDetail<TData = Awaited<ReturnType<typeof equipmentGetDetail>>, TError = ProblemResponseResponse>(
 equipmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentGetDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 検査機器の詳細情報を取得する
 */

export function useEquipmentGetDetail<TData = Awaited<ReturnType<typeof equipmentGetDetail>>, TError = ProblemResponseResponse>(
 equipmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentGetDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentGetDetailQueryOptions(equipmentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type equipmentUpdateDetailResponse200 = {
  data: EquipmentDetail
  status: 200
}

export type equipmentUpdateDetailResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type equipmentUpdateDetailResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type equipmentUpdateDetailResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type equipmentUpdateDetailResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type equipmentUpdateDetailResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type equipmentUpdateDetailResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type equipmentUpdateDetailResponseSuccess = (equipmentUpdateDetailResponse200) & {
  headers: Headers;
};
export type equipmentUpdateDetailResponseError = (equipmentUpdateDetailResponse400 | equipmentUpdateDetailResponse401 | equipmentUpdateDetailResponse403 | equipmentUpdateDetailResponse404 | equipmentUpdateDetailResponse422 | equipmentUpdateDetailResponse500) & {
  headers: Headers;
};

export type equipmentUpdateDetailResponse = (equipmentUpdateDetailResponseSuccess | equipmentUpdateDetailResponseError)

export const getEquipmentUpdateDetailUrl = (equipmentId: string,) => {




  return `/equipment/${equipmentId}`
}

/**
 * 指定された機器（equipmentId）の詳細情報のうち、指定された項目のみ部分更新します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*
 * @summary 検査機器の詳細情報を更新する
 */
export const equipmentUpdateDetail = async (equipmentId: string,
    equipmentDetailUpdateRequest: EquipmentDetailUpdateRequest, options?: Parameters<typeof http>[1]): Promise<equipmentUpdateDetailResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<equipmentUpdateDetailResponse>(getEquipmentUpdateDetailUrl(equipmentId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(equipmentDetailUpdateRequest)
  }
);}





export const getEquipmentUpdateDetailMutationKey = () => ['equipmentUpdateDetail'] as const;

export const getEquipmentUpdateDetailMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof equipmentUpdateDetail>>, TError,EquipmentUpdateDetailMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof equipmentUpdateDetail>>, TError,EquipmentUpdateDetailMutationVariables, TContext> => {

const mutationKey = getEquipmentUpdateDetailMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof equipmentUpdateDetail>>, EquipmentUpdateDetailMutationVariables> = (props) => {
          const {equipmentId,data} = props ?? {};

          return  equipmentUpdateDetail(equipmentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EquipmentUpdateDetailMutationResult = NonNullable<Awaited<ReturnType<typeof equipmentUpdateDetail>>>
    export type EquipmentUpdateDetailMutationBody = EquipmentDetailUpdateRequest
    export type EquipmentUpdateDetailMutationError = ProblemResponseResponse
    export type EquipmentUpdateDetailMutationVariables = {equipmentId: string;data: EquipmentDetailUpdateRequest}

    /**
 * @summary 検査機器の詳細情報を更新する
 */
export const useEquipmentUpdateDetail = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof equipmentUpdateDetail>>, TError,EquipmentUpdateDetailMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof equipmentUpdateDetail>>,
        TError,
        EquipmentUpdateDetailMutationVariables,
        TContext
      > => {
      return useMutation(getEquipmentUpdateDetailMutationOptions(options), queryClient);
    }

export type equipmentShipmentCreateResponse201 = {
  data: EquipmentShipment
  status: 201
}

export type equipmentShipmentCreateResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type equipmentShipmentCreateResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type equipmentShipmentCreateResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type equipmentShipmentCreateResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type equipmentShipmentCreateResponseSuccess = (equipmentShipmentCreateResponse201) & {
  headers: Headers;
};
export type equipmentShipmentCreateResponseError = (equipmentShipmentCreateResponse401 | equipmentShipmentCreateResponse403 | equipmentShipmentCreateResponse422 | equipmentShipmentCreateResponse500) & {
  headers: Headers;
};

export type equipmentShipmentCreateResponse = (equipmentShipmentCreateResponseSuccess | equipmentShipmentCreateResponseError)

export const getEquipmentShipmentCreateUrl = () => {




  return `/equipment-shipments`
}

/**
 * 患者ID・機器種別（PG/PSG）・機器名・医療機関独自の患者識別番号・担当医師ユーザーIDを指定して、機器発送依頼を登録します（POST）。
 * リクエストには含まれませんが、発送先住所として患者の住所をデフォルトで設定してください。
 *
 * 備考:
 * - `testType` により `deviceModelCode` の許容値が変わります（PG: PGモデルコード群、PSG: PSGモデルコード群）。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*
 * @summary 機器発送依頼を登録する
 */
export const equipmentShipmentCreate = async (equipmentShipmentCreateRequest: EquipmentShipmentCreateRequest, options?: Parameters<typeof http>[1]): Promise<equipmentShipmentCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<equipmentShipmentCreateResponse>(getEquipmentShipmentCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(equipmentShipmentCreateRequest)
  }
);}





export const getEquipmentShipmentCreateMutationKey = () => ['equipmentShipmentCreate'] as const;

export const getEquipmentShipmentCreateMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof equipmentShipmentCreate>>, TError,EquipmentShipmentCreateMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof equipmentShipmentCreate>>, TError,EquipmentShipmentCreateMutationVariables, TContext> => {

const mutationKey = getEquipmentShipmentCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof equipmentShipmentCreate>>, EquipmentShipmentCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  equipmentShipmentCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EquipmentShipmentCreateMutationResult = NonNullable<Awaited<ReturnType<typeof equipmentShipmentCreate>>>
    export type EquipmentShipmentCreateMutationBody = EquipmentShipmentCreateRequest
    export type EquipmentShipmentCreateMutationError = ProblemResponseResponse
    export type EquipmentShipmentCreateMutationVariables = {data: EquipmentShipmentCreateRequest}

    /**
 * @summary 機器発送依頼を登録する
 */
export const useEquipmentShipmentCreate = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof equipmentShipmentCreate>>, TError,EquipmentShipmentCreateMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof equipmentShipmentCreate>>,
        TError,
        EquipmentShipmentCreateMutationVariables,
        TContext
      > => {
      return useMutation(getEquipmentShipmentCreateMutationOptions(options), queryClient);
    }

export type operatorGetMyProfileResponse200 = {
  data: UserProfile
  status: 200
}

export type operatorGetMyProfileResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type operatorGetMyProfileResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type operatorGetMyProfileResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type operatorGetMyProfileResponseSuccess = (operatorGetMyProfileResponse200) & {
  headers: Headers;
};
export type operatorGetMyProfileResponseError = (operatorGetMyProfileResponse401 | operatorGetMyProfileResponse403 | operatorGetMyProfileResponse500) & {
  headers: Headers;
};

export type operatorGetMyProfileResponse = (operatorGetMyProfileResponseSuccess | operatorGetMyProfileResponseError)

export const getOperatorGetMyProfileUrl = () => {




  return `/operators/me/profile`
}

/**
 * ログイン中オペレーター（自分）の基本情報を返します。
 *
 * 返却項目：名前/フリガナ/ロールコード（ops-admin|ops-operator）/所属会社名/部署名/電話番号/メールアドレス/郵便番号/住所。
 * @summary 自分（オペレーター）の基本情報を取得する
 */
export const operatorGetMyProfile = async ( options?: Parameters<typeof http>[1]): Promise<operatorGetMyProfileResponse> => {

  return http<operatorGetMyProfileResponse>(getOperatorGetMyProfileUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOperatorGetMyProfileQueryKey = () => {
    return [
    `/operators/me/profile`
    ] as const;
    }


export const getOperatorGetMyProfileQueryOptions = <TData = Awaited<ReturnType<typeof operatorGetMyProfile>>, TError = ProblemResponseResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatorGetMyProfile>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperatorGetMyProfileQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operatorGetMyProfile>>> = ({ signal }) => operatorGetMyProfile({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operatorGetMyProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperatorGetMyProfileQueryResult = NonNullable<Awaited<ReturnType<typeof operatorGetMyProfile>>>
export type OperatorGetMyProfileQueryError = ProblemResponseResponse


export function useOperatorGetMyProfile<TData = Awaited<ReturnType<typeof operatorGetMyProfile>>, TError = ProblemResponseResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatorGetMyProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operatorGetMyProfile>>,
          TError,
          Awaited<ReturnType<typeof operatorGetMyProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperatorGetMyProfile<TData = Awaited<ReturnType<typeof operatorGetMyProfile>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatorGetMyProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operatorGetMyProfile>>,
          TError,
          Awaited<ReturnType<typeof operatorGetMyProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperatorGetMyProfile<TData = Awaited<ReturnType<typeof operatorGetMyProfile>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatorGetMyProfile>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 自分（オペレーター）の基本情報を取得する
 */

export function useOperatorGetMyProfile<TData = Awaited<ReturnType<typeof operatorGetMyProfile>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatorGetMyProfile>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperatorGetMyProfileQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type operatorUpdateMyProfileResponse200 = {
  data: UserProfile
  status: 200
}

export type operatorUpdateMyProfileResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type operatorUpdateMyProfileResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type operatorUpdateMyProfileResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type operatorUpdateMyProfileResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type operatorUpdateMyProfileResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type operatorUpdateMyProfileResponseSuccess = (operatorUpdateMyProfileResponse200) & {
  headers: Headers;
};
export type operatorUpdateMyProfileResponseError = (operatorUpdateMyProfileResponse400 | operatorUpdateMyProfileResponse401 | operatorUpdateMyProfileResponse403 | operatorUpdateMyProfileResponse422 | operatorUpdateMyProfileResponse500) & {
  headers: Headers;
};

export type operatorUpdateMyProfileResponse = (operatorUpdateMyProfileResponseSuccess | operatorUpdateMyProfileResponseError)

export const getOperatorUpdateMyProfileUrl = () => {




  return `/operators/me/profile`
}

/**
 * ログイン中オペレーター（自分）の基本情報を部分更新します（指定項目のみ）。
 *
 * 更新対象：名前/フリガナ/所属会社名/部署名/電話番号/郵便番号/住所。
 *
 * 非対象：ロールコード/メールアドレス/パスワードの変更は本APIには含みません。
 * @summary 自分（オペレーター）の基本情報を更新する
 */
export const operatorUpdateMyProfile = async (userProfileUpdateRequest: UserProfileUpdateRequest, options?: Parameters<typeof http>[1]): Promise<operatorUpdateMyProfileResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<operatorUpdateMyProfileResponse>(getOperatorUpdateMyProfileUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(userProfileUpdateRequest)
  }
);}





export const getOperatorUpdateMyProfileMutationKey = () => ['operatorUpdateMyProfile'] as const;

export const getOperatorUpdateMyProfileMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operatorUpdateMyProfile>>, TError,OperatorUpdateMyProfileMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof operatorUpdateMyProfile>>, TError,OperatorUpdateMyProfileMutationVariables, TContext> => {

const mutationKey = getOperatorUpdateMyProfileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operatorUpdateMyProfile>>, OperatorUpdateMyProfileMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  operatorUpdateMyProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OperatorUpdateMyProfileMutationResult = NonNullable<Awaited<ReturnType<typeof operatorUpdateMyProfile>>>
    export type OperatorUpdateMyProfileMutationBody = UserProfileUpdateRequest
    export type OperatorUpdateMyProfileMutationError = ProblemResponseResponse
    export type OperatorUpdateMyProfileMutationVariables = {data: UserProfileUpdateRequest}

    /**
 * @summary 自分（オペレーター）の基本情報を更新する
 */
export const useOperatorUpdateMyProfile = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operatorUpdateMyProfile>>, TError,OperatorUpdateMyProfileMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operatorUpdateMyProfile>>,
        TError,
        OperatorUpdateMyProfileMutationVariables,
        TContext
      > => {
      return useMutation(getOperatorUpdateMyProfileMutationOptions(options), queryClient);
    }

export type meetingJoinResponse200 = {
  data: MeetingJoinResponse
  status: 200
}

export type meetingJoinResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type meetingJoinResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type meetingJoinResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type meetingJoinResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type meetingJoinResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type meetingJoinResponseSuccess = (meetingJoinResponse200) & {
  headers: Headers;
};
export type meetingJoinResponseError = (meetingJoinResponse401 | meetingJoinResponse403 | meetingJoinResponse404 | meetingJoinResponse422 | meetingJoinResponse500) & {
  headers: Headers;
};

export type meetingJoinResponse = (meetingJoinResponseSuccess | meetingJoinResponseError)

export const getMeetingJoinUrl = () => {




  return `/meetings/join`
}

/**
 * Amazon Chime SDK の Meeting を作成または再利用し、Attendee を作成して参加に必要な情報を返します。
 * 認可: `reservationId` に紐づく患者または担当医師のみ参加可能（不一致は 403）。
 * セキュリティ: JoinToken は短命で、ログ/永続保存は禁止。ユーザー識別は Cognito の認証トークンから判別します（リクエストBodyに userId は不要）。
 * 会議の生成/再利用: サーバは `reservationId` を論理キーとして、既存の会議があれば流用し、なければ新規作成します（クライアントは externalMeetingId を送信する必要はありません）。
 *
 * 既存会議の不在（Chime側のNotFound）時の挙動:
 * - 既存会議の再利用が `NotFound` により失敗した場合、サーバは安全に新規会議を再作成して参加を継続し、予約→会議IDの紐付けを更新します（応答は 200）。
 *
 * RBAC簡易注記:
 * - 許可: 予約関係者のみ（`patient-user` 本人／`clinic-*` 担当）
 * @summary ビデオ会議へ参加するための情報を取得する
 */
export const meetingJoin = async (meetingJoinRequest: MeetingJoinRequest, options?: Parameters<typeof http>[1]): Promise<meetingJoinResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<meetingJoinResponse>(getMeetingJoinUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(meetingJoinRequest)
  }
);}





export const getMeetingJoinMutationKey = () => ['meetingJoin'] as const;

export const getMeetingJoinMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meetingJoin>>, TError,MeetingJoinMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof meetingJoin>>, TError,MeetingJoinMutationVariables, TContext> => {

const mutationKey = getMeetingJoinMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meetingJoin>>, MeetingJoinMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  meetingJoin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeetingJoinMutationResult = NonNullable<Awaited<ReturnType<typeof meetingJoin>>>
    export type MeetingJoinMutationBody = MeetingJoinRequest
    export type MeetingJoinMutationError = ProblemResponseResponse
    export type MeetingJoinMutationVariables = {data: MeetingJoinRequest}

    /**
 * @summary ビデオ会議へ参加するための情報を取得する
 */
export const useMeetingJoin = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meetingJoin>>, TError,MeetingJoinMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meetingJoin>>,
        TError,
        MeetingJoinMutationVariables,
        TContext
      > => {
      return useMutation(getMeetingJoinMutationOptions(options), queryClient);
    }

export type patientUpdateCurrentClinicResponse200 = {
  data: PatientDetail
  status: 200
}

export type patientUpdateCurrentClinicResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type patientUpdateCurrentClinicResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientUpdateCurrentClinicResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientUpdateCurrentClinicResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientUpdateCurrentClinicResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type patientUpdateCurrentClinicResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientUpdateCurrentClinicResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientUpdateCurrentClinicResponseSuccess = (patientUpdateCurrentClinicResponse200) & {
  headers: Headers;
};
export type patientUpdateCurrentClinicResponseError = (patientUpdateCurrentClinicResponse400 | patientUpdateCurrentClinicResponse401 | patientUpdateCurrentClinicResponse403 | patientUpdateCurrentClinicResponse404 | patientUpdateCurrentClinicResponse409 | patientUpdateCurrentClinicResponse422 | patientUpdateCurrentClinicResponse500) & {
  headers: Headers;
};

export type patientUpdateCurrentClinicResponse = (patientUpdateCurrentClinicResponseSuccess | patientUpdateCurrentClinicResponseError)

export const getPatientUpdateCurrentClinicUrl = (patientId: string,) => {




  return `/patients/${patientId}/current-clinic`
}

/**
 * 患者が通院先として選んだ医療機関（クリニック）を更新します。通院先は「clinicId（UUID）」または「clinicName（病院名）」のいずれかで指定できます。指定があれば通院期間（開始日・終了日）も更新します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*\/patient-admin
 * - 許可: patient-user（本人のみ。本人判定はサービス層で強制）
 * @summary 患者の通院先クリニックを更新する
 */
export const patientUpdateCurrentClinic = async (patientId: string,
    patientCurrentClinicUpdateRequest: PatientCurrentClinicUpdateRequest, options?: Parameters<typeof http>[1]): Promise<patientUpdateCurrentClinicResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<patientUpdateCurrentClinicResponse>(getPatientUpdateCurrentClinicUrl(patientId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patientCurrentClinicUpdateRequest)
  }
);}





export const getPatientUpdateCurrentClinicMutationKey = () => ['patientUpdateCurrentClinic'] as const;

export const getPatientUpdateCurrentClinicMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientUpdateCurrentClinic>>, TError,PatientUpdateCurrentClinicMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof patientUpdateCurrentClinic>>, TError,PatientUpdateCurrentClinicMutationVariables, TContext> => {

const mutationKey = getPatientUpdateCurrentClinicMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientUpdateCurrentClinic>>, PatientUpdateCurrentClinicMutationVariables> = (props) => {
          const {patientId,data} = props ?? {};

          return  patientUpdateCurrentClinic(patientId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientUpdateCurrentClinicMutationResult = NonNullable<Awaited<ReturnType<typeof patientUpdateCurrentClinic>>>
    export type PatientUpdateCurrentClinicMutationBody = PatientCurrentClinicUpdateRequest
    export type PatientUpdateCurrentClinicMutationError = ProblemResponseResponse
    export type PatientUpdateCurrentClinicMutationVariables = {patientId: string;data: PatientCurrentClinicUpdateRequest}

    /**
 * @summary 患者の通院先クリニックを更新する
 */
export const usePatientUpdateCurrentClinic = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientUpdateCurrentClinic>>, TError,PatientUpdateCurrentClinicMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientUpdateCurrentClinic>>,
        TError,
        PatientUpdateCurrentClinicMutationVariables,
        TContext
      > => {
      return useMutation(getPatientUpdateCurrentClinicMutationOptions(options), queryClient);
    }

export type patientUpdateStatusesResponse200 = {
  data: PatientDetail
  status: 200
}

export type patientUpdateStatusesResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type patientUpdateStatusesResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientUpdateStatusesResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientUpdateStatusesResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientUpdateStatusesResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type patientUpdateStatusesResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientUpdateStatusesResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientUpdateStatusesResponseSuccess = (patientUpdateStatusesResponse200) & {
  headers: Headers;
};
export type patientUpdateStatusesResponseError = (patientUpdateStatusesResponse400 | patientUpdateStatusesResponse401 | patientUpdateStatusesResponse403 | patientUpdateStatusesResponse404 | patientUpdateStatusesResponse409 | patientUpdateStatusesResponse422 | patientUpdateStatusesResponse500) & {
  headers: Headers;
};

export type patientUpdateStatusesResponse = (patientUpdateStatusesResponseSuccess | patientUpdateStatusesResponseError)

export const getPatientUpdateStatusesUrl = (patientId: string,) => {




  return `/patients/${patientId}/statuses`
}

/**
 * 患者のパルス/PG/PSG/CPAPの各ステータスを1つのエンドポイントで部分更新します（指定項目のみ更新）。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*\/patient-admin
 * - 許可: patient-user（本人のみ。本人判定はサービス層で強制）
 * @summary 患者の治療・検査ステータスを更新する
 */
export const patientUpdateStatuses = async (patientId: string,
    patientStatusUpdateRequest: PatientStatusUpdateRequest, options?: Parameters<typeof http>[1]): Promise<patientUpdateStatusesResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<patientUpdateStatusesResponse>(getPatientUpdateStatusesUrl(patientId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patientStatusUpdateRequest)
  }
);}





export const getPatientUpdateStatusesMutationKey = () => ['patientUpdateStatuses'] as const;

export const getPatientUpdateStatusesMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientUpdateStatuses>>, TError,PatientUpdateStatusesMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof patientUpdateStatuses>>, TError,PatientUpdateStatusesMutationVariables, TContext> => {

const mutationKey = getPatientUpdateStatusesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientUpdateStatuses>>, PatientUpdateStatusesMutationVariables> = (props) => {
          const {patientId,data} = props ?? {};

          return  patientUpdateStatuses(patientId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientUpdateStatusesMutationResult = NonNullable<Awaited<ReturnType<typeof patientUpdateStatuses>>>
    export type PatientUpdateStatusesMutationBody = PatientStatusUpdateRequest
    export type PatientUpdateStatusesMutationError = ProblemResponseResponse
    export type PatientUpdateStatusesMutationVariables = {patientId: string;data: PatientStatusUpdateRequest}

    /**
 * @summary 患者の治療・検査ステータスを更新する
 */
export const usePatientUpdateStatuses = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientUpdateStatuses>>, TError,PatientUpdateStatusesMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientUpdateStatuses>>,
        TError,
        PatientUpdateStatusesMutationVariables,
        TContext
      > => {
      return useMutation(getPatientUpdateStatusesMutationOptions(options), queryClient);
    }

export type reservationSlotListResponse200 = {
  data: ReservationSlotList200
  status: 200
}

export type reservationSlotListResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type reservationSlotListResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type reservationSlotListResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type reservationSlotListResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type reservationSlotListResponseSuccess = (reservationSlotListResponse200) & {
  headers: Headers;
};
export type reservationSlotListResponseError = (reservationSlotListResponse401 | reservationSlotListResponse403 | reservationSlotListResponse422 | reservationSlotListResponse500) & {
  headers: Headers;
};

export type reservationSlotListResponse = (reservationSlotListResponseSuccess | reservationSlotListResponseError)

export const getReservationSlotListUrl = (params?: ReservationSlotListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/reservation-slots?${stringifiedParams}` : `/reservation-slots`
}

/**
 * 週ページング・分単位設定の診療予約枠一覧を返します。
 * フィルタ: 診療枠日時範囲（from/to）、担当医師名（doctorName）。
 *
 * 認証済みユーザーが医師/医療事務の場合、自組織の診察予約枠を取得します。
 * 認証済みユーザーが患者の場合、その患者の通院先の医療機関の診察予約枠を取得します。
 * @summary 診療予約枠の一覧を取得する
 */
export const reservationSlotList = async (params?: ReservationSlotListParams, options?: Parameters<typeof http>[1]): Promise<reservationSlotListResponse> => {

  return http<reservationSlotListResponse>(getReservationSlotListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReservationSlotListQueryKey = (params?: ReservationSlotListParams,) => {
    return [
    `/reservation-slots`, ...(params ? [params] : [])
    ] as const;
    }


export const getReservationSlotListQueryOptions = <TData = Awaited<ReturnType<typeof reservationSlotList>>, TError = ProblemResponseResponse>(params?: ReservationSlotListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationSlotList>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReservationSlotListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reservationSlotList>>> = ({ signal }) => reservationSlotList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reservationSlotList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReservationSlotListQueryResult = NonNullable<Awaited<ReturnType<typeof reservationSlotList>>>
export type ReservationSlotListQueryError = ProblemResponseResponse


export function useReservationSlotList<TData = Awaited<ReturnType<typeof reservationSlotList>>, TError = ProblemResponseResponse>(
 params: undefined |  ReservationSlotListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationSlotList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationSlotList>>,
          TError,
          Awaited<ReturnType<typeof reservationSlotList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationSlotList<TData = Awaited<ReturnType<typeof reservationSlotList>>, TError = ProblemResponseResponse>(
 params?: ReservationSlotListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationSlotList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationSlotList>>,
          TError,
          Awaited<ReturnType<typeof reservationSlotList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationSlotList<TData = Awaited<ReturnType<typeof reservationSlotList>>, TError = ProblemResponseResponse>(
 params?: ReservationSlotListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationSlotList>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 診療予約枠の一覧を取得する
 */

export function useReservationSlotList<TData = Awaited<ReturnType<typeof reservationSlotList>>, TError = ProblemResponseResponse>(
 params?: ReservationSlotListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationSlotList>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReservationSlotListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type reservationSlotCreateResponse201 = {
  data: ReservationSlot
  status: 201
}

export type reservationSlotCreateResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type reservationSlotCreateResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type reservationSlotCreateResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type reservationSlotCreateResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type reservationSlotCreateResponseSuccess = (reservationSlotCreateResponse201) & {
  headers: Headers;
};
export type reservationSlotCreateResponseError = (reservationSlotCreateResponse401 | reservationSlotCreateResponse403 | reservationSlotCreateResponse422 | reservationSlotCreateResponse500) & {
  headers: Headers;
};

export type reservationSlotCreateResponse = (reservationSlotCreateResponseSuccess | reservationSlotCreateResponseError)

export const getReservationSlotCreateUrl = () => {




  return `/reservation-slots`
}

/**
 * 週ページング・分単位設定の単一予約枠を作成します。
 * @summary 診療予約枠を作成する（単一）
 */
export const reservationSlotCreate = async (reservationSlotCreateRequest: ReservationSlotCreateRequest, options?: Parameters<typeof http>[1]): Promise<reservationSlotCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<reservationSlotCreateResponse>(getReservationSlotCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reservationSlotCreateRequest)
  }
);}





export const getReservationSlotCreateMutationKey = () => ['reservationSlotCreate'] as const;

export const getReservationSlotCreateMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationSlotCreate>>, TError,ReservationSlotCreateMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof reservationSlotCreate>>, TError,ReservationSlotCreateMutationVariables, TContext> => {

const mutationKey = getReservationSlotCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reservationSlotCreate>>, ReservationSlotCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  reservationSlotCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReservationSlotCreateMutationResult = NonNullable<Awaited<ReturnType<typeof reservationSlotCreate>>>
    export type ReservationSlotCreateMutationBody = ReservationSlotCreateRequest
    export type ReservationSlotCreateMutationError = ProblemResponseResponse
    export type ReservationSlotCreateMutationVariables = {data: ReservationSlotCreateRequest}

    /**
 * @summary 診療予約枠を作成する（単一）
 */
export const useReservationSlotCreate = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationSlotCreate>>, TError,ReservationSlotCreateMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reservationSlotCreate>>,
        TError,
        ReservationSlotCreateMutationVariables,
        TContext
      > => {
      return useMutation(getReservationSlotCreateMutationOptions(options), queryClient);
    }

export type reservationSlotUpdateResponse200 = {
  data: ReservationSlot
  status: 200
}

export type reservationSlotUpdateResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type reservationSlotUpdateResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type reservationSlotUpdateResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type reservationSlotUpdateResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type reservationSlotUpdateResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type reservationSlotUpdateResponseSuccess = (reservationSlotUpdateResponse200) & {
  headers: Headers;
};
export type reservationSlotUpdateResponseError = (reservationSlotUpdateResponse401 | reservationSlotUpdateResponse403 | reservationSlotUpdateResponse404 | reservationSlotUpdateResponse422 | reservationSlotUpdateResponse500) & {
  headers: Headers;
};

export type reservationSlotUpdateResponse = (reservationSlotUpdateResponseSuccess | reservationSlotUpdateResponseError)

export const getReservationSlotUpdateUrl = (slotId: string,) => {




  return `/reservation-slots/${slotId}`
}

/**
 * 予約枠の時間帯・担当医・公開状態などを部分更新します。
 * @summary 診療予約枠を更新する（部分更新）
 */
export const reservationSlotUpdate = async (slotId: string,
    reservationSlotUpdateRequest: ReservationSlotUpdateRequest, options?: Parameters<typeof http>[1]): Promise<reservationSlotUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<reservationSlotUpdateResponse>(getReservationSlotUpdateUrl(slotId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reservationSlotUpdateRequest)
  }
);}





export const getReservationSlotUpdateMutationKey = () => ['reservationSlotUpdate'] as const;

export const getReservationSlotUpdateMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationSlotUpdate>>, TError,ReservationSlotUpdateMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof reservationSlotUpdate>>, TError,ReservationSlotUpdateMutationVariables, TContext> => {

const mutationKey = getReservationSlotUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reservationSlotUpdate>>, ReservationSlotUpdateMutationVariables> = (props) => {
          const {slotId,data} = props ?? {};

          return  reservationSlotUpdate(slotId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReservationSlotUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof reservationSlotUpdate>>>
    export type ReservationSlotUpdateMutationBody = ReservationSlotUpdateRequest
    export type ReservationSlotUpdateMutationError = ProblemResponseResponse
    export type ReservationSlotUpdateMutationVariables = {slotId: string;data: ReservationSlotUpdateRequest}

    /**
 * @summary 診療予約枠を更新する（部分更新）
 */
export const useReservationSlotUpdate = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationSlotUpdate>>, TError,ReservationSlotUpdateMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reservationSlotUpdate>>,
        TError,
        ReservationSlotUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getReservationSlotUpdateMutationOptions(options), queryClient);
    }

export type reservationSlotDeleteResponse204 = {
  data: void
  status: 204
}

export type reservationSlotDeleteResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type reservationSlotDeleteResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type reservationSlotDeleteResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type reservationSlotDeleteResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type reservationSlotDeleteResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type reservationSlotDeleteResponseSuccess = (reservationSlotDeleteResponse204) & {
  headers: Headers;
};
export type reservationSlotDeleteResponseError = (reservationSlotDeleteResponse401 | reservationSlotDeleteResponse403 | reservationSlotDeleteResponse404 | reservationSlotDeleteResponse422 | reservationSlotDeleteResponse500) & {
  headers: Headers;
};

export type reservationSlotDeleteResponse = (reservationSlotDeleteResponseSuccess | reservationSlotDeleteResponseError)

export const getReservationSlotDeleteUrl = (slotId: string,) => {




  return `/reservation-slots/${slotId}`
}

/**
 * 指定した予約枠を削除します。
 * @summary 診療予約枠を削除する
 */
export const reservationSlotDelete = async (slotId: string, options?: Parameters<typeof http>[1]): Promise<reservationSlotDeleteResponse> => {

  return http<reservationSlotDeleteResponse>(getReservationSlotDeleteUrl(slotId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getReservationSlotDeleteMutationKey = () => ['reservationSlotDelete'] as const;

export const getReservationSlotDeleteMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationSlotDelete>>, TError,ReservationSlotDeleteMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof reservationSlotDelete>>, TError,ReservationSlotDeleteMutationVariables, TContext> => {

const mutationKey = getReservationSlotDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reservationSlotDelete>>, ReservationSlotDeleteMutationVariables> = (props) => {
          const {slotId} = props ?? {};

          return  reservationSlotDelete(slotId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReservationSlotDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof reservationSlotDelete>>>

    export type ReservationSlotDeleteMutationError = ProblemResponseResponse
    export type ReservationSlotDeleteMutationVariables = {slotId: string}

    /**
 * @summary 診療予約枠を削除する
 */
export const useReservationSlotDelete = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationSlotDelete>>, TError,ReservationSlotDeleteMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reservationSlotDelete>>,
        TError,
        ReservationSlotDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getReservationSlotDeleteMutationOptions(options), queryClient);
    }

export type reservationSlotBulkUpsertResponse200 = {
  data: ReservationSlotBulkUpsert200
  status: 200
}

export type reservationSlotBulkUpsertResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type reservationSlotBulkUpsertResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type reservationSlotBulkUpsertResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type reservationSlotBulkUpsertResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type reservationSlotBulkUpsertResponseSuccess = (reservationSlotBulkUpsertResponse200) & {
  headers: Headers;
};
export type reservationSlotBulkUpsertResponseError = (reservationSlotBulkUpsertResponse401 | reservationSlotBulkUpsertResponse403 | reservationSlotBulkUpsertResponse422 | reservationSlotBulkUpsertResponse500) & {
  headers: Headers;
};

export type reservationSlotBulkUpsertResponse = (reservationSlotBulkUpsertResponseSuccess | reservationSlotBulkUpsertResponseError)

export const getReservationSlotBulkUpsertUrl = () => {




  return `/reservation-slots/bulk-upsert`
}

/**
 * 複数の予約枠を一括で作成・更新します。
 * @summary 診療予約枠を一括作成・更新する
 */
export const reservationSlotBulkUpsert = async (reservationSlotBulkUpsertRequest: ReservationSlotBulkUpsertRequest, options?: Parameters<typeof http>[1]): Promise<reservationSlotBulkUpsertResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<reservationSlotBulkUpsertResponse>(getReservationSlotBulkUpsertUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reservationSlotBulkUpsertRequest)
  }
);}





export const getReservationSlotBulkUpsertMutationKey = () => ['reservationSlotBulkUpsert'] as const;

export const getReservationSlotBulkUpsertMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationSlotBulkUpsert>>, TError,ReservationSlotBulkUpsertMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof reservationSlotBulkUpsert>>, TError,ReservationSlotBulkUpsertMutationVariables, TContext> => {

const mutationKey = getReservationSlotBulkUpsertMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reservationSlotBulkUpsert>>, ReservationSlotBulkUpsertMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  reservationSlotBulkUpsert(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReservationSlotBulkUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof reservationSlotBulkUpsert>>>
    export type ReservationSlotBulkUpsertMutationBody = ReservationSlotBulkUpsertRequest
    export type ReservationSlotBulkUpsertMutationError = ProblemResponseResponse
    export type ReservationSlotBulkUpsertMutationVariables = {data: ReservationSlotBulkUpsertRequest}

    /**
 * @summary 診療予約枠を一括作成・更新する
 */
export const useReservationSlotBulkUpsert = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationSlotBulkUpsert>>, TError,ReservationSlotBulkUpsertMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reservationSlotBulkUpsert>>,
        TError,
        ReservationSlotBulkUpsertMutationVariables,
        TContext
      > => {
      return useMutation(getReservationSlotBulkUpsertMutationOptions(options), queryClient);
    }

export type reservationSlotListByPatientResponse200 = {
  data: ReservationSlotListByPatient200
  status: 200
}

export type reservationSlotListByPatientResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type reservationSlotListByPatientResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type reservationSlotListByPatientResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type reservationSlotListByPatientResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type reservationSlotListByPatientResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type reservationSlotListByPatientResponseSuccess = (reservationSlotListByPatientResponse200) & {
  headers: Headers;
};
export type reservationSlotListByPatientResponseError = (reservationSlotListByPatientResponse401 | reservationSlotListByPatientResponse403 | reservationSlotListByPatientResponse404 | reservationSlotListByPatientResponse422 | reservationSlotListByPatientResponse500) & {
  headers: Headers;
};

export type reservationSlotListByPatientResponse = (reservationSlotListByPatientResponseSuccess | reservationSlotListByPatientResponseError)

export const getReservationSlotListByPatientUrl = (patientId: string,
    params?: ReservationSlotListByPatientParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/reservation-slots/by-patient/${patientId}?${stringifiedParams}` : `/reservation-slots/by-patient/${patientId}`
}

/**
 * 指定された患者（patientId）の通院先の医療機関に紐づく診察予約枠一覧を返します。
 * フィルタ: 診療枠日時範囲（from/to）、担当医師名（doctorName）。
 *
 * OPS ユーザーは任意の患者を指定できます。患者ユーザーは自身の患者IDのみ指定可能です。
 * @summary 患者別の診療予約枠一覧を取得する
 */
export const reservationSlotListByPatient = async (patientId: string,
    params?: ReservationSlotListByPatientParams, options?: Parameters<typeof http>[1]): Promise<reservationSlotListByPatientResponse> => {

  return http<reservationSlotListByPatientResponse>(getReservationSlotListByPatientUrl(patientId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReservationSlotListByPatientQueryKey = (patientId: string,
    params?: ReservationSlotListByPatientParams,) => {
    return [
    `/reservation-slots/by-patient/${patientId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getReservationSlotListByPatientQueryOptions = <TData = Awaited<ReturnType<typeof reservationSlotListByPatient>>, TError = ProblemResponseResponse>(patientId: string,
    params?: ReservationSlotListByPatientParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationSlotListByPatient>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReservationSlotListByPatientQueryKey(patientId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reservationSlotListByPatient>>> = ({ signal }) => reservationSlotListByPatient(patientId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: patientId !== null && patientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reservationSlotListByPatient>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReservationSlotListByPatientQueryResult = NonNullable<Awaited<ReturnType<typeof reservationSlotListByPatient>>>
export type ReservationSlotListByPatientQueryError = ProblemResponseResponse


export function useReservationSlotListByPatient<TData = Awaited<ReturnType<typeof reservationSlotListByPatient>>, TError = ProblemResponseResponse>(
 patientId: string,
    params: undefined |  ReservationSlotListByPatientParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationSlotListByPatient>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationSlotListByPatient>>,
          TError,
          Awaited<ReturnType<typeof reservationSlotListByPatient>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationSlotListByPatient<TData = Awaited<ReturnType<typeof reservationSlotListByPatient>>, TError = ProblemResponseResponse>(
 patientId: string,
    params?: ReservationSlotListByPatientParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationSlotListByPatient>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationSlotListByPatient>>,
          TError,
          Awaited<ReturnType<typeof reservationSlotListByPatient>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationSlotListByPatient<TData = Awaited<ReturnType<typeof reservationSlotListByPatient>>, TError = ProblemResponseResponse>(
 patientId: string,
    params?: ReservationSlotListByPatientParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationSlotListByPatient>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者別の診療予約枠一覧を取得する
 */

export function useReservationSlotListByPatient<TData = Awaited<ReturnType<typeof reservationSlotListByPatient>>, TError = ProblemResponseResponse>(
 patientId: string,
    params?: ReservationSlotListByPatientParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationSlotListByPatient>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReservationSlotListByPatientQueryOptions(patientId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type reservationListReservationsResponse200 = {
  data: ReservationListReservations200
  status: 200
}

export type reservationListReservationsResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type reservationListReservationsResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type reservationListReservationsResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type reservationListReservationsResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type reservationListReservationsResponseSuccess = (reservationListReservationsResponse200) & {
  headers: Headers;
};
export type reservationListReservationsResponseError = (reservationListReservationsResponse401 | reservationListReservationsResponse403 | reservationListReservationsResponse422 | reservationListReservationsResponse500) & {
  headers: Headers;
};

export type reservationListReservationsResponse = (reservationListReservationsResponseSuccess | reservationListReservationsResponseError)

export const getReservationListReservationsUrl = (params?: ReservationListReservationsParams,) => {
  const normalizedParams = new URLSearchParams();
  const deepObjectEntries: string[] = [];

  Object.entries(params || {}).forEach(([key, value]) => {
    const deepObjectParameters = ["patientOrganization","clinicOrganization"];

    if (typeof value === 'object' && value !== null && !Array.isArray(value) && deepObjectParameters.includes(key)) {
      Object.entries(value).forEach(([subKey, subValue]) => {
        if (subValue !== undefined) {
          deepObjectEntries.push(encodeURIComponent(key) + '[' + encodeURIComponent(subKey) + ']=' + (subValue === null ? 'null' : encodeURIComponent(String(subValue))));
        }
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = [normalizedParams.toString(), deepObjectEntries.join('&')].filter(Boolean).join('&');

  return stringifiedParams.length > 0 ? `/reservations?${stringifiedParams}` : `/reservations`
}

/**
 * 医療機関スタッフ/医師向けの「予約一覧」画面に対応する予約（診療予約）の一覧を返します。
 *
 * フィルタ/検索:
 * - appointmentDateFrom/appointmentDateTo: 診療予約日時の範囲でフィルタします。
 * - nameKana: 患者名（ふりがな）の部分一致検索に使用します。
 * - reservationStatus: 予約ステータスでフィルタします。
 * - consultationType: 診療種別（オンライン/対面）でフィルタします。
 * - patientOrganization[id|name]: 所属企業フィルタに使用します（deepObject）。
 * - clinicOrganization[id|name]: 医療機関フィルタに使用します（deepObject）。
 *
 * RBAC簡易注記:
 * - 許可: `ops-*`, `clinic-*`, `patient-admin`
 * - 禁止: `patient-user`
 *
 * ソート:
 * - ホワイトリスト: appointmentStart|createdAt のみ許可。方向 asc|desc。
 * @summary 予約一覧を取得する
 */
export const reservationListReservations = async (params?: ReservationListReservationsParams, options?: Parameters<typeof http>[1]): Promise<reservationListReservationsResponse> => {

  return http<reservationListReservationsResponse>(getReservationListReservationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReservationListReservationsQueryKey = (params?: ReservationListReservationsParams,) => {
    return [
    `/reservations`, ...(params ? [params] : [])
    ] as const;
    }


export const getReservationListReservationsQueryOptions = <TData = Awaited<ReturnType<typeof reservationListReservations>>, TError = ProblemResponseResponse>(params?: ReservationListReservationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationListReservations>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReservationListReservationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reservationListReservations>>> = ({ signal }) => reservationListReservations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reservationListReservations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReservationListReservationsQueryResult = NonNullable<Awaited<ReturnType<typeof reservationListReservations>>>
export type ReservationListReservationsQueryError = ProblemResponseResponse


export function useReservationListReservations<TData = Awaited<ReturnType<typeof reservationListReservations>>, TError = ProblemResponseResponse>(
 params: undefined |  ReservationListReservationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationListReservations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationListReservations>>,
          TError,
          Awaited<ReturnType<typeof reservationListReservations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationListReservations<TData = Awaited<ReturnType<typeof reservationListReservations>>, TError = ProblemResponseResponse>(
 params?: ReservationListReservationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationListReservations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationListReservations>>,
          TError,
          Awaited<ReturnType<typeof reservationListReservations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationListReservations<TData = Awaited<ReturnType<typeof reservationListReservations>>, TError = ProblemResponseResponse>(
 params?: ReservationListReservationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationListReservations>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 予約一覧を取得する
 */

export function useReservationListReservations<TData = Awaited<ReturnType<typeof reservationListReservations>>, TError = ProblemResponseResponse>(
 params?: ReservationListReservationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationListReservations>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReservationListReservationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type reservationCreateResponse201 = {
  data: Reservation
  status: 201
}

export type reservationCreateResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type reservationCreateResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type reservationCreateResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type reservationCreateResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type reservationCreateResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type reservationCreateResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type reservationCreateResponseSuccess = (reservationCreateResponse201) & {
  headers: Headers;
};
export type reservationCreateResponseError = (reservationCreateResponse400 | reservationCreateResponse401 | reservationCreateResponse403 | reservationCreateResponse409 | reservationCreateResponse422 | reservationCreateResponse500) & {
  headers: Headers;
};

export type reservationCreateResponse = (reservationCreateResponseSuccess | reservationCreateResponseError)

export const getReservationCreateUrl = () => {




  return `/reservations`
}

/**
 * 患者が選択した予約枠（slot）を確定し、診察予約を作成します。
 * リクエストでは診察の開始/終了日時（appointmentStart/appointmentEnd）も指定します。
 * 予約作成後は予約ID等の最小情報を返します。
 *
 * 予約締切ルール（JST）:
 * - 当日予約は常に不可です（422）。
 * - 翌日予約は前日17:00以降は不可です（422）。
 * - 締切超過時は `code=RESERVATION_DEADLINE_EXCEEDED` を返します。
 *
 * RBAC簡易注記:
 * - 許可: `ops-*`, `clinic-*`, `patient-admin`, `patient-user`（本人の予約作成）
 * @summary 診察予約を作成する
 */
export const reservationCreate = async (reservationCreateRequest: ReservationCreateRequest, options?: Parameters<typeof http>[1]): Promise<reservationCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<reservationCreateResponse>(getReservationCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reservationCreateRequest)
  }
);}





export const getReservationCreateMutationKey = () => ['reservationCreate'] as const;

export const getReservationCreateMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationCreate>>, TError,ReservationCreateMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof reservationCreate>>, TError,ReservationCreateMutationVariables, TContext> => {

const mutationKey = getReservationCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reservationCreate>>, ReservationCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  reservationCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReservationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof reservationCreate>>>
    export type ReservationCreateMutationBody = ReservationCreateRequest
    export type ReservationCreateMutationError = ProblemResponseResponse
    export type ReservationCreateMutationVariables = {data: ReservationCreateRequest}

    /**
 * @summary 診察予約を作成する
 */
export const useReservationCreate = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationCreate>>, TError,ReservationCreateMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reservationCreate>>,
        TError,
        ReservationCreateMutationVariables,
        TContext
      > => {
      return useMutation(getReservationCreateMutationOptions(options), queryClient);
    }

export type reservationCreateInPersonResponse201 = {
  data: Reservation
  status: 201
}

export type reservationCreateInPersonResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type reservationCreateInPersonResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type reservationCreateInPersonResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type reservationCreateInPersonResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type reservationCreateInPersonResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type reservationCreateInPersonResponseSuccess = (reservationCreateInPersonResponse201) & {
  headers: Headers;
};
export type reservationCreateInPersonResponseError = (reservationCreateInPersonResponse400 | reservationCreateInPersonResponse401 | reservationCreateInPersonResponse403 | reservationCreateInPersonResponse422 | reservationCreateInPersonResponse500) & {
  headers: Headers;
};

export type reservationCreateInPersonResponse = (reservationCreateInPersonResponseSuccess | reservationCreateInPersonResponseError)

export const getReservationCreateInPersonUrl = () => {




  return `/reservations/in-person`
}

/**
 * 対面診療の予約を作成します。
 * オンライン診療と異なり、予約枠（slot）との紐付けは行いません。
 * 医療機関と担当医師を直接指定します。
 * 診療種別は IN_PERSON として自動設定されます。
 *
 * RBAC簡易注記:
 * - 許可: `ops-*`, `clinic-*`
 * - 禁止: `patient-admin`, `patient-user`
 * @summary 対面診療予約を作成する
 */
export const reservationCreateInPerson = async (inPersonReservationCreateRequest: InPersonReservationCreateRequest, options?: Parameters<typeof http>[1]): Promise<reservationCreateInPersonResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<reservationCreateInPersonResponse>(getReservationCreateInPersonUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(inPersonReservationCreateRequest)
  }
);}





export const getReservationCreateInPersonMutationKey = () => ['reservationCreateInPerson'] as const;

export const getReservationCreateInPersonMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationCreateInPerson>>, TError,ReservationCreateInPersonMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof reservationCreateInPerson>>, TError,ReservationCreateInPersonMutationVariables, TContext> => {

const mutationKey = getReservationCreateInPersonMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reservationCreateInPerson>>, ReservationCreateInPersonMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  reservationCreateInPerson(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReservationCreateInPersonMutationResult = NonNullable<Awaited<ReturnType<typeof reservationCreateInPerson>>>
    export type ReservationCreateInPersonMutationBody = InPersonReservationCreateRequest
    export type ReservationCreateInPersonMutationError = ProblemResponseResponse
    export type ReservationCreateInPersonMutationVariables = {data: InPersonReservationCreateRequest}

    /**
 * @summary 対面診療予約を作成する
 */
export const useReservationCreateInPerson = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationCreateInPerson>>, TError,ReservationCreateInPersonMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reservationCreateInPerson>>,
        TError,
        ReservationCreateInPersonMutationVariables,
        TContext
      > => {
      return useMutation(getReservationCreateInPersonMutationOptions(options), queryClient);
    }

export type reservationCreateOnlineConsultationResponse201 = {
  data: OnlineConsultationReservationCreateResponse
  status: 201
}

export type reservationCreateOnlineConsultationResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type reservationCreateOnlineConsultationResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type reservationCreateOnlineConsultationResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type reservationCreateOnlineConsultationResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type reservationCreateOnlineConsultationResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type reservationCreateOnlineConsultationResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type reservationCreateOnlineConsultationResponseSuccess = (reservationCreateOnlineConsultationResponse201) & {
  headers: Headers;
};
export type reservationCreateOnlineConsultationResponseError = (reservationCreateOnlineConsultationResponse400 | reservationCreateOnlineConsultationResponse401 | reservationCreateOnlineConsultationResponse403 | reservationCreateOnlineConsultationResponse409 | reservationCreateOnlineConsultationResponse422 | reservationCreateOnlineConsultationResponse500) & {
  headers: Headers;
};

export type reservationCreateOnlineConsultationResponse = (reservationCreateOnlineConsultationResponseSuccess | reservationCreateOnlineConsultationResponseError)

export const getReservationCreateOnlineConsultationUrl = () => {




  return `/reservations/online-consultation`
}

/**
 * クリニック職員が患者詳細画面から、日付・時刻・担当医を指定して
 * オンライン診療の予約枠（slot）と予約を単一トランザクションで作成します。
 * 予約作成が失敗した場合は予約枠作成もロールバックされ、不要な予約枠が残りません。
 * 医療機関組織は doctorUserId から解決されます。
 * 診療種別は ONLINE として自動設定されます。
 *
 * 業務ルール:
 * - 予約締切ルール（当日/翌日締切）は適用しません。
 * - CPAP治療の1回目/2回目の診療、または企業請求設定時はオンライン予約不可（422）。
 * - PSG診療1回目予約依頼の患者は問診回答完了前にオンライン予約不可（422）。
 *
 * RBAC簡易注記:
 * - 許可: `clinic-*`
 * - 禁止: `ops-*`, `patient-admin`, `patient-user`
 * @summary オンライン診療予約を作成する（原子的）
 */
export const reservationCreateOnlineConsultation = async (onlineConsultationReservationCreateRequest: OnlineConsultationReservationCreateRequest, options?: Parameters<typeof http>[1]): Promise<reservationCreateOnlineConsultationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<reservationCreateOnlineConsultationResponse>(getReservationCreateOnlineConsultationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(onlineConsultationReservationCreateRequest)
  }
);}





export const getReservationCreateOnlineConsultationMutationKey = () => ['reservationCreateOnlineConsultation'] as const;

export const getReservationCreateOnlineConsultationMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationCreateOnlineConsultation>>, TError,ReservationCreateOnlineConsultationMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof reservationCreateOnlineConsultation>>, TError,ReservationCreateOnlineConsultationMutationVariables, TContext> => {

const mutationKey = getReservationCreateOnlineConsultationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reservationCreateOnlineConsultation>>, ReservationCreateOnlineConsultationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  reservationCreateOnlineConsultation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReservationCreateOnlineConsultationMutationResult = NonNullable<Awaited<ReturnType<typeof reservationCreateOnlineConsultation>>>
    export type ReservationCreateOnlineConsultationMutationBody = OnlineConsultationReservationCreateRequest
    export type ReservationCreateOnlineConsultationMutationError = ProblemResponseResponse
    export type ReservationCreateOnlineConsultationMutationVariables = {data: OnlineConsultationReservationCreateRequest}

    /**
 * @summary オンライン診療予約を作成する（原子的）
 */
export const useReservationCreateOnlineConsultation = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationCreateOnlineConsultation>>, TError,ReservationCreateOnlineConsultationMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reservationCreateOnlineConsultation>>,
        TError,
        ReservationCreateOnlineConsultationMutationVariables,
        TContext
      > => {
      return useMutation(getReservationCreateOnlineConsultationMutationOptions(options), queryClient);
    }

export type reservationListByPatientResponse200 = {
  data: ReservationListByPatient200
  status: 200
}

export type reservationListByPatientResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type reservationListByPatientResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type reservationListByPatientResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type reservationListByPatientResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type reservationListByPatientResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type reservationListByPatientResponseSuccess = (reservationListByPatientResponse200) & {
  headers: Headers;
};
export type reservationListByPatientResponseError = (reservationListByPatientResponse401 | reservationListByPatientResponse403 | reservationListByPatientResponse404 | reservationListByPatientResponse422 | reservationListByPatientResponse500) & {
  headers: Headers;
};

export type reservationListByPatientResponse = (reservationListByPatientResponseSuccess | reservationListByPatientResponseError)

export const getReservationListByPatientUrl = (patientId: string,
    params?: ReservationListByPatientParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/reservations/by-patient/${patientId}?${stringifiedParams}` : `/reservations/by-patient/${patientId}`
}

/**
 * 指定された患者（patientId）の予約一覧を返します。
 * @summary 患者別の予約一覧を取得する
 */
export const reservationListByPatient = async (patientId: string,
    params?: ReservationListByPatientParams, options?: Parameters<typeof http>[1]): Promise<reservationListByPatientResponse> => {

  return http<reservationListByPatientResponse>(getReservationListByPatientUrl(patientId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReservationListByPatientQueryKey = (patientId: string,
    params?: ReservationListByPatientParams,) => {
    return [
    `/reservations/by-patient/${patientId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getReservationListByPatientQueryOptions = <TData = Awaited<ReturnType<typeof reservationListByPatient>>, TError = ProblemResponseResponse>(patientId: string,
    params?: ReservationListByPatientParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationListByPatient>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReservationListByPatientQueryKey(patientId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reservationListByPatient>>> = ({ signal }) => reservationListByPatient(patientId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: patientId !== null && patientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reservationListByPatient>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReservationListByPatientQueryResult = NonNullable<Awaited<ReturnType<typeof reservationListByPatient>>>
export type ReservationListByPatientQueryError = ProblemResponseResponse


export function useReservationListByPatient<TData = Awaited<ReturnType<typeof reservationListByPatient>>, TError = ProblemResponseResponse>(
 patientId: string,
    params: undefined |  ReservationListByPatientParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationListByPatient>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationListByPatient>>,
          TError,
          Awaited<ReturnType<typeof reservationListByPatient>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationListByPatient<TData = Awaited<ReturnType<typeof reservationListByPatient>>, TError = ProblemResponseResponse>(
 patientId: string,
    params?: ReservationListByPatientParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationListByPatient>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationListByPatient>>,
          TError,
          Awaited<ReturnType<typeof reservationListByPatient>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationListByPatient<TData = Awaited<ReturnType<typeof reservationListByPatient>>, TError = ProblemResponseResponse>(
 patientId: string,
    params?: ReservationListByPatientParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationListByPatient>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者別の予約一覧を取得する
 */

export function useReservationListByPatient<TData = Awaited<ReturnType<typeof reservationListByPatient>>, TError = ProblemResponseResponse>(
 patientId: string,
    params?: ReservationListByPatientParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationListByPatient>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReservationListByPatientQueryOptions(patientId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type reservationCancelResponse200 = {
  data: Reservation
  status: 200
}

export type reservationCancelResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type reservationCancelResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type reservationCancelResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type reservationCancelResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type reservationCancelResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type reservationCancelResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type reservationCancelResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type reservationCancelResponseSuccess = (reservationCancelResponse200) & {
  headers: Headers;
};
export type reservationCancelResponseError = (reservationCancelResponse400 | reservationCancelResponse401 | reservationCancelResponse403 | reservationCancelResponse404 | reservationCancelResponse409 | reservationCancelResponse422 | reservationCancelResponse500) & {
  headers: Headers;
};

export type reservationCancelResponse = (reservationCancelResponseSuccess | reservationCancelResponseError)

export const getReservationCancelUrl = (reservationId: string,) => {




  return `/reservations/${reservationId}/cancel`
}

/**
 * 指定された予約ID（reservationId）の予約をキャンセルします。
 *
 * RBAC簡易注記:
 * - 許可: `ops-*`, `clinic-*`, `patient-admin`, `patient-user`（本人の予約のみ）
 * - 禁止: 上記以外
 * @summary 予約をキャンセルする
 */
export const reservationCancel = async (reservationId: string, options?: Parameters<typeof http>[1]): Promise<reservationCancelResponse> => {

  return http<reservationCancelResponse>(getReservationCancelUrl(reservationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReservationCancelMutationKey = () => ['reservationCancel'] as const;

export const getReservationCancelMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationCancel>>, TError,ReservationCancelMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof reservationCancel>>, TError,ReservationCancelMutationVariables, TContext> => {

const mutationKey = getReservationCancelMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reservationCancel>>, ReservationCancelMutationVariables> = (props) => {
          const {reservationId} = props ?? {};

          return  reservationCancel(reservationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReservationCancelMutationResult = NonNullable<Awaited<ReturnType<typeof reservationCancel>>>

    export type ReservationCancelMutationError = ProblemResponseResponse
    export type ReservationCancelMutationVariables = {reservationId: string}

    /**
 * @summary 予約をキャンセルする
 */
export const useReservationCancel = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationCancel>>, TError,ReservationCancelMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reservationCancel>>,
        TError,
        ReservationCancelMutationVariables,
        TContext
      > => {
      return useMutation(getReservationCancelMutationOptions(options), queryClient);
    }

export type reservationMarkNoShowResponse200 = {
  data: Reservation
  status: 200
}

export type reservationMarkNoShowResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type reservationMarkNoShowResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type reservationMarkNoShowResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type reservationMarkNoShowResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type reservationMarkNoShowResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type reservationMarkNoShowResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type reservationMarkNoShowResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type reservationMarkNoShowResponseSuccess = (reservationMarkNoShowResponse200) & {
  headers: Headers;
};
export type reservationMarkNoShowResponseError = (reservationMarkNoShowResponse400 | reservationMarkNoShowResponse401 | reservationMarkNoShowResponse403 | reservationMarkNoShowResponse404 | reservationMarkNoShowResponse409 | reservationMarkNoShowResponse422 | reservationMarkNoShowResponse500) & {
  headers: Headers;
};

export type reservationMarkNoShowResponse = (reservationMarkNoShowResponseSuccess | reservationMarkNoShowResponseError)

export const getReservationMarkNoShowUrl = (reservationId: string,) => {




  return `/reservations/${reservationId}/no-show`
}

/**
 * 指定された予約ID（reservationId）の予約を、無断キャンセル（no-show）として登録します。
 * 診療予約時刻を過ぎた予約に対してクリニック担当者が実行する想定です。
 *
 * RBAC簡易注記:
 * - 許可: `clinic-doctor`, `clinic-operator`
 * - 禁止: 上記以外（`ops-*`, `patient-admin`, `patient-user` は不可）
 * @summary 予約を無断キャンセル（no-show）として登録する
 */
export const reservationMarkNoShow = async (reservationId: string, options?: Parameters<typeof http>[1]): Promise<reservationMarkNoShowResponse> => {

  return http<reservationMarkNoShowResponse>(getReservationMarkNoShowUrl(reservationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReservationMarkNoShowMutationKey = () => ['reservationMarkNoShow'] as const;

export const getReservationMarkNoShowMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationMarkNoShow>>, TError,ReservationMarkNoShowMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof reservationMarkNoShow>>, TError,ReservationMarkNoShowMutationVariables, TContext> => {

const mutationKey = getReservationMarkNoShowMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reservationMarkNoShow>>, ReservationMarkNoShowMutationVariables> = (props) => {
          const {reservationId} = props ?? {};

          return  reservationMarkNoShow(reservationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReservationMarkNoShowMutationResult = NonNullable<Awaited<ReturnType<typeof reservationMarkNoShow>>>

    export type ReservationMarkNoShowMutationError = ProblemResponseResponse
    export type ReservationMarkNoShowMutationVariables = {reservationId: string}

    /**
 * @summary 予約を無断キャンセル（no-show）として登録する
 */
export const useReservationMarkNoShow = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationMarkNoShow>>, TError,ReservationMarkNoShowMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reservationMarkNoShow>>,
        TError,
        ReservationMarkNoShowMutationVariables,
        TContext
      > => {
      return useMutation(getReservationMarkNoShowMutationOptions(options), queryClient);
    }

export type taskProgressListByUserResponse200 = {
  data: TaskProgressListByUser200
  status: 200
}

export type taskProgressListByUserResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type taskProgressListByUserResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type taskProgressListByUserResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type taskProgressListByUserResponseSuccess = (taskProgressListByUserResponse200) & {
  headers: Headers;
};
export type taskProgressListByUserResponseError = (taskProgressListByUserResponse401 | taskProgressListByUserResponse403 | taskProgressListByUserResponse500) & {
  headers: Headers;
};

export type taskProgressListByUserResponse = (taskProgressListByUserResponseSuccess | taskProgressListByUserResponseError)

export const getTaskProgressListByUserUrl = (userId: string,) => {




  return `/tasks/by-user/${userId}`
}

/**
 * タスク（やること）の進捗を一覧で返します。
 * 対象がユーザー個別のタスクと、所属組織向け（全ユーザー共有）のタスクの両方を含みます。
 * 組織対象タスクの進捗は、対象組織の全ユーザー間で共有されます。
 * 未完了のタスクのみを返すため、完了したタスクは含まれません。
 * @summary ユーザー別のタスク/やること一覧を取得する
 */
export const taskProgressListByUser = async (userId: string, options?: Parameters<typeof http>[1]): Promise<taskProgressListByUserResponse> => {

  return http<taskProgressListByUserResponse>(getTaskProgressListByUserUrl(userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTaskProgressListByUserQueryKey = (userId: string,) => {
    return [
    `/tasks/by-user/${userId}`
    ] as const;
    }


export const getTaskProgressListByUserQueryOptions = <TData = Awaited<ReturnType<typeof taskProgressListByUser>>, TError = ProblemResponseResponse>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskProgressListByUser>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTaskProgressListByUserQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof taskProgressListByUser>>> = ({ signal }) => taskProgressListByUser(userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof taskProgressListByUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TaskProgressListByUserQueryResult = NonNullable<Awaited<ReturnType<typeof taskProgressListByUser>>>
export type TaskProgressListByUserQueryError = ProblemResponseResponse


export function useTaskProgressListByUser<TData = Awaited<ReturnType<typeof taskProgressListByUser>>, TError = ProblemResponseResponse>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskProgressListByUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskProgressListByUser>>,
          TError,
          Awaited<ReturnType<typeof taskProgressListByUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskProgressListByUser<TData = Awaited<ReturnType<typeof taskProgressListByUser>>, TError = ProblemResponseResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskProgressListByUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskProgressListByUser>>,
          TError,
          Awaited<ReturnType<typeof taskProgressListByUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskProgressListByUser<TData = Awaited<ReturnType<typeof taskProgressListByUser>>, TError = ProblemResponseResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskProgressListByUser>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ユーザー別のタスク/やること一覧を取得する
 */

export function useTaskProgressListByUser<TData = Awaited<ReturnType<typeof taskProgressListByUser>>, TError = ProblemResponseResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskProgressListByUser>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTaskProgressListByUserQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type taskProgressListMeResponse200 = {
  data: TaskProgressListMe200
  status: 200
}

export type taskProgressListMeResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type taskProgressListMeResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type taskProgressListMeResponseSuccess = (taskProgressListMeResponse200) & {
  headers: Headers;
};
export type taskProgressListMeResponseError = (taskProgressListMeResponse401 | taskProgressListMeResponse403) & {
  headers: Headers;
};

export type taskProgressListMeResponse = (taskProgressListMeResponseSuccess | taskProgressListMeResponseError)

export const getTaskProgressListMeUrl = () => {




  return `/tasks/me`
}

/**
 * 認証済みユーザー自身のタスク（やること）の進捗を一覧で返します。
 * ユーザー個別のタスクと、所属組織向け（全ユーザー共有）のタスクの両方を含みます。
 * 未完了のタスクのみを返すため、完了したタスクは含まれません。
 * バックエンドがJWTから内部ユーザーIDを解決するため、フロントエンドでのID指定は不要です。
 * @summary 自分のタスク/やること一覧を取得する
 */
export const taskProgressListMe = async ( options?: Parameters<typeof http>[1]): Promise<taskProgressListMeResponse> => {

  return http<taskProgressListMeResponse>(getTaskProgressListMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTaskProgressListMeQueryKey = () => {
    return [
    `/tasks/me`
    ] as const;
    }


export const getTaskProgressListMeQueryOptions = <TData = Awaited<ReturnType<typeof taskProgressListMe>>, TError = ProblemResponseResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskProgressListMe>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTaskProgressListMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof taskProgressListMe>>> = ({ signal }) => taskProgressListMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof taskProgressListMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TaskProgressListMeQueryResult = NonNullable<Awaited<ReturnType<typeof taskProgressListMe>>>
export type TaskProgressListMeQueryError = ProblemResponseResponse


export function useTaskProgressListMe<TData = Awaited<ReturnType<typeof taskProgressListMe>>, TError = ProblemResponseResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskProgressListMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskProgressListMe>>,
          TError,
          Awaited<ReturnType<typeof taskProgressListMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskProgressListMe<TData = Awaited<ReturnType<typeof taskProgressListMe>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskProgressListMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskProgressListMe>>,
          TError,
          Awaited<ReturnType<typeof taskProgressListMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskProgressListMe<TData = Awaited<ReturnType<typeof taskProgressListMe>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskProgressListMe>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 自分のタスク/やること一覧を取得する
 */

export function useTaskProgressListMe<TData = Awaited<ReturnType<typeof taskProgressListMe>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskProgressListMe>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTaskProgressListMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type taskCreateResponse201 = {
  data: Task
  status: 201
}

export type taskCreateResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type taskCreateResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type taskCreateResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type taskCreateResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type taskCreateResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type taskCreateResponseSuccess = (taskCreateResponse201) & {
  headers: Headers;
};
export type taskCreateResponseError = (taskCreateResponse400 | taskCreateResponse401 | taskCreateResponse403 | taskCreateResponse422 | taskCreateResponse500) & {
  headers: Headers;
};

export type taskCreateResponse = (taskCreateResponseSuccess | taskCreateResponseError)

export const getTaskCreateUrl = () => {




  return `/tasks`
}

/**
 * タスク（やること）を新規登録します。
 * 発行対象として「特定のユーザー」または「特定の組織に所属するすべてのユーザー」を指定できます。
 * 組織を対象としたタスクは、その進捗が対象組織の全ユーザー間で共有されます。
 * @summary タスクを登録する
 */
export const taskCreate = async (taskCreateRequest: TaskCreateRequest, options?: Parameters<typeof http>[1]): Promise<taskCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<taskCreateResponse>(getTaskCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(taskCreateRequest)
  }
);}





export const getTaskCreateMutationKey = () => ['taskCreate'] as const;

export const getTaskCreateMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taskCreate>>, TError,TaskCreateMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof taskCreate>>, TError,TaskCreateMutationVariables, TContext> => {

const mutationKey = getTaskCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof taskCreate>>, TaskCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  taskCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TaskCreateMutationResult = NonNullable<Awaited<ReturnType<typeof taskCreate>>>
    export type TaskCreateMutationBody = TaskCreateRequest
    export type TaskCreateMutationError = ProblemResponseResponse
    export type TaskCreateMutationVariables = {data: TaskCreateRequest}

    /**
 * @summary タスクを登録する
 */
export const useTaskCreate = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taskCreate>>, TError,TaskCreateMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof taskCreate>>,
        TError,
        TaskCreateMutationVariables,
        TContext
      > => {
      return useMutation(getTaskCreateMutationOptions(options), queryClient);
    }

export type taskUpdateResponse200 = {
  data: Task
  status: 200
}

export type taskUpdateResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type taskUpdateResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type taskUpdateResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type taskUpdateResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type taskUpdateResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type taskUpdateResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type taskUpdateResponseSuccess = (taskUpdateResponse200) & {
  headers: Headers;
};
export type taskUpdateResponseError = (taskUpdateResponse400 | taskUpdateResponse401 | taskUpdateResponse403 | taskUpdateResponse404 | taskUpdateResponse422 | taskUpdateResponse500) & {
  headers: Headers;
};

export type taskUpdateResponse = (taskUpdateResponseSuccess | taskUpdateResponseError)

export const getTaskUpdateUrl = (taskId: string,) => {




  return `/tasks/${taskId}`
}

/**
 * 指定したタスクの表示タイトルや進捗状態を部分更新します。
 * タスクの発行対象が組織（target.type=organization）の場合、進捗の更新は対象組織の全ユーザーに共有されます。
 * @summary タスクを更新する
 */
export const taskUpdate = async (taskId: string,
    taskUpdateRequest: TaskUpdateRequest, options?: Parameters<typeof http>[1]): Promise<taskUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<taskUpdateResponse>(getTaskUpdateUrl(taskId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(taskUpdateRequest)
  }
);}





export const getTaskUpdateMutationKey = () => ['taskUpdate'] as const;

export const getTaskUpdateMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taskUpdate>>, TError,TaskUpdateMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof taskUpdate>>, TError,TaskUpdateMutationVariables, TContext> => {

const mutationKey = getTaskUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof taskUpdate>>, TaskUpdateMutationVariables> = (props) => {
          const {taskId,data} = props ?? {};

          return  taskUpdate(taskId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TaskUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof taskUpdate>>>
    export type TaskUpdateMutationBody = TaskUpdateRequest
    export type TaskUpdateMutationError = ProblemResponseResponse
    export type TaskUpdateMutationVariables = {taskId: string;data: TaskUpdateRequest}

    /**
 * @summary タスクを更新する
 */
export const useTaskUpdate = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taskUpdate>>, TError,TaskUpdateMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof taskUpdate>>,
        TError,
        TaskUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getTaskUpdateMutationOptions(options), queryClient);
    }

export type patientTestReportUploadResponse201 = {
  data: void
  status: 201
}

export type patientTestReportUploadResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type patientTestReportUploadResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientTestReportUploadResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientTestReportUploadResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientTestReportUploadResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type patientTestReportUploadResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientTestReportUploadResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientTestReportUploadResponseSuccess = (patientTestReportUploadResponse201) & {
  headers: Headers;
};
export type patientTestReportUploadResponseError = (patientTestReportUploadResponse400 | patientTestReportUploadResponse401 | patientTestReportUploadResponse403 | patientTestReportUploadResponse404 | patientTestReportUploadResponse409 | patientTestReportUploadResponse422 | patientTestReportUploadResponse500) & {
  headers: Headers;
};

export type patientTestReportUploadResponse = (patientTestReportUploadResponseSuccess | patientTestReportUploadResponseError)

export const getPatientTestReportUploadUrl = (patientId: string,) => {




  return `/patients/${patientId}/checkup-report/complete`
}

/**
 * 指定された患者（patientId）に紐づく検査結果レポートのS3キーを登録します。
 * あわせて検査実施日および検査値（AHI/ODI）を同梱して登録できます。
 * 後続のダウンロード用URL発行に利用されます。
 *
 * RBAC（例）:
 * - 許可: ops-*
 * @summary 検査結果レポートアップロード情報を登録する
 */
export const patientTestReportUpload = async (patientId: string,
    patientTestReportUploadRequest: PatientTestReportUploadRequest, options?: Parameters<typeof http>[1]): Promise<patientTestReportUploadResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<patientTestReportUploadResponse>(getPatientTestReportUploadUrl(patientId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patientTestReportUploadRequest)
  }
);}





export const getPatientTestReportUploadMutationKey = () => ['patientTestReportUpload'] as const;

export const getPatientTestReportUploadMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientTestReportUpload>>, TError,PatientTestReportUploadMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof patientTestReportUpload>>, TError,PatientTestReportUploadMutationVariables, TContext> => {

const mutationKey = getPatientTestReportUploadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientTestReportUpload>>, PatientTestReportUploadMutationVariables> = (props) => {
          const {patientId,data} = props ?? {};

          return  patientTestReportUpload(patientId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientTestReportUploadMutationResult = NonNullable<Awaited<ReturnType<typeof patientTestReportUpload>>>
    export type PatientTestReportUploadMutationBody = PatientTestReportUploadRequest
    export type PatientTestReportUploadMutationError = ProblemResponseResponse
    export type PatientTestReportUploadMutationVariables = {patientId: string;data: PatientTestReportUploadRequest}

    /**
 * @summary 検査結果レポートアップロード情報を登録する
 */
export const usePatientTestReportUpload = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientTestReportUpload>>, TError,PatientTestReportUploadMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientTestReportUpload>>,
        TError,
        PatientTestReportUploadMutationVariables,
        TContext
      > => {
      return useMutation(getPatientTestReportUploadMutationOptions(options), queryClient);
    }

export type patientGetTestReportDownloadUrlResponse200 = {
  data: PatientTestReportDownloadResponse
  status: 200
}

export type patientGetTestReportDownloadUrlResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type patientGetTestReportDownloadUrlResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientGetTestReportDownloadUrlResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientGetTestReportDownloadUrlResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientGetTestReportDownloadUrlResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientGetTestReportDownloadUrlResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientGetTestReportDownloadUrlResponseSuccess = (patientGetTestReportDownloadUrlResponse200) & {
  headers: Headers;
};
export type patientGetTestReportDownloadUrlResponseError = (patientGetTestReportDownloadUrlResponse400 | patientGetTestReportDownloadUrlResponse401 | patientGetTestReportDownloadUrlResponse403 | patientGetTestReportDownloadUrlResponse404 | patientGetTestReportDownloadUrlResponse422 | patientGetTestReportDownloadUrlResponse500) & {
  headers: Headers;
};

export type patientGetTestReportDownloadUrlResponse = (patientGetTestReportDownloadUrlResponseSuccess | patientGetTestReportDownloadUrlResponseError)

export const getPatientGetTestReportDownloadUrlUrl = (patientId: string,) => {




  return `/patients/${patientId}/checkup-report/download`
}

/**
 * 指定された患者（patientId）に紐づく検査結果レポートのダウンロード情報を items 配列で返します。
 * 各要素は検査カテゴリ・署名付きURL・作成日時に加え、検査実施日および検査値（AHI/ODI）を返します。
 *
 * RBAC（例）:
 * - 許可: ops-*\/clinic-*
 * @summary 検査結果レポートのダウンロードURL一覧を取得する
 */
export const patientGetTestReportDownloadUrl = async (patientId: string, options?: Parameters<typeof http>[1]): Promise<patientGetTestReportDownloadUrlResponse> => {

  return http<patientGetTestReportDownloadUrlResponse>(getPatientGetTestReportDownloadUrlUrl(patientId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPatientGetTestReportDownloadUrlQueryKey = (patientId: string,) => {
    return [
    `/patients/${patientId}/checkup-report/download`
    ] as const;
    }


export const getPatientGetTestReportDownloadUrlQueryOptions = <TData = Awaited<ReturnType<typeof patientGetTestReportDownloadUrl>>, TError = ProblemResponseResponse>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetTestReportDownloadUrl>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientGetTestReportDownloadUrlQueryKey(patientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientGetTestReportDownloadUrl>>> = ({ signal }) => patientGetTestReportDownloadUrl(patientId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: patientId !== null && patientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientGetTestReportDownloadUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientGetTestReportDownloadUrlQueryResult = NonNullable<Awaited<ReturnType<typeof patientGetTestReportDownloadUrl>>>
export type PatientGetTestReportDownloadUrlQueryError = ProblemResponseResponse


export function usePatientGetTestReportDownloadUrl<TData = Awaited<ReturnType<typeof patientGetTestReportDownloadUrl>>, TError = ProblemResponseResponse>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetTestReportDownloadUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetTestReportDownloadUrl>>,
          TError,
          Awaited<ReturnType<typeof patientGetTestReportDownloadUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetTestReportDownloadUrl<TData = Awaited<ReturnType<typeof patientGetTestReportDownloadUrl>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetTestReportDownloadUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetTestReportDownloadUrl>>,
          TError,
          Awaited<ReturnType<typeof patientGetTestReportDownloadUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetTestReportDownloadUrl<TData = Awaited<ReturnType<typeof patientGetTestReportDownloadUrl>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetTestReportDownloadUrl>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 検査結果レポートのダウンロードURL一覧を取得する
 */

export function usePatientGetTestReportDownloadUrl<TData = Awaited<ReturnType<typeof patientGetTestReportDownloadUrl>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetTestReportDownloadUrl>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientGetTestReportDownloadUrlQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type patientIdentityUploadCompleteResponse201 = {
  data: void
  status: 201
}

export type patientIdentityUploadCompleteResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type patientIdentityUploadCompleteResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientIdentityUploadCompleteResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientIdentityUploadCompleteResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientIdentityUploadCompleteResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type patientIdentityUploadCompleteResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientIdentityUploadCompleteResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientIdentityUploadCompleteResponseSuccess = (patientIdentityUploadCompleteResponse201) & {
  headers: Headers;
};
export type patientIdentityUploadCompleteResponseError = (patientIdentityUploadCompleteResponse400 | patientIdentityUploadCompleteResponse401 | patientIdentityUploadCompleteResponse403 | patientIdentityUploadCompleteResponse404 | patientIdentityUploadCompleteResponse409 | patientIdentityUploadCompleteResponse422 | patientIdentityUploadCompleteResponse500) & {
  headers: Headers;
};

export type patientIdentityUploadCompleteResponse = (patientIdentityUploadCompleteResponseSuccess | patientIdentityUploadCompleteResponseError)

export const getPatientIdentityUploadCompleteUrl = (patientId: string,) => {




  return `/patients/${patientId}/identity-or-insurance/complete`
}

/**
 * 指定された患者（patientId）に紐づく保険証/身分証のS3キーを登録します（PATCHセマンティクス）。
 * 以後のダウンロード用URL発行に利用されます。
 * オブジェクト形式で保険証・身分証それぞれの表面(front)のS3キーをまとめて渡せます。
 * - フィールド未指定の場合は変更を行いません（既存データは保持）。
 * - プロパティ（insuranceCard/identityDocument）自体を未指定の場合は当該カテゴリの変更は行いません。
 * - 削除は専用の DELETE エンドポイント（PatientIdentityDocumentCategoryDelete）を使用してください。
 * /uploads/initと/uploads/completeを事前に実行済みなことが前提です。
 *
 * RBAC（例）:
 * - 許可: ops-*
 * - 許可: patient-user（本人のみ。patientIdの指定内容に関わらず、本人に対して更新が行われます）
 * @summary 保険証/身分証のアップロード情報を登録する
 */
export const patientIdentityUploadComplete = async (patientId: string,
    patientIdentityUploadCompleteRequest: PatientIdentityUploadCompleteRequest, options?: Parameters<typeof http>[1]): Promise<patientIdentityUploadCompleteResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<patientIdentityUploadCompleteResponse>(getPatientIdentityUploadCompleteUrl(patientId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patientIdentityUploadCompleteRequest)
  }
);}





export const getPatientIdentityUploadCompleteMutationKey = () => ['patientIdentityUploadComplete'] as const;

export const getPatientIdentityUploadCompleteMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientIdentityUploadComplete>>, TError,PatientIdentityUploadCompleteMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof patientIdentityUploadComplete>>, TError,PatientIdentityUploadCompleteMutationVariables, TContext> => {

const mutationKey = getPatientIdentityUploadCompleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientIdentityUploadComplete>>, PatientIdentityUploadCompleteMutationVariables> = (props) => {
          const {patientId,data} = props ?? {};

          return  patientIdentityUploadComplete(patientId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientIdentityUploadCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof patientIdentityUploadComplete>>>
    export type PatientIdentityUploadCompleteMutationBody = PatientIdentityUploadCompleteRequest
    export type PatientIdentityUploadCompleteMutationError = ProblemResponseResponse
    export type PatientIdentityUploadCompleteMutationVariables = {patientId: string;data: PatientIdentityUploadCompleteRequest}

    /**
 * @summary 保険証/身分証のアップロード情報を登録する
 */
export const usePatientIdentityUploadComplete = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientIdentityUploadComplete>>, TError,PatientIdentityUploadCompleteMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientIdentityUploadComplete>>,
        TError,
        PatientIdentityUploadCompleteMutationVariables,
        TContext
      > => {
      return useMutation(getPatientIdentityUploadCompleteMutationOptions(options), queryClient);
    }

export type patientIdentityDocumentCategoryDeleteResponse204 = {
  data: void
  status: 204
}

export type patientIdentityDocumentCategoryDeleteResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientIdentityDocumentCategoryDeleteResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientIdentityDocumentCategoryDeleteResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientIdentityDocumentCategoryDeleteResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientIdentityDocumentCategoryDeleteResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientIdentityDocumentCategoryDeleteResponseSuccess = (patientIdentityDocumentCategoryDeleteResponse204) & {
  headers: Headers;
};
export type patientIdentityDocumentCategoryDeleteResponseError = (patientIdentityDocumentCategoryDeleteResponse401 | patientIdentityDocumentCategoryDeleteResponse403 | patientIdentityDocumentCategoryDeleteResponse404 | patientIdentityDocumentCategoryDeleteResponse422 | patientIdentityDocumentCategoryDeleteResponse500) & {
  headers: Headers;
};

export type patientIdentityDocumentCategoryDeleteResponse = (patientIdentityDocumentCategoryDeleteResponseSuccess | patientIdentityDocumentCategoryDeleteResponseError)

export const getPatientIdentityDocumentCategoryDeleteUrl = (patientId: string,
    category: IdentityUploadCategory,) => {




  return `/patients/${patientId}/identity-documents/${category}`
}

/**
 * 指定した患者の保険証または身分証をカテゴリ単位で削除（論理削除）します。
 * カテゴリ配下のアクティブな書類行（FRONT/BACK）はすべて削除対象です。
 *
 * RBAC（例）:
 * - 許可: ops-*
 * - 許可: patient-user（本人のみ。patientIdの指定内容に関わらず、本人に対して削除が行われます）
 * @summary 保険証/身分証をカテゴリ単位で削除する
 */
export const patientIdentityDocumentCategoryDelete = async (patientId: string,
    category: IdentityUploadCategory, options?: Parameters<typeof http>[1]): Promise<patientIdentityDocumentCategoryDeleteResponse> => {

  return http<patientIdentityDocumentCategoryDeleteResponse>(getPatientIdentityDocumentCategoryDeleteUrl(patientId,category),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getPatientIdentityDocumentCategoryDeleteMutationKey = () => ['patientIdentityDocumentCategoryDelete'] as const;

export const getPatientIdentityDocumentCategoryDeleteMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientIdentityDocumentCategoryDelete>>, TError,PatientIdentityDocumentCategoryDeleteMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof patientIdentityDocumentCategoryDelete>>, TError,PatientIdentityDocumentCategoryDeleteMutationVariables, TContext> => {

const mutationKey = getPatientIdentityDocumentCategoryDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientIdentityDocumentCategoryDelete>>, PatientIdentityDocumentCategoryDeleteMutationVariables> = (props) => {
          const {patientId,category} = props ?? {};

          return  patientIdentityDocumentCategoryDelete(patientId,category,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientIdentityDocumentCategoryDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof patientIdentityDocumentCategoryDelete>>>

    export type PatientIdentityDocumentCategoryDeleteMutationError = ProblemResponseResponse
    export type PatientIdentityDocumentCategoryDeleteMutationVariables = {patientId: string;category: IdentityUploadCategory}

    /**
 * @summary 保険証/身分証をカテゴリ単位で削除する
 */
export const usePatientIdentityDocumentCategoryDelete = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientIdentityDocumentCategoryDelete>>, TError,PatientIdentityDocumentCategoryDeleteMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientIdentityDocumentCategoryDelete>>,
        TError,
        PatientIdentityDocumentCategoryDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getPatientIdentityDocumentCategoryDeleteMutationOptions(options), queryClient);
    }

export type doctorGetMyInfoResponse200 = {
  data: DoctorSelf
  status: 200
}

export type doctorGetMyInfoResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type doctorGetMyInfoResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type doctorGetMyInfoResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type doctorGetMyInfoResponseSuccess = (doctorGetMyInfoResponse200) & {
  headers: Headers;
};
export type doctorGetMyInfoResponseError = (doctorGetMyInfoResponse401 | doctorGetMyInfoResponse403 | doctorGetMyInfoResponse500) & {
  headers: Headers;
};

export type doctorGetMyInfoResponse = (doctorGetMyInfoResponseSuccess | doctorGetMyInfoResponseError)

export const getDoctorGetMyInfoUrl = () => {




  return `/doctors/me`
}

/**
 * ログイン中の医師ユーザー（自分）の内部ユーザーID（UUID）と氏名を返します。
 *
 * - doctorUserId: アプリ内部の `app.users.id`（予約枠APIで使用）
 * - doctorName: 表示名（予約枠一覧などで使用）
 *
 * RBAC（Option A）:
 * - 許可: clinic-doctor
 * @summary 自分（医師）のユーザーIDと氏名を取得する
 */
export const doctorGetMyInfo = async ( options?: Parameters<typeof http>[1]): Promise<doctorGetMyInfoResponse> => {

  return http<doctorGetMyInfoResponse>(getDoctorGetMyInfoUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDoctorGetMyInfoQueryKey = () => {
    return [
    `/doctors/me`
    ] as const;
    }


export const getDoctorGetMyInfoQueryOptions = <TData = Awaited<ReturnType<typeof doctorGetMyInfo>>, TError = ProblemResponseResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof doctorGetMyInfo>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDoctorGetMyInfoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof doctorGetMyInfo>>> = ({ signal }) => doctorGetMyInfo({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof doctorGetMyInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DoctorGetMyInfoQueryResult = NonNullable<Awaited<ReturnType<typeof doctorGetMyInfo>>>
export type DoctorGetMyInfoQueryError = ProblemResponseResponse


export function useDoctorGetMyInfo<TData = Awaited<ReturnType<typeof doctorGetMyInfo>>, TError = ProblemResponseResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof doctorGetMyInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof doctorGetMyInfo>>,
          TError,
          Awaited<ReturnType<typeof doctorGetMyInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDoctorGetMyInfo<TData = Awaited<ReturnType<typeof doctorGetMyInfo>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof doctorGetMyInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof doctorGetMyInfo>>,
          TError,
          Awaited<ReturnType<typeof doctorGetMyInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDoctorGetMyInfo<TData = Awaited<ReturnType<typeof doctorGetMyInfo>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof doctorGetMyInfo>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 自分（医師）のユーザーIDと氏名を取得する
 */

export function useDoctorGetMyInfo<TData = Awaited<ReturnType<typeof doctorGetMyInfo>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof doctorGetMyInfo>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDoctorGetMyInfoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type termsOfUseConsentGetMeResponse200 = {
  data: TermsOfUseConsentStatus
  status: 200
}

export type termsOfUseConsentGetMeResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type termsOfUseConsentGetMeResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type termsOfUseConsentGetMeResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type termsOfUseConsentGetMeResponseSuccess = (termsOfUseConsentGetMeResponse200) & {
  headers: Headers;
};
export type termsOfUseConsentGetMeResponseError = (termsOfUseConsentGetMeResponse401 | termsOfUseConsentGetMeResponse403 | termsOfUseConsentGetMeResponse500) & {
  headers: Headers;
};

export type termsOfUseConsentGetMeResponse = (termsOfUseConsentGetMeResponseSuccess | termsOfUseConsentGetMeResponseError)

export const getTermsOfUseConsentGetMeUrl = () => {




  return `/terms-of-use-consent/me`
}

/**
 * 認証済みユーザー（バックエンドで認証情報から特定）の利用規約同意状態を返します。クライアントは返却される理由に応じて同意ダイアログを表示します。
 *
 * 患者/企業管理者/医療機関それぞれで利用規約の内容が異なります。
 * 認証済みユーザーのロール（patient-user / patient-admin / clinic-*）を元に、フロント側でどの利用規約を表示するかを判別します。
 * @summary 利用規約の同意状態（理由含む）を取得する
 */
export const termsOfUseConsentGetMe = async ( options?: Parameters<typeof http>[1]): Promise<termsOfUseConsentGetMeResponse> => {

  return http<termsOfUseConsentGetMeResponse>(getTermsOfUseConsentGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTermsOfUseConsentGetMeQueryKey = () => {
    return [
    `/terms-of-use-consent/me`
    ] as const;
    }


export const getTermsOfUseConsentGetMeQueryOptions = <TData = Awaited<ReturnType<typeof termsOfUseConsentGetMe>>, TError = ProblemResponseResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof termsOfUseConsentGetMe>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTermsOfUseConsentGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof termsOfUseConsentGetMe>>> = ({ signal }) => termsOfUseConsentGetMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof termsOfUseConsentGetMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TermsOfUseConsentGetMeQueryResult = NonNullable<Awaited<ReturnType<typeof termsOfUseConsentGetMe>>>
export type TermsOfUseConsentGetMeQueryError = ProblemResponseResponse


export function useTermsOfUseConsentGetMe<TData = Awaited<ReturnType<typeof termsOfUseConsentGetMe>>, TError = ProblemResponseResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof termsOfUseConsentGetMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof termsOfUseConsentGetMe>>,
          TError,
          Awaited<ReturnType<typeof termsOfUseConsentGetMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTermsOfUseConsentGetMe<TData = Awaited<ReturnType<typeof termsOfUseConsentGetMe>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof termsOfUseConsentGetMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof termsOfUseConsentGetMe>>,
          TError,
          Awaited<ReturnType<typeof termsOfUseConsentGetMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTermsOfUseConsentGetMe<TData = Awaited<ReturnType<typeof termsOfUseConsentGetMe>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof termsOfUseConsentGetMe>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 利用規約の同意状態（理由含む）を取得する
 */

export function useTermsOfUseConsentGetMe<TData = Awaited<ReturnType<typeof termsOfUseConsentGetMe>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof termsOfUseConsentGetMe>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTermsOfUseConsentGetMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type termsOfUseConsentAgreeMeResponse200 = {
  data: TermsOfUseConsentStatus
  status: 200
}

export type termsOfUseConsentAgreeMeResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type termsOfUseConsentAgreeMeResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type termsOfUseConsentAgreeMeResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type termsOfUseConsentAgreeMeResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type termsOfUseConsentAgreeMeResponseSuccess = (termsOfUseConsentAgreeMeResponse200) & {
  headers: Headers;
};
export type termsOfUseConsentAgreeMeResponseError = (termsOfUseConsentAgreeMeResponse401 | termsOfUseConsentAgreeMeResponse403 | termsOfUseConsentAgreeMeResponse404 | termsOfUseConsentAgreeMeResponse500) & {
  headers: Headers;
};

export type termsOfUseConsentAgreeMeResponse = (termsOfUseConsentAgreeMeResponseSuccess | termsOfUseConsentAgreeMeResponseError)

export const getTermsOfUseConsentAgreeMeUrl = () => {




  return `/terms-of-use-consent/me`
}

/**
 * 認証済みユーザー（バックエンドで認証情報から特定）の利用規約同意フラグを true として記録します。
 *
 * 患者/企業管理者/医療機関それぞれで利用規約の内容が異なります。
 * 認証済みユーザーのロール（patient-user / patient-admin / clinic-*）を元に、フロント側でどの利用規約を表示するかを判別します。
 * @summary 利用規約に同意済みとして記録する
 */
export const termsOfUseConsentAgreeMe = async ( options?: Parameters<typeof http>[1]): Promise<termsOfUseConsentAgreeMeResponse> => {

  return http<termsOfUseConsentAgreeMeResponse>(getTermsOfUseConsentAgreeMeUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getTermsOfUseConsentAgreeMeMutationKey = () => ['termsOfUseConsentAgreeMe'] as const;

export const getTermsOfUseConsentAgreeMeMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof termsOfUseConsentAgreeMe>>, TError,void, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof termsOfUseConsentAgreeMe>>, TError,void, TContext> => {

const mutationKey = getTermsOfUseConsentAgreeMeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof termsOfUseConsentAgreeMe>>, void> = () => {


          return  termsOfUseConsentAgreeMe(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TermsOfUseConsentAgreeMeMutationResult = NonNullable<Awaited<ReturnType<typeof termsOfUseConsentAgreeMe>>>

    export type TermsOfUseConsentAgreeMeMutationError = ProblemResponseResponse


    /**
 * @summary 利用規約に同意済みとして記録する
 */
export const useTermsOfUseConsentAgreeMe = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof termsOfUseConsentAgreeMe>>, TError,void, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof termsOfUseConsentAgreeMe>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getTermsOfUseConsentAgreeMeMutationOptions(options), queryClient);
    }

export type patientListNotesResponse200 = {
  data: PatientListNotes200
  status: 200
}

export type patientListNotesResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientListNotesResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientListNotesResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientListNotesResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientListNotesResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientListNotesResponseSuccess = (patientListNotesResponse200) & {
  headers: Headers;
};
export type patientListNotesResponseError = (patientListNotesResponse401 | patientListNotesResponse403 | patientListNotesResponse404 | patientListNotesResponse422 | patientListNotesResponse500) & {
  headers: Headers;
};

export type patientListNotesResponse = (patientListNotesResponseSuccess | patientListNotesResponseError)

export const getPatientListNotesUrl = (patientId: string,
    params?: PatientListNotesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/notes/patients/${patientId}?${stringifiedParams}` : `/notes/patients/${patientId}`
}

/**
 * 指定された患者（patientId）の応対履歴（記事欄）一覧を返します。
 *
 * RBAC（Option A）:
 * - 許可: ops-admin / ops-operator
 * @summary 患者の応対履歴一覧を取得する
 */
export const patientListNotes = async (patientId: string,
    params?: PatientListNotesParams, options?: Parameters<typeof http>[1]): Promise<patientListNotesResponse> => {

  return http<patientListNotesResponse>(getPatientListNotesUrl(patientId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPatientListNotesQueryKey = (patientId: string,
    params?: PatientListNotesParams,) => {
    return [
    `/notes/patients/${patientId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getPatientListNotesQueryOptions = <TData = Awaited<ReturnType<typeof patientListNotes>>, TError = ProblemResponseResponse>(patientId: string,
    params?: PatientListNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListNotes>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientListNotesQueryKey(patientId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientListNotes>>> = ({ signal }) => patientListNotes(patientId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: patientId !== null && patientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientListNotes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientListNotesQueryResult = NonNullable<Awaited<ReturnType<typeof patientListNotes>>>
export type PatientListNotesQueryError = ProblemResponseResponse


export function usePatientListNotes<TData = Awaited<ReturnType<typeof patientListNotes>>, TError = ProblemResponseResponse>(
 patientId: string,
    params: undefined |  PatientListNotesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListNotes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientListNotes>>,
          TError,
          Awaited<ReturnType<typeof patientListNotes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientListNotes<TData = Awaited<ReturnType<typeof patientListNotes>>, TError = ProblemResponseResponse>(
 patientId: string,
    params?: PatientListNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListNotes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientListNotes>>,
          TError,
          Awaited<ReturnType<typeof patientListNotes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientListNotes<TData = Awaited<ReturnType<typeof patientListNotes>>, TError = ProblemResponseResponse>(
 patientId: string,
    params?: PatientListNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListNotes>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者の応対履歴一覧を取得する
 */

export function usePatientListNotes<TData = Awaited<ReturnType<typeof patientListNotes>>, TError = ProblemResponseResponse>(
 patientId: string,
    params?: PatientListNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientListNotes>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientListNotesQueryOptions(patientId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type patientCreateNoteResponse201 = {
  data: PatientNote
  status: 201
}

export type patientCreateNoteResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type patientCreateNoteResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientCreateNoteResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientCreateNoteResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type patientCreateNoteResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientCreateNoteResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientCreateNoteResponseSuccess = (patientCreateNoteResponse201) & {
  headers: Headers;
};
export type patientCreateNoteResponseError = (patientCreateNoteResponse400 | patientCreateNoteResponse401 | patientCreateNoteResponse403 | patientCreateNoteResponse409 | patientCreateNoteResponse422 | patientCreateNoteResponse500) & {
  headers: Headers;
};

export type patientCreateNoteResponse = (patientCreateNoteResponseSuccess | patientCreateNoteResponseError)

export const getPatientCreateNoteUrl = (patientId: string,) => {




  return `/notes/patients/${patientId}`
}

/**
 * 指定された患者（patientId）の応対履歴（記事欄）を登録します。テキスト最大2000文字まで許容します。
 *
 * RBAC（Option A）:
 * - 許可: ops-admin / ops-operator
 * @summary 患者の応対履歴を登録する
 */
export const patientCreateNote = async (patientId: string,
    patientNoteCreateRequest: PatientNoteCreateRequest, options?: Parameters<typeof http>[1]): Promise<patientCreateNoteResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<patientCreateNoteResponse>(getPatientCreateNoteUrl(patientId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patientNoteCreateRequest)
  }
);}





export const getPatientCreateNoteMutationKey = () => ['patientCreateNote'] as const;

export const getPatientCreateNoteMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientCreateNote>>, TError,PatientCreateNoteMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof patientCreateNote>>, TError,PatientCreateNoteMutationVariables, TContext> => {

const mutationKey = getPatientCreateNoteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientCreateNote>>, PatientCreateNoteMutationVariables> = (props) => {
          const {patientId,data} = props ?? {};

          return  patientCreateNote(patientId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientCreateNoteMutationResult = NonNullable<Awaited<ReturnType<typeof patientCreateNote>>>
    export type PatientCreateNoteMutationBody = PatientNoteCreateRequest
    export type PatientCreateNoteMutationError = ProblemResponseResponse
    export type PatientCreateNoteMutationVariables = {patientId: string;data: PatientNoteCreateRequest}

    /**
 * @summary 患者の応対履歴を登録する
 */
export const usePatientCreateNote = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientCreateNote>>, TError,PatientCreateNoteMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientCreateNote>>,
        TError,
        PatientCreateNoteMutationVariables,
        TContext
      > => {
      return useMutation(getPatientCreateNoteMutationOptions(options), queryClient);
    }

export type cpapPrescriptionCreateResponse201 = {
  data: CpapPrescription
  status: 201
}

export type cpapPrescriptionCreateResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type cpapPrescriptionCreateResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type cpapPrescriptionCreateResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type cpapPrescriptionCreateResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type cpapPrescriptionCreateResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type cpapPrescriptionCreateResponseSuccess = (cpapPrescriptionCreateResponse201) & {
  headers: Headers;
};
export type cpapPrescriptionCreateResponseError = (cpapPrescriptionCreateResponse400 | cpapPrescriptionCreateResponse401 | cpapPrescriptionCreateResponse403 | cpapPrescriptionCreateResponse422 | cpapPrescriptionCreateResponse500) & {
  headers: Headers;
};

export type cpapPrescriptionCreateResponse = (cpapPrescriptionCreateResponseSuccess | cpapPrescriptionCreateResponseError)

export const getCpapPrescriptionCreateUrl = () => {




  return `/cpap-prescriptions`
}

/**
 * CPAP処方指示書を新規作成します（status=draft）。
 * 管理番号はSEQUENCEから自動採番されます。
 * draft 保存では doctorUserId と instructionDate を未入力にできます。
 *
 * RBAC:
 * - 許可: clinic-doctor, clinic-operator
 * @summary CPAP処方指示書を新規作成する
 */
export const cpapPrescriptionCreate = async (cpapPrescriptionCreateRequest: CpapPrescriptionCreateRequest, options?: Parameters<typeof http>[1]): Promise<cpapPrescriptionCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<cpapPrescriptionCreateResponse>(getCpapPrescriptionCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cpapPrescriptionCreateRequest)
  }
);}





export const getCpapPrescriptionCreateMutationKey = () => ['cpapPrescriptionCreate'] as const;

export const getCpapPrescriptionCreateMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cpapPrescriptionCreate>>, TError,CpapPrescriptionCreateMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof cpapPrescriptionCreate>>, TError,CpapPrescriptionCreateMutationVariables, TContext> => {

const mutationKey = getCpapPrescriptionCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cpapPrescriptionCreate>>, CpapPrescriptionCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  cpapPrescriptionCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CpapPrescriptionCreateMutationResult = NonNullable<Awaited<ReturnType<typeof cpapPrescriptionCreate>>>
    export type CpapPrescriptionCreateMutationBody = CpapPrescriptionCreateRequest
    export type CpapPrescriptionCreateMutationError = ProblemResponseResponse
    export type CpapPrescriptionCreateMutationVariables = {data: CpapPrescriptionCreateRequest}

    /**
 * @summary CPAP処方指示書を新規作成する
 */
export const useCpapPrescriptionCreate = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cpapPrescriptionCreate>>, TError,CpapPrescriptionCreateMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cpapPrescriptionCreate>>,
        TError,
        CpapPrescriptionCreateMutationVariables,
        TContext
      > => {
      return useMutation(getCpapPrescriptionCreateMutationOptions(options), queryClient);
    }

export type cpapPrescriptionGetResponse200 = {
  data: CpapPrescription
  status: 200
}

export type cpapPrescriptionGetResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type cpapPrescriptionGetResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type cpapPrescriptionGetResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type cpapPrescriptionGetResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type cpapPrescriptionGetResponseSuccess = (cpapPrescriptionGetResponse200) & {
  headers: Headers;
};
export type cpapPrescriptionGetResponseError = (cpapPrescriptionGetResponse401 | cpapPrescriptionGetResponse403 | cpapPrescriptionGetResponse404 | cpapPrescriptionGetResponse500) & {
  headers: Headers;
};

export type cpapPrescriptionGetResponse = (cpapPrescriptionGetResponseSuccess | cpapPrescriptionGetResponseError)

export const getCpapPrescriptionGetUrl = (prescriptionId: string,) => {




  return `/cpap-prescriptions/${prescriptionId}`
}

/**
 * 指定された処方指示書（prescriptionId）の詳細情報を返します。
 *
 * RBAC:
 * - 許可: 全ロール
 * @summary CPAP処方指示書の詳細を取得する
 */
export const cpapPrescriptionGet = async (prescriptionId: string, options?: Parameters<typeof http>[1]): Promise<cpapPrescriptionGetResponse> => {

  return http<cpapPrescriptionGetResponse>(getCpapPrescriptionGetUrl(prescriptionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCpapPrescriptionGetQueryKey = (prescriptionId: string,) => {
    return [
    `/cpap-prescriptions/${prescriptionId}`
    ] as const;
    }


export const getCpapPrescriptionGetQueryOptions = <TData = Awaited<ReturnType<typeof cpapPrescriptionGet>>, TError = ProblemResponseResponse>(prescriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cpapPrescriptionGet>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCpapPrescriptionGetQueryKey(prescriptionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof cpapPrescriptionGet>>> = ({ signal }) => cpapPrescriptionGet(prescriptionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: prescriptionId !== null && prescriptionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cpapPrescriptionGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CpapPrescriptionGetQueryResult = NonNullable<Awaited<ReturnType<typeof cpapPrescriptionGet>>>
export type CpapPrescriptionGetQueryError = ProblemResponseResponse


export function useCpapPrescriptionGet<TData = Awaited<ReturnType<typeof cpapPrescriptionGet>>, TError = ProblemResponseResponse>(
 prescriptionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof cpapPrescriptionGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof cpapPrescriptionGet>>,
          TError,
          Awaited<ReturnType<typeof cpapPrescriptionGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCpapPrescriptionGet<TData = Awaited<ReturnType<typeof cpapPrescriptionGet>>, TError = ProblemResponseResponse>(
 prescriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cpapPrescriptionGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof cpapPrescriptionGet>>,
          TError,
          Awaited<ReturnType<typeof cpapPrescriptionGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCpapPrescriptionGet<TData = Awaited<ReturnType<typeof cpapPrescriptionGet>>, TError = ProblemResponseResponse>(
 prescriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cpapPrescriptionGet>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary CPAP処方指示書の詳細を取得する
 */

export function useCpapPrescriptionGet<TData = Awaited<ReturnType<typeof cpapPrescriptionGet>>, TError = ProblemResponseResponse>(
 prescriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cpapPrescriptionGet>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCpapPrescriptionGetQueryOptions(prescriptionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type cpapPrescriptionUpdateResponse200 = {
  data: CpapPrescription
  status: 200
}

export type cpapPrescriptionUpdateResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type cpapPrescriptionUpdateResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type cpapPrescriptionUpdateResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type cpapPrescriptionUpdateResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type cpapPrescriptionUpdateResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type cpapPrescriptionUpdateResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type cpapPrescriptionUpdateResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type cpapPrescriptionUpdateResponseSuccess = (cpapPrescriptionUpdateResponse200) & {
  headers: Headers;
};
export type cpapPrescriptionUpdateResponseError = (cpapPrescriptionUpdateResponse400 | cpapPrescriptionUpdateResponse401 | cpapPrescriptionUpdateResponse403 | cpapPrescriptionUpdateResponse404 | cpapPrescriptionUpdateResponse409 | cpapPrescriptionUpdateResponse422 | cpapPrescriptionUpdateResponse500) & {
  headers: Headers;
};

export type cpapPrescriptionUpdateResponse = (cpapPrescriptionUpdateResponseSuccess | cpapPrescriptionUpdateResponseError)

export const getCpapPrescriptionUpdateUrl = (prescriptionId: string,) => {




  return `/cpap-prescriptions/${prescriptionId}`
}

/**
 * 指定された処方指示書（prescriptionId）を部分更新します。
 * - submitted 以降は inventoryContent 以外の医療者フィールドは凍結（409）
 * - inventoryContent は OPS スコープのみ更新可。CLINIC スコープから inventoryContent を更新すると 403
 * - prescriptionContent, status, orderType, doctorUserId, instructionDate は CLINIC スコープのみ更新可。OPS からこれらを更新すると 403
 * - status=submitted への変更時、同一患者に既存のsubmittedがあれば409
 *
 * RBAC:
 * - 許可: clinic-doctor, clinic-operator, ops-admin, ops-operator
 * @summary CPAP処方指示書を更新する
 */
export const cpapPrescriptionUpdate = async (prescriptionId: string,
    cpapPrescriptionPatchRequest: CpapPrescriptionPatchRequest, options?: Parameters<typeof http>[1]): Promise<cpapPrescriptionUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<cpapPrescriptionUpdateResponse>(getCpapPrescriptionUpdateUrl(prescriptionId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cpapPrescriptionPatchRequest)
  }
);}





export const getCpapPrescriptionUpdateMutationKey = () => ['cpapPrescriptionUpdate'] as const;

export const getCpapPrescriptionUpdateMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cpapPrescriptionUpdate>>, TError,CpapPrescriptionUpdateMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof cpapPrescriptionUpdate>>, TError,CpapPrescriptionUpdateMutationVariables, TContext> => {

const mutationKey = getCpapPrescriptionUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cpapPrescriptionUpdate>>, CpapPrescriptionUpdateMutationVariables> = (props) => {
          const {prescriptionId,data} = props ?? {};

          return  cpapPrescriptionUpdate(prescriptionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CpapPrescriptionUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof cpapPrescriptionUpdate>>>
    export type CpapPrescriptionUpdateMutationBody = CpapPrescriptionPatchRequest
    export type CpapPrescriptionUpdateMutationError = ProblemResponseResponse
    export type CpapPrescriptionUpdateMutationVariables = {prescriptionId: string;data: CpapPrescriptionPatchRequest}

    /**
 * @summary CPAP処方指示書を更新する
 */
export const useCpapPrescriptionUpdate = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cpapPrescriptionUpdate>>, TError,CpapPrescriptionUpdateMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cpapPrescriptionUpdate>>,
        TError,
        CpapPrescriptionUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getCpapPrescriptionUpdateMutationOptions(options), queryClient);
    }

export type cpapPrescriptionConsentResponse200 = {
  data: CpapPrescription
  status: 200
}

export type cpapPrescriptionConsentResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type cpapPrescriptionConsentResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type cpapPrescriptionConsentResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type cpapPrescriptionConsentResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type cpapPrescriptionConsentResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type cpapPrescriptionConsentResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type cpapPrescriptionConsentResponseSuccess = (cpapPrescriptionConsentResponse200) & {
  headers: Headers;
};
export type cpapPrescriptionConsentResponseError = (cpapPrescriptionConsentResponse400 | cpapPrescriptionConsentResponse401 | cpapPrescriptionConsentResponse403 | cpapPrescriptionConsentResponse404 | cpapPrescriptionConsentResponse409 | cpapPrescriptionConsentResponse500) & {
  headers: Headers;
};

export type cpapPrescriptionConsentResponse = (cpapPrescriptionConsentResponseSuccess | cpapPrescriptionConsentResponseError)

export const getCpapPrescriptionConsentUrl = (prescriptionId: string,) => {




  return `/cpap-prescriptions/${prescriptionId}/consent`
}

/**
 * 指定された処方指示書（prescriptionId）に患者が同意します。
 * request body の consented は true のみ受け付けます。
 * request body には画面に表示した同意文書バージョンと文言スナップショットを含めます。
 * status=submittedの場合のみ操作可能。それ以外は409。
 *
 * RBAC:
 * - 許可: patient-user
 * @summary CPAP処方指示書に患者が同意する
 */
export const cpapPrescriptionConsent = async (prescriptionId: string,
    cpapPrescriptionConsentRequest: CpapPrescriptionConsentRequest, options?: Parameters<typeof http>[1]): Promise<cpapPrescriptionConsentResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<cpapPrescriptionConsentResponse>(getCpapPrescriptionConsentUrl(prescriptionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cpapPrescriptionConsentRequest)
  }
);}





export const getCpapPrescriptionConsentMutationKey = () => ['cpapPrescriptionConsent'] as const;

export const getCpapPrescriptionConsentMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cpapPrescriptionConsent>>, TError,CpapPrescriptionConsentMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof cpapPrescriptionConsent>>, TError,CpapPrescriptionConsentMutationVariables, TContext> => {

const mutationKey = getCpapPrescriptionConsentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cpapPrescriptionConsent>>, CpapPrescriptionConsentMutationVariables> = (props) => {
          const {prescriptionId,data} = props ?? {};

          return  cpapPrescriptionConsent(prescriptionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CpapPrescriptionConsentMutationResult = NonNullable<Awaited<ReturnType<typeof cpapPrescriptionConsent>>>
    export type CpapPrescriptionConsentMutationBody = CpapPrescriptionConsentRequest
    export type CpapPrescriptionConsentMutationError = ProblemResponseResponse
    export type CpapPrescriptionConsentMutationVariables = {prescriptionId: string;data: CpapPrescriptionConsentRequest}

    /**
 * @summary CPAP処方指示書に患者が同意する
 */
export const useCpapPrescriptionConsent = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cpapPrescriptionConsent>>, TError,CpapPrescriptionConsentMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cpapPrescriptionConsent>>,
        TError,
        CpapPrescriptionConsentMutationVariables,
        TContext
      > => {
      return useMutation(getCpapPrescriptionConsentMutationOptions(options), queryClient);
    }

export type cpapPrescriptionListByPatientResponse200 = {
  data: CpapPrescriptionListResponse
  status: 200
}

export type cpapPrescriptionListByPatientResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type cpapPrescriptionListByPatientResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type cpapPrescriptionListByPatientResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type cpapPrescriptionListByPatientResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type cpapPrescriptionListByPatientResponseSuccess = (cpapPrescriptionListByPatientResponse200) & {
  headers: Headers;
};
export type cpapPrescriptionListByPatientResponseError = (cpapPrescriptionListByPatientResponse400 | cpapPrescriptionListByPatientResponse401 | cpapPrescriptionListByPatientResponse403 | cpapPrescriptionListByPatientResponse500) & {
  headers: Headers;
};

export type cpapPrescriptionListByPatientResponse = (cpapPrescriptionListByPatientResponseSuccess | cpapPrescriptionListByPatientResponseError)

export const getCpapPrescriptionListByPatientUrl = (patientId: string,
    params?: CpapPrescriptionListByPatientParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/cpap-prescriptions/by-patient/${patientId}?${stringifiedParams}` : `/cpap-prescriptions/by-patient/${patientId}`
}

/**
 * 指定された患者（patientId）のCPAP処方指示書一覧を返します。
 * statusでフィルタ可能。
 *
 * RBAC:
 * - 許可: 全ロール
 * @summary 患者のCPAP処方指示書一覧を取得する
 */
export const cpapPrescriptionListByPatient = async (patientId: string,
    params?: CpapPrescriptionListByPatientParams, options?: Parameters<typeof http>[1]): Promise<cpapPrescriptionListByPatientResponse> => {

  return http<cpapPrescriptionListByPatientResponse>(getCpapPrescriptionListByPatientUrl(patientId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCpapPrescriptionListByPatientQueryKey = (patientId: string,
    params?: CpapPrescriptionListByPatientParams,) => {
    return [
    `/cpap-prescriptions/by-patient/${patientId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getCpapPrescriptionListByPatientQueryOptions = <TData = Awaited<ReturnType<typeof cpapPrescriptionListByPatient>>, TError = ProblemResponseResponse>(patientId: string,
    params?: CpapPrescriptionListByPatientParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cpapPrescriptionListByPatient>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCpapPrescriptionListByPatientQueryKey(patientId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof cpapPrescriptionListByPatient>>> = ({ signal }) => cpapPrescriptionListByPatient(patientId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: patientId !== null && patientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cpapPrescriptionListByPatient>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CpapPrescriptionListByPatientQueryResult = NonNullable<Awaited<ReturnType<typeof cpapPrescriptionListByPatient>>>
export type CpapPrescriptionListByPatientQueryError = ProblemResponseResponse


export function useCpapPrescriptionListByPatient<TData = Awaited<ReturnType<typeof cpapPrescriptionListByPatient>>, TError = ProblemResponseResponse>(
 patientId: string,
    params: undefined |  CpapPrescriptionListByPatientParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof cpapPrescriptionListByPatient>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof cpapPrescriptionListByPatient>>,
          TError,
          Awaited<ReturnType<typeof cpapPrescriptionListByPatient>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCpapPrescriptionListByPatient<TData = Awaited<ReturnType<typeof cpapPrescriptionListByPatient>>, TError = ProblemResponseResponse>(
 patientId: string,
    params?: CpapPrescriptionListByPatientParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cpapPrescriptionListByPatient>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof cpapPrescriptionListByPatient>>,
          TError,
          Awaited<ReturnType<typeof cpapPrescriptionListByPatient>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCpapPrescriptionListByPatient<TData = Awaited<ReturnType<typeof cpapPrescriptionListByPatient>>, TError = ProblemResponseResponse>(
 patientId: string,
    params?: CpapPrescriptionListByPatientParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cpapPrescriptionListByPatient>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者のCPAP処方指示書一覧を取得する
 */

export function useCpapPrescriptionListByPatient<TData = Awaited<ReturnType<typeof cpapPrescriptionListByPatient>>, TError = ProblemResponseResponse>(
 patientId: string,
    params?: CpapPrescriptionListByPatientParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cpapPrescriptionListByPatient>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCpapPrescriptionListByPatientQueryOptions(patientId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type cpapTreatmentSummaryUpsertResponse200 = {
  data: CpapTreatmentSummary
  status: 200
}

export type cpapTreatmentSummaryUpsertResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type cpapTreatmentSummaryUpsertResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type cpapTreatmentSummaryUpsertResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type cpapTreatmentSummaryUpsertResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type cpapTreatmentSummaryUpsertResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type cpapTreatmentSummaryUpsertResponseSuccess = (cpapTreatmentSummaryUpsertResponse200) & {
  headers: Headers;
};
export type cpapTreatmentSummaryUpsertResponseError = (cpapTreatmentSummaryUpsertResponse400 | cpapTreatmentSummaryUpsertResponse401 | cpapTreatmentSummaryUpsertResponse403 | cpapTreatmentSummaryUpsertResponse422 | cpapTreatmentSummaryUpsertResponse500) & {
  headers: Headers;
};

export type cpapTreatmentSummaryUpsertResponse = (cpapTreatmentSummaryUpsertResponseSuccess | cpapTreatmentSummaryUpsertResponseError)

export const getCpapTreatmentSummaryUpsertUrl = () => {




  return `/cpap-treatment-summaries`
}

/**
 * 対象患者・対象年月の組み合わせで、平均AHI・装着率・平均使用時間を登録する。
 * 同一の対象年月に既存データがある場合は上書き更新する（履歴は保持しない）。
 *
 * RBAC:
 * - 許可: ops-admin, ops-operator のみ
 * @summary CPAP治療実績（期間集計値）を登録・上書き更新する
 */
export const cpapTreatmentSummaryUpsert = async (cpapTreatmentSummaryUpsertRequest: CpapTreatmentSummaryUpsertRequest, options?: Parameters<typeof http>[1]): Promise<cpapTreatmentSummaryUpsertResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<cpapTreatmentSummaryUpsertResponse>(getCpapTreatmentSummaryUpsertUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cpapTreatmentSummaryUpsertRequest)
  }
);}





export const getCpapTreatmentSummaryUpsertMutationKey = () => ['cpapTreatmentSummaryUpsert'] as const;

export const getCpapTreatmentSummaryUpsertMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cpapTreatmentSummaryUpsert>>, TError,CpapTreatmentSummaryUpsertMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof cpapTreatmentSummaryUpsert>>, TError,CpapTreatmentSummaryUpsertMutationVariables, TContext> => {

const mutationKey = getCpapTreatmentSummaryUpsertMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cpapTreatmentSummaryUpsert>>, CpapTreatmentSummaryUpsertMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  cpapTreatmentSummaryUpsert(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CpapTreatmentSummaryUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof cpapTreatmentSummaryUpsert>>>
    export type CpapTreatmentSummaryUpsertMutationBody = CpapTreatmentSummaryUpsertRequest
    export type CpapTreatmentSummaryUpsertMutationError = ProblemResponseResponse
    export type CpapTreatmentSummaryUpsertMutationVariables = {data: CpapTreatmentSummaryUpsertRequest}

    /**
 * @summary CPAP治療実績（期間集計値）を登録・上書き更新する
 */
export const useCpapTreatmentSummaryUpsert = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cpapTreatmentSummaryUpsert>>, TError,CpapTreatmentSummaryUpsertMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cpapTreatmentSummaryUpsert>>,
        TError,
        CpapTreatmentSummaryUpsertMutationVariables,
        TContext
      > => {
      return useMutation(getCpapTreatmentSummaryUpsertMutationOptions(options), queryClient);
    }

export type patientCreateClinicProposalResponse201 = {
  data: ClinicProposalForPatient
  status: 201
}

export type patientCreateClinicProposalResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type patientCreateClinicProposalResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientCreateClinicProposalResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientCreateClinicProposalResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type patientCreateClinicProposalResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientCreateClinicProposalResponseSuccess = (patientCreateClinicProposalResponse201) & {
  headers: Headers;
};
export type patientCreateClinicProposalResponseError = (patientCreateClinicProposalResponse400 | patientCreateClinicProposalResponse401 | patientCreateClinicProposalResponse403 | patientCreateClinicProposalResponse422 | patientCreateClinicProposalResponse500) & {
  headers: Headers;
};

export type patientCreateClinicProposalResponse = (patientCreateClinicProposalResponseSuccess | patientCreateClinicProposalResponseError)

export const getPatientCreateClinicProposalUrl = () => {




  return `/patients/me/clinic-proposals`
}

/**
 * 患者が通える診療所がみつからない場合に、理由を添えてopsへリクエストを送信します。
 * status=waiting_proposal の提案レコードが作成され、opsにタスクが発行されます。
 * @summary 「診療所がみつからない」リクエストを送信する
 */
export const patientCreateClinicProposal = async (clinicProposalRequestCreate: ClinicProposalRequestCreate, options?: Parameters<typeof http>[1]): Promise<patientCreateClinicProposalResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<patientCreateClinicProposalResponse>(getPatientCreateClinicProposalUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(clinicProposalRequestCreate)
  }
);}





export const getPatientCreateClinicProposalMutationKey = () => ['patientCreateClinicProposal'] as const;

export const getPatientCreateClinicProposalMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientCreateClinicProposal>>, TError,PatientCreateClinicProposalMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof patientCreateClinicProposal>>, TError,PatientCreateClinicProposalMutationVariables, TContext> => {

const mutationKey = getPatientCreateClinicProposalMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientCreateClinicProposal>>, PatientCreateClinicProposalMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  patientCreateClinicProposal(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientCreateClinicProposalMutationResult = NonNullable<Awaited<ReturnType<typeof patientCreateClinicProposal>>>
    export type PatientCreateClinicProposalMutationBody = ClinicProposalRequestCreate
    export type PatientCreateClinicProposalMutationError = ProblemResponseResponse
    export type PatientCreateClinicProposalMutationVariables = {data: ClinicProposalRequestCreate}

    /**
 * @summary 「診療所がみつからない」リクエストを送信する
 */
export const usePatientCreateClinicProposal = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientCreateClinicProposal>>, TError,PatientCreateClinicProposalMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientCreateClinicProposal>>,
        TError,
        PatientCreateClinicProposalMutationVariables,
        TContext
      > => {
      return useMutation(getPatientCreateClinicProposalMutationOptions(options), queryClient);
    }

export type patientGetLatestPendingClinicProposalResponse200 = {
  data: ClinicProposalForPatient
  status: 200
}

export type patientGetLatestPendingClinicProposalResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientGetLatestPendingClinicProposalResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientGetLatestPendingClinicProposalResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientGetLatestPendingClinicProposalResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientGetLatestPendingClinicProposalResponseSuccess = (patientGetLatestPendingClinicProposalResponse200) & {
  headers: Headers;
};
export type patientGetLatestPendingClinicProposalResponseError = (patientGetLatestPendingClinicProposalResponse401 | patientGetLatestPendingClinicProposalResponse403 | patientGetLatestPendingClinicProposalResponse404 | patientGetLatestPendingClinicProposalResponse500) & {
  headers: Headers;
};

export type patientGetLatestPendingClinicProposalResponse = (patientGetLatestPendingClinicProposalResponseSuccess | patientGetLatestPendingClinicProposalResponseError)

export const getPatientGetLatestPendingClinicProposalUrl = () => {




  return `/patients/me/clinic-proposals/latest-pending`
}

/**
 * 患者の最新のpending状態の医療機関提案を取得します。
 * タスクから提案画面に遷移する際にproposalIdを事前に知らなくても利用できます。
 * @summary 最新のpending提案を取得する
 */
export const patientGetLatestPendingClinicProposal = async ( options?: Parameters<typeof http>[1]): Promise<patientGetLatestPendingClinicProposalResponse> => {

  return http<patientGetLatestPendingClinicProposalResponse>(getPatientGetLatestPendingClinicProposalUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPatientGetLatestPendingClinicProposalQueryKey = () => {
    return [
    `/patients/me/clinic-proposals/latest-pending`
    ] as const;
    }


export const getPatientGetLatestPendingClinicProposalQueryOptions = <TData = Awaited<ReturnType<typeof patientGetLatestPendingClinicProposal>>, TError = ProblemResponseResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetLatestPendingClinicProposal>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientGetLatestPendingClinicProposalQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientGetLatestPendingClinicProposal>>> = ({ signal }) => patientGetLatestPendingClinicProposal({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientGetLatestPendingClinicProposal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientGetLatestPendingClinicProposalQueryResult = NonNullable<Awaited<ReturnType<typeof patientGetLatestPendingClinicProposal>>>
export type PatientGetLatestPendingClinicProposalQueryError = ProblemResponseResponse


export function usePatientGetLatestPendingClinicProposal<TData = Awaited<ReturnType<typeof patientGetLatestPendingClinicProposal>>, TError = ProblemResponseResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetLatestPendingClinicProposal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetLatestPendingClinicProposal>>,
          TError,
          Awaited<ReturnType<typeof patientGetLatestPendingClinicProposal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetLatestPendingClinicProposal<TData = Awaited<ReturnType<typeof patientGetLatestPendingClinicProposal>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetLatestPendingClinicProposal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetLatestPendingClinicProposal>>,
          TError,
          Awaited<ReturnType<typeof patientGetLatestPendingClinicProposal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetLatestPendingClinicProposal<TData = Awaited<ReturnType<typeof patientGetLatestPendingClinicProposal>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetLatestPendingClinicProposal>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 最新のpending提案を取得する
 */

export function usePatientGetLatestPendingClinicProposal<TData = Awaited<ReturnType<typeof patientGetLatestPendingClinicProposal>>, TError = ProblemResponseResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetLatestPendingClinicProposal>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientGetLatestPendingClinicProposalQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type patientGetClinicProposalDetailResponse200 = {
  data: ClinicProposalForPatient
  status: 200
}

export type patientGetClinicProposalDetailResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientGetClinicProposalDetailResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientGetClinicProposalDetailResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientGetClinicProposalDetailResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientGetClinicProposalDetailResponseSuccess = (patientGetClinicProposalDetailResponse200) & {
  headers: Headers;
};
export type patientGetClinicProposalDetailResponseError = (patientGetClinicProposalDetailResponse401 | patientGetClinicProposalDetailResponse403 | patientGetClinicProposalDetailResponse404 | patientGetClinicProposalDetailResponse500) & {
  headers: Headers;
};

export type patientGetClinicProposalDetailResponse = (patientGetClinicProposalDetailResponseSuccess | patientGetClinicProposalDetailResponseError)

export const getPatientGetClinicProposalDetailUrl = (proposalId: string,) => {




  return `/patients/me/clinic-proposals/${proposalId}`
}

/**
 * 指定されたproposalIdの医療機関提案詳細を取得します。
 * 患者本人かつ自身宛ての提案のみ取得可能です。
 * @summary 提案詳細を取得する
 */
export const patientGetClinicProposalDetail = async (proposalId: string, options?: Parameters<typeof http>[1]): Promise<patientGetClinicProposalDetailResponse> => {

  return http<patientGetClinicProposalDetailResponse>(getPatientGetClinicProposalDetailUrl(proposalId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPatientGetClinicProposalDetailQueryKey = (proposalId: string,) => {
    return [
    `/patients/me/clinic-proposals/${proposalId}`
    ] as const;
    }


export const getPatientGetClinicProposalDetailQueryOptions = <TData = Awaited<ReturnType<typeof patientGetClinicProposalDetail>>, TError = ProblemResponseResponse>(proposalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetClinicProposalDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientGetClinicProposalDetailQueryKey(proposalId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientGetClinicProposalDetail>>> = ({ signal }) => patientGetClinicProposalDetail(proposalId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: proposalId !== null && proposalId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientGetClinicProposalDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientGetClinicProposalDetailQueryResult = NonNullable<Awaited<ReturnType<typeof patientGetClinicProposalDetail>>>
export type PatientGetClinicProposalDetailQueryError = ProblemResponseResponse


export function usePatientGetClinicProposalDetail<TData = Awaited<ReturnType<typeof patientGetClinicProposalDetail>>, TError = ProblemResponseResponse>(
 proposalId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetClinicProposalDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetClinicProposalDetail>>,
          TError,
          Awaited<ReturnType<typeof patientGetClinicProposalDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetClinicProposalDetail<TData = Awaited<ReturnType<typeof patientGetClinicProposalDetail>>, TError = ProblemResponseResponse>(
 proposalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetClinicProposalDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientGetClinicProposalDetail>>,
          TError,
          Awaited<ReturnType<typeof patientGetClinicProposalDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientGetClinicProposalDetail<TData = Awaited<ReturnType<typeof patientGetClinicProposalDetail>>, TError = ProblemResponseResponse>(
 proposalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetClinicProposalDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 提案詳細を取得する
 */

export function usePatientGetClinicProposalDetail<TData = Awaited<ReturnType<typeof patientGetClinicProposalDetail>>, TError = ProblemResponseResponse>(
 proposalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientGetClinicProposalDetail>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientGetClinicProposalDetailQueryOptions(proposalId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type patientAcceptClinicProposalResponse201 = {
  data: ReferralRequest
  status: 201
}

export type patientAcceptClinicProposalResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientAcceptClinicProposalResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientAcceptClinicProposalResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientAcceptClinicProposalResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type patientAcceptClinicProposalResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientAcceptClinicProposalResponseSuccess = (patientAcceptClinicProposalResponse201) & {
  headers: Headers;
};
export type patientAcceptClinicProposalResponseError = (patientAcceptClinicProposalResponse401 | patientAcceptClinicProposalResponse403 | patientAcceptClinicProposalResponse404 | patientAcceptClinicProposalResponse409 | patientAcceptClinicProposalResponse500) & {
  headers: Headers;
};

export type patientAcceptClinicProposalResponse = (patientAcceptClinicProposalResponseSuccess | patientAcceptClinicProposalResponseError)

export const getPatientAcceptClinicProposalUrl = (proposalId: string,) => {




  return `/patients/me/clinic-proposals/${proposalId}/accept`
}

/**
 * 提案された医療機関を承認し、紹介状依頼を作成します。
 * 患者本人かつ自身宛てのpending提案のみ承認可能です。
 * @summary 医療機関提案を承認する
 */
export const patientAcceptClinicProposal = async (proposalId: string, options?: Parameters<typeof http>[1]): Promise<patientAcceptClinicProposalResponse> => {

  return http<patientAcceptClinicProposalResponse>(getPatientAcceptClinicProposalUrl(proposalId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPatientAcceptClinicProposalMutationKey = () => ['patientAcceptClinicProposal'] as const;

export const getPatientAcceptClinicProposalMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientAcceptClinicProposal>>, TError,PatientAcceptClinicProposalMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof patientAcceptClinicProposal>>, TError,PatientAcceptClinicProposalMutationVariables, TContext> => {

const mutationKey = getPatientAcceptClinicProposalMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientAcceptClinicProposal>>, PatientAcceptClinicProposalMutationVariables> = (props) => {
          const {proposalId} = props ?? {};

          return  patientAcceptClinicProposal(proposalId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientAcceptClinicProposalMutationResult = NonNullable<Awaited<ReturnType<typeof patientAcceptClinicProposal>>>

    export type PatientAcceptClinicProposalMutationError = ProblemResponseResponse
    export type PatientAcceptClinicProposalMutationVariables = {proposalId: string}

    /**
 * @summary 医療機関提案を承認する
 */
export const usePatientAcceptClinicProposal = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientAcceptClinicProposal>>, TError,PatientAcceptClinicProposalMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientAcceptClinicProposal>>,
        TError,
        PatientAcceptClinicProposalMutationVariables,
        TContext
      > => {
      return useMutation(getPatientAcceptClinicProposalMutationOptions(options), queryClient);
    }

export type patientRejectClinicProposalResponse200 = {
  data: ClinicProposalForPatient
  status: 200
}

export type patientRejectClinicProposalResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type patientRejectClinicProposalResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type patientRejectClinicProposalResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type patientRejectClinicProposalResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type patientRejectClinicProposalResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type patientRejectClinicProposalResponseSuccess = (patientRejectClinicProposalResponse200) & {
  headers: Headers;
};
export type patientRejectClinicProposalResponseError = (patientRejectClinicProposalResponse401 | patientRejectClinicProposalResponse403 | patientRejectClinicProposalResponse404 | patientRejectClinicProposalResponse409 | patientRejectClinicProposalResponse500) & {
  headers: Headers;
};

export type patientRejectClinicProposalResponse = (patientRejectClinicProposalResponseSuccess | patientRejectClinicProposalResponseError)

export const getPatientRejectClinicProposalUrl = (proposalId: string,) => {




  return `/patients/me/clinic-proposals/${proposalId}/reject`
}

/**
 * 提案された医療機関を拒否します。
 * 患者本人かつ自身宛てのpending提案のみ拒否可能です。
 * 拒否後、患者は理由選択画面に戻り再度フローを開始できます。
 * @summary 医療機関提案を拒否する
 */
export const patientRejectClinicProposal = async (proposalId: string, options?: Parameters<typeof http>[1]): Promise<patientRejectClinicProposalResponse> => {

  return http<patientRejectClinicProposalResponse>(getPatientRejectClinicProposalUrl(proposalId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPatientRejectClinicProposalMutationKey = () => ['patientRejectClinicProposal'] as const;

export const getPatientRejectClinicProposalMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientRejectClinicProposal>>, TError,PatientRejectClinicProposalMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof patientRejectClinicProposal>>, TError,PatientRejectClinicProposalMutationVariables, TContext> => {

const mutationKey = getPatientRejectClinicProposalMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientRejectClinicProposal>>, PatientRejectClinicProposalMutationVariables> = (props) => {
          const {proposalId} = props ?? {};

          return  patientRejectClinicProposal(proposalId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientRejectClinicProposalMutationResult = NonNullable<Awaited<ReturnType<typeof patientRejectClinicProposal>>>

    export type PatientRejectClinicProposalMutationError = ProblemResponseResponse
    export type PatientRejectClinicProposalMutationVariables = {proposalId: string}

    /**
 * @summary 医療機関提案を拒否する
 */
export const usePatientRejectClinicProposal = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientRejectClinicProposal>>, TError,PatientRejectClinicProposalMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientRejectClinicProposal>>,
        TError,
        PatientRejectClinicProposalMutationVariables,
        TContext
      > => {
      return useMutation(getPatientRejectClinicProposalMutationOptions(options), queryClient);
    }

export type opsGetLatestWaitingClinicProposalResponse200 = {
  data: ClinicProposal
  status: 200
}

export type opsGetLatestWaitingClinicProposalResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type opsGetLatestWaitingClinicProposalResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type opsGetLatestWaitingClinicProposalResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type opsGetLatestWaitingClinicProposalResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type opsGetLatestWaitingClinicProposalResponseSuccess = (opsGetLatestWaitingClinicProposalResponse200) & {
  headers: Headers;
};
export type opsGetLatestWaitingClinicProposalResponseError = (opsGetLatestWaitingClinicProposalResponse401 | opsGetLatestWaitingClinicProposalResponse403 | opsGetLatestWaitingClinicProposalResponse404 | opsGetLatestWaitingClinicProposalResponse500) & {
  headers: Headers;
};

export type opsGetLatestWaitingClinicProposalResponse = (opsGetLatestWaitingClinicProposalResponseSuccess | opsGetLatestWaitingClinicProposalResponseError)

export const getOpsGetLatestWaitingClinicProposalUrl = (patientId: string,) => {




  return `/patients/${patientId}/clinic-proposals/latest-waiting`
}

/**
 * 指定患者の最新のwaiting_proposal状態の医療機関提案を取得します。
 * ops画面で提案入力フォームの表示判定とproposalIdの取得に使用します。
 * @summary 患者の最新waiting_proposal提案を取得する
 */
export const opsGetLatestWaitingClinicProposal = async (patientId: string, options?: Parameters<typeof http>[1]): Promise<opsGetLatestWaitingClinicProposalResponse> => {

  return http<opsGetLatestWaitingClinicProposalResponse>(getOpsGetLatestWaitingClinicProposalUrl(patientId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOpsGetLatestWaitingClinicProposalQueryKey = (patientId: string,) => {
    return [
    `/patients/${patientId}/clinic-proposals/latest-waiting`
    ] as const;
    }


export const getOpsGetLatestWaitingClinicProposalQueryOptions = <TData = Awaited<ReturnType<typeof opsGetLatestWaitingClinicProposal>>, TError = ProblemResponseResponse>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof opsGetLatestWaitingClinicProposal>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOpsGetLatestWaitingClinicProposalQueryKey(patientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof opsGetLatestWaitingClinicProposal>>> = ({ signal }) => opsGetLatestWaitingClinicProposal(patientId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: patientId !== null && patientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof opsGetLatestWaitingClinicProposal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OpsGetLatestWaitingClinicProposalQueryResult = NonNullable<Awaited<ReturnType<typeof opsGetLatestWaitingClinicProposal>>>
export type OpsGetLatestWaitingClinicProposalQueryError = ProblemResponseResponse


export function useOpsGetLatestWaitingClinicProposal<TData = Awaited<ReturnType<typeof opsGetLatestWaitingClinicProposal>>, TError = ProblemResponseResponse>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof opsGetLatestWaitingClinicProposal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof opsGetLatestWaitingClinicProposal>>,
          TError,
          Awaited<ReturnType<typeof opsGetLatestWaitingClinicProposal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpsGetLatestWaitingClinicProposal<TData = Awaited<ReturnType<typeof opsGetLatestWaitingClinicProposal>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof opsGetLatestWaitingClinicProposal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof opsGetLatestWaitingClinicProposal>>,
          TError,
          Awaited<ReturnType<typeof opsGetLatestWaitingClinicProposal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpsGetLatestWaitingClinicProposal<TData = Awaited<ReturnType<typeof opsGetLatestWaitingClinicProposal>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof opsGetLatestWaitingClinicProposal>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者の最新waiting_proposal提案を取得する
 */

export function useOpsGetLatestWaitingClinicProposal<TData = Awaited<ReturnType<typeof opsGetLatestWaitingClinicProposal>>, TError = ProblemResponseResponse>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof opsGetLatestWaitingClinicProposal>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOpsGetLatestWaitingClinicProposalQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type opsProposeClinicsForPatientResponse200 = {
  data: ClinicProposal
  status: 200
}

export type opsProposeClinicsForPatientResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type opsProposeClinicsForPatientResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type opsProposeClinicsForPatientResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type opsProposeClinicsForPatientResponse404 = {
  data: ProblemResponseResponse
  status: 404
}

export type opsProposeClinicsForPatientResponse409 = {
  data: ProblemResponseResponse
  status: 409
}

export type opsProposeClinicsForPatientResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type opsProposeClinicsForPatientResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type opsProposeClinicsForPatientResponseSuccess = (opsProposeClinicsForPatientResponse200) & {
  headers: Headers;
};
export type opsProposeClinicsForPatientResponseError = (opsProposeClinicsForPatientResponse400 | opsProposeClinicsForPatientResponse401 | opsProposeClinicsForPatientResponse403 | opsProposeClinicsForPatientResponse404 | opsProposeClinicsForPatientResponse409 | opsProposeClinicsForPatientResponse422 | opsProposeClinicsForPatientResponse500) & {
  headers: Headers;
};

export type opsProposeClinicsForPatientResponse = (opsProposeClinicsForPatientResponseSuccess | opsProposeClinicsForPatientResponseError)

export const getOpsProposeClinicsForPatientUrl = (patientId: string,
    proposalId: string,) => {




  return `/patients/${patientId}/clinic-proposals/${proposalId}/propose`
}

/**
 * waiting_proposal状態の提案にクリニック情報を入力し、患者に提案します。
 * 新規クリニックを登録するか、既存の管理外クリニックを選択できます。
 * @summary 患者にクリニックを提案する
 */
export const opsProposeClinicsForPatient = async (patientId: string,
    proposalId: string,
    clinicProposalProposeRequest: ClinicProposalProposeRequest, options?: Parameters<typeof http>[1]): Promise<opsProposeClinicsForPatientResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<opsProposeClinicsForPatientResponse>(getOpsProposeClinicsForPatientUrl(patientId,proposalId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(clinicProposalProposeRequest)
  }
);}





export const getOpsProposeClinicsForPatientMutationKey = () => ['opsProposeClinicsForPatient'] as const;

export const getOpsProposeClinicsForPatientMutationOptions = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof opsProposeClinicsForPatient>>, TError,OpsProposeClinicsForPatientMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof opsProposeClinicsForPatient>>, TError,OpsProposeClinicsForPatientMutationVariables, TContext> => {

const mutationKey = getOpsProposeClinicsForPatientMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof opsProposeClinicsForPatient>>, OpsProposeClinicsForPatientMutationVariables> = (props) => {
          const {patientId,proposalId,data} = props ?? {};

          return  opsProposeClinicsForPatient(patientId,proposalId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpsProposeClinicsForPatientMutationResult = NonNullable<Awaited<ReturnType<typeof opsProposeClinicsForPatient>>>
    export type OpsProposeClinicsForPatientMutationBody = ClinicProposalProposeRequest
    export type OpsProposeClinicsForPatientMutationError = ProblemResponseResponse
    export type OpsProposeClinicsForPatientMutationVariables = {patientId: string;proposalId: string;data: ClinicProposalProposeRequest}

    /**
 * @summary 患者にクリニックを提案する
 */
export const useOpsProposeClinicsForPatient = <TError = ProblemResponseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof opsProposeClinicsForPatient>>, TError,OpsProposeClinicsForPatientMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof opsProposeClinicsForPatient>>,
        TError,
        OpsProposeClinicsForPatientMutationVariables,
        TContext
      > => {
      return useMutation(getOpsProposeClinicsForPatientMutationOptions(options), queryClient);
    }

export type getExternalClinicsResponse200 = {
  data: ExternalClinicListResponse
  status: 200
}

export type getExternalClinicsResponse401 = {
  data: ProblemResponseResponse
  status: 401
}

export type getExternalClinicsResponse403 = {
  data: ProblemResponseResponse
  status: 403
}

export type getExternalClinicsResponse500 = {
  data: ProblemResponseResponse
  status: 500
}

export type getExternalClinicsResponseSuccess = (getExternalClinicsResponse200) & {
  headers: Headers;
};
export type getExternalClinicsResponseError = (getExternalClinicsResponse401 | getExternalClinicsResponse403 | getExternalClinicsResponse500) & {
  headers: Headers;
};

export type getExternalClinicsResponse = (getExternalClinicsResponseSuccess | getExternalClinicsResponseError)

export const getGetExternalClinicsUrl = (params?: GetExternalClinicsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/external-clinics?${stringifiedParams}` : `/external-clinics`
}

/**
 * 登録済みの管理外クリニック一覧を取得します。
 * ops提案画面のプルダウン選択に使用します。
 * @summary 管理外クリニック一覧を取得する
 */
export const getExternalClinics = async (params?: GetExternalClinicsParams, options?: Parameters<typeof http>[1]): Promise<getExternalClinicsResponse> => {

  return http<getExternalClinicsResponse>(getGetExternalClinicsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExternalClinicsQueryKey = (params?: GetExternalClinicsParams,) => {
    return [
    `/external-clinics`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetExternalClinicsQueryOptions = <TData = Awaited<ReturnType<typeof getExternalClinics>>, TError = ProblemResponseResponse>(params?: GetExternalClinicsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalClinics>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExternalClinicsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExternalClinics>>> = ({ signal }) => getExternalClinics(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExternalClinics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExternalClinicsQueryResult = NonNullable<Awaited<ReturnType<typeof getExternalClinics>>>
export type GetExternalClinicsQueryError = ProblemResponseResponse


export function useGetExternalClinics<TData = Awaited<ReturnType<typeof getExternalClinics>>, TError = ProblemResponseResponse>(
 params: undefined |  GetExternalClinicsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalClinics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExternalClinics>>,
          TError,
          Awaited<ReturnType<typeof getExternalClinics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExternalClinics<TData = Awaited<ReturnType<typeof getExternalClinics>>, TError = ProblemResponseResponse>(
 params?: GetExternalClinicsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalClinics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExternalClinics>>,
          TError,
          Awaited<ReturnType<typeof getExternalClinics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExternalClinics<TData = Awaited<ReturnType<typeof getExternalClinics>>, TError = ProblemResponseResponse>(
 params?: GetExternalClinicsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalClinics>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 管理外クリニック一覧を取得する
 */

export function useGetExternalClinics<TData = Awaited<ReturnType<typeof getExternalClinics>>, TError = ProblemResponseResponse>(
 params?: GetExternalClinicsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalClinics>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExternalClinicsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type smsHandleCpaasDeliveryReportResponse200 = {
  data: SmsHandleCpaasDeliveryReport200
  status: 200
}

export type smsHandleCpaasDeliveryReportResponse400 = {
  data: ProblemResponseResponse
  status: 400
}

export type smsHandleCpaasDeliveryReportResponse413 = {
  data: void
  status: 413
}

export type smsHandleCpaasDeliveryReportResponse422 = {
  data: ProblemResponseResponse
  status: 422
}

export type smsHandleCpaasDeliveryReportResponseSuccess = (smsHandleCpaasDeliveryReportResponse200) & {
  headers: Headers;
};
export type smsHandleCpaasDeliveryReportResponseError = (smsHandleCpaasDeliveryReportResponse400 | smsHandleCpaasDeliveryReportResponse413 | smsHandleCpaasDeliveryReportResponse422) & {
  headers: Headers;
};

export type smsHandleCpaasDeliveryReportResponse = (smsHandleCpaasDeliveryReportResponseSuccess | smsHandleCpaasDeliveryReportResponseError)

export const getSmsHandleCpaasDeliveryReportUrl = () => {




  return `/sms/callbacks/cpaas`
}

/**
 * NTT CPaaSからのSMS配信レポートを受信して`app.sms_deliveries`へ反映します。
 * リクエスト単位の認証はありません。照合は`results`の要素ごとに行い、
 * 送信時に`webhooks.callbackData`へ載せた照合用トークン（`sms_deliveries.callback_token`、行ごとのUUID）と
 * `messageId`（`sms_deliveries.id`）の両方が一致する行だけを更新します。
 * どちらかが欠落・形式不正・不一致なら、その要素は無視して件数だけ数えます
 * （「行がない」「トークンが違う」「すでに確定済み」は区別しません）。
 * 整形式のJSONであれば、個々のレポートの適用可否によらず常に200を返します
 * （2xx以外を返すとCPaaS側が最大20回・約41.5時間にわたり再送します）。
 * リクエストボディには上限（`app.sms.webhook.max-body-bytes`、既定1MB）があり、
 * 超えた場合はボディを読む前に413を返します。
 * また`results`の要素数には1リクエストあたり1000件の上限があり、
 * 超えた分は処理せず`ignored`にだけ数えます（実測前提は1リクエスト最大数百件）。
 * 整形式でないJSONは400、空ボディ（0バイト）はリクエストボディ必須の検証で422になります。
 * いずれもproblem+jsonで返します。
 * @summary SMS配信レポートを受信する
 */
export const smsHandleCpaasDeliveryReport = async (smsDeliveryReportRequest: SmsDeliveryReportRequest, options?: Parameters<typeof http>[1]): Promise<smsHandleCpaasDeliveryReportResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return http<smsHandleCpaasDeliveryReportResponse>(getSmsHandleCpaasDeliveryReportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(smsDeliveryReportRequest)
  }
);}





export const getSmsHandleCpaasDeliveryReportMutationKey = () => ['smsHandleCpaasDeliveryReport'] as const;

export const getSmsHandleCpaasDeliveryReportMutationOptions = <TError = ProblemResponseResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof smsHandleCpaasDeliveryReport>>, TError,SmsHandleCpaasDeliveryReportMutationVariables, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof smsHandleCpaasDeliveryReport>>, TError,SmsHandleCpaasDeliveryReportMutationVariables, TContext> => {

const mutationKey = getSmsHandleCpaasDeliveryReportMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof smsHandleCpaasDeliveryReport>>, SmsHandleCpaasDeliveryReportMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  smsHandleCpaasDeliveryReport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SmsHandleCpaasDeliveryReportMutationResult = NonNullable<Awaited<ReturnType<typeof smsHandleCpaasDeliveryReport>>>
    export type SmsHandleCpaasDeliveryReportMutationBody = SmsDeliveryReportRequest
    export type SmsHandleCpaasDeliveryReportMutationError = ProblemResponseResponse | void
    export type SmsHandleCpaasDeliveryReportMutationVariables = {data: SmsDeliveryReportRequest}

    /**
 * @summary SMS配信レポートを受信する
 */
export const useSmsHandleCpaasDeliveryReport = <TError = ProblemResponseResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof smsHandleCpaasDeliveryReport>>, TError,SmsHandleCpaasDeliveryReportMutationVariables, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof smsHandleCpaasDeliveryReport>>,
        TError,
        SmsHandleCpaasDeliveryReportMutationVariables,
        TContext
      > => {
      return useMutation(getSmsHandleCpaasDeliveryReportMutationOptions(options), queryClient);
    }

